webpackJsonp([0],{

/***/ "+8F3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mercer',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "0T80":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0e2X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Biscuit_vue__ = __webpack_require__("WMUf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b231c13e_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Biscuit_vue__ = __webpack_require__("IbzO");
function injectStyle (ssrContext) {
  __webpack_require__("I9NK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b231c13e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Biscuit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b231c13e_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Biscuit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0xWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("The CST scheduler app is designed for the RBI customer service team to manage vehicle inspectors' schedules efficiently. So far, the customer service team has been using multiple softwares, and doing a lot of repeated tasks to manage inspectors' schedules. \n  "),_c('br'),_c('br'),_vm._v("We interviewed customer service team crews several times during the process and also shared the progress with them to make the tool as optimised for their processes as possible.")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Daily view")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Daily view - job summary")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-03.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Weekly view")]),_vm._v(" "),_c('div',{staticClass:"cols col-2"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-04.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-05.png',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Workforce filtering")]),_vm._v(" "),_c('p',[_vm._v("The app is designed to be a SPA (single page application) so there's no page loading during the process, and every item of data is real-time. I tried to avoid the use of modal window UI unless it was completely necessary. Instead of modal windows, the side panel area is actively used to show information based on context.")]),_vm._v(" "),_c('div',{staticClass:"cols col-2"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-06.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-07.png',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Inspector view")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-08.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Inspector view - sub sections")]),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-m-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-m-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-m-03.png',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Inspector view - mobile")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-interactions.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Interaction states")]),_vm._v(" "),_c('p',[_vm._v("Design systems methodology has been actively used in this project. The app has many repeated UIs, which means making small changes will be increasingly difficult. To prevent this and make maintaining it efficient, I made every UI element as a Sketch symbol, which can be translated to components when it's in the development phase.")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-system-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Sketch symbols")]),_vm._v(" "),_c('p',[_vm._v("Luckily, Zeplin has started supporting design components recently. With this feature, I could easily organize design components down to atom level (based on Atomic Design by Brad Frost).")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-system-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Design components on Zeplin")]),_vm._v(" "),_c('div',{staticClass:"cols col-2-row-3"},[_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-wf-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-wf-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-wf-03.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-wf-04.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-wf-05.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-rbi-scheduler-wf-06.png',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Early stage wireframes")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Awh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1aee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('project-header',{attrs:{"bgColor":_vm.projectData.projectColor}},[_c('h2',{ref:"projectTitle",attrs:{"slot":"projectTitle"},slot:"projectTitle"},[_vm._v(_vm._s(_vm.projectData.subject))]),_vm._v(" "),_c('i',{attrs:{"slot":"year"},slot:"year"},[_vm._v(_vm._s(_vm.projectData.year))]),_vm._v(" "),_c('i',{attrs:{"slot":"team"},slot:"team"},[_vm._v(_vm._s(_vm.projectData.team))]),_vm._v(" "),_c('i',{attrs:{"slot":"participation"},slot:"participation"},[_vm._v(_vm._s(_vm.projectData.participation))])]),_vm._v(" "),_c('project-body',[_vm._t("default")],2),_vm._v(" "),_c('project-footer',{attrs:{"nextSlug":_vm.nextProjectData.slug,"nextBgColor":_vm.nextProjectData.projectColor}},[_c('i',{attrs:{"slot":"projectTitle"},slot:"projectTitle"},[_vm._v(_vm._s(_vm.projectData.subject))]),_vm._v(" "),_c('i',{attrs:{"slot":"year"},slot:"year"},[_vm._v(_vm._s(_vm.projectData.year))]),_vm._v(" "),_c('i',{attrs:{"slot":"team"},slot:"team"},[_vm._v(_vm._s(_vm.projectData.team))]),_vm._v(" "),_c('i',{attrs:{"slot":"participation"},slot:"participation"},[_vm._v(_vm._s(_vm.projectData.participation))]),_vm._v(" "),_c('h2',{attrs:{"slot":"nextProject"},slot:"nextProject"},[_vm._v(_vm._s(_vm.nextProjectData.subject))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "25Mm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Collision_vue__ = __webpack_require__("Yivk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f7b88a_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Collision_vue__ = __webpack_require__("wdOw");
function injectStyle (ssrContext) {
  __webpack_require__("KMdB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56f7b88a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Collision_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f7b88a_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Collision_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ZmN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('article',[_c('site-title',{attrs:{"text":'About Jason'}}),_vm._v(" "),_c('img',{ref:"profileImg",staticClass:"avatar",attrs:{"src":"/static/image/jason-profile.jpg","alt":"Jason Jun"}}),_vm._v(" "),_c('div',{ref:"introCopy"},[_c('p',[_vm._v("Hello, I'm Jason Jun, a UI designer and front-end developer based in Melbourne, Australia.")]),_vm._v(" "),_c('p',[_vm._v("I’ve been working in the digital design and development field since 2009, and moved from South Korea to Australia at the end of 2012 to study for a masters degree in Interactive and Digital Media at the University of Sydney.")]),_vm._v(" "),_c('p',[_vm._v("Upon finishing my degree, I moved to Melbourne, and have been working as a UI designer and front-end developer at a number of companies. Currently I'm working at Envato.")]),_vm._v(" "),_c('p',[_vm._v("Thanks for stopping by.")])]),_vm._v(" "),_c('ul',{ref:"links",staticClass:"links"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.links),function(link){return _c('li',{key:link.type},[_c('i',[_vm._v(_vm._s(link.label))]),_c('a',{attrs:{"href":link.url,"target":"_blank"}},[_vm._v(_vm._s(link.url))])])})],2)],1),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('i',[_vm._v("Email")]),_c('u',[_vm._v("uxd.jun@gmail.com")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2iSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RbiReport_vue__ = __webpack_require__("xRSM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81ff59c8_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RbiReport_vue__ = __webpack_require__("Ufvi");
function injectStyle (ssrContext) {
  __webpack_require__("RKkW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81ff59c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RbiReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81ff59c8_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RbiReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "30DY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3JwC":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 466.6 142.1\"><path d=\"M466.1 88c0 29.9-24.2 54.1-54.1 54.1H54.2C24.3 142.1.1 117.9.1 88V54.6C.1 24.7 24.3.5 54.2.5H412c29.9 0 54.1 24.2 54.1 54.1V88zm-11.6-32.8c0-23.2-18.8-42.1-42.1-42.1H54.8c-23.2 0-42.1 18.8-42.1 42.1v33.2c0 23.2 18.8 42.1 42.1 42.1h357.6c23.2 0 42.1-18.8 42.1-42.1V55.2z\" class=\"__3mmDUGI__st0 \"></path><path d=\"M281.5 101.5c-.6 0-1-.4-1-1V97h-.1c-2.3 3.3-6.7 5.5-13.4 5.5-8.7 0-16-4.5-16-14.5 0-10.4 7.3-15.1 19-15.1h9.7c.4 0 .6-.2.6-.6V70c0-5.4-2.6-7.9-10.6-7.9-5.3 0-8.6 1.5-10.8 3.3-.5.4-1.1.3-1.4-.2l-3.6-6.5c-.3-.5-.2-1 .2-1.3 3.8-2.8 9.1-4.6 16.9-4.6 14.5 0 19.8 4.9 19.8 16.6v31.1c0 .6-.4 1-1 1h-8.3zm-1.2-16v-3.6c0-.4-.2-.6-.6-.6h-7.9c-7.1 0-10.3 2-10.3 6.4 0 3.9 2.9 5.9 8.2 5.9 6.8 0 10.6-2.7 10.6-8.1zm32.6 11.4l-.1 3.5c0 .6-.4 1-1 1h-9.1c-.6 0-1-.4-1-1V40.3c0-.6.4-1 1-1h9.1c.6 0 1 .4 1 1v18.2h.1c2.3-3.3 6.2-5.6 12.6-5.6 8.1 0 14 3.8 16.5 11.4 1.2 3.6 1.7 7 1.7 13.4s-.5 9.8-1.7 13.4c-2.5 7.6-8.4 11.4-16.5 11.4-6.4 0-10.3-2.3-12.6-5.6zm18.6-10.3c.7-2.2 1-4.5 1-8.9 0-4.3-.3-6.7-1-8.9-1.3-3.9-4.3-6.1-8.8-6.1s-7.6 2.2-8.9 6.1c-.7 2.2-1 4.5-1 8.9 0 4.3.3 6.7 1 8.9 1.3 3.9 4.3 6.1 8.9 6.1 4.4 0 7.5-2.2 8.8-6.1zm33.9 15.4c-9.3 0-13-4.4-13-13.6V40.3c0-.6.4-1 1-1h9.1c.6 0 1 .4 1 1v47.5c0 3.3 1.3 4.3 4.1 4.3h2.2c.6 0 1 .4 1 1v7.9c0 .6-.4 1-1 1h-4.4zm12-12.7c-1-3.1-1.7-6.7-1.7-11.6s.6-8.7 1.6-11.7c2.7-8.3 10-13.1 19.4-13.1 9.8 0 16.9 5 19.5 13.1 1.1 3.4 1.6 6.6 1.6 14.3 0 .6-.4 1-1.1 1h-29.3c-.4 0-.6.2-.6.6 0 1.4.3 2.6.7 3.6 1.6 4.6 5.3 7.2 10.7 7.2 5.3 0 8.8-2 11.1-4.5.5-.5 1-.6 1.5-.2l5.8 5.1c.5.4.5.9.1 1.4-4 4.7-10.7 8.1-19.5 8.1-10-.1-17.1-5-19.8-13.3zm28.7-21c-1.3-3.8-4.8-6.1-9.3-6.1s-8.1 2.3-9.4 6.1c-.4 1.2-.6 2.4-.6 4 0 .4.2.6.6.6h18.7c.4 0 .6-.2.6-.6 0-1.6-.2-2.8-.6-4zm-358.2-28c0-.6.4-1 1-1H58c.6 0 1 .4 1 1v13c0 .4.2.6.6.6h6.3c.6 0 1 .4 1 1v6.6c0 .6-.4 1-1 1h-6.3c-.4 0-.6.2-.6.6v24.7c0 3.4 1.4 4.4 4.4 4.4h2.5c.6 0 1 .4 1 1v7.9c0 .6-.4 1-1 1h-4.8c-9.6 0-13.2-4.6-13.2-13.9V40.3zm27.1 49c-1-3.1-1.7-6.7-1.7-11.6s.6-8.7 1.6-11.7c2.7-8.3 10-13.1 19.4-13.1 9.8 0 16.9 5 19.5 13.1 1.1 3.4 1.6 6.6 1.6 14.3 0 .6-.4 1-1.1 1H85.1c-.4 0-.6.2-.6.6 0 1.4.3 2.6.7 3.6 1.6 4.6 5.3 7.2 10.6 7.2s8.8-2 11.1-4.5c.5-.5 1-.6 1.5-.2l5.8 5.1c.5.4.5.9.1 1.4-4 4.7-10.8 8.1-19.5 8.1-10-.1-17.1-5-19.8-13.3zm28.7-21c-1.3-3.8-4.8-6.1-9.3-6.1s-8.1 2.3-9.4 6.1c-.4 1.2-.6 2.4-.6 4 0 .4.2.6.6.6h18.6c.4 0 .6-.2.6-.6.1-1.6-.1-2.8-.5-4zm49 33.2c-.6 0-1-.4-1-1V97h-.1c-2.3 3.3-6.7 5.5-13.4 5.5-8.7 0-16-4.5-16-14.5 0-10.4 7.3-15.1 19-15.1h9.7c.4 0 .6-.2.6-.6V70c0-5.4-2.6-7.9-10.6-7.9-5.3 0-8.6 1.5-10.8 3.3-.5.4-1.1.3-1.4-.2l-3.6-6.5c-.3-.5-.2-1 .2-1.3 3.8-2.8 9.1-4.6 16.9-4.6 14.5 0 19.8 4.9 19.8 16.6v31.1c0 .6-.4 1-1 1h-8.3zm-1.2-16v-3.6c0-.4-.2-.6-.6-.6H143c-7.1 0-10.3 2-10.3 6.4 0 3.9 2.9 5.9 8.2 5.9 6.8 0 10.6-2.7 10.6-8.1zm80.6 16c-.6 0-1-.4-1-1V73.1c0-6.1-3.1-10.4-9-10.4-5.7 0-9.1 4.2-9.1 10.4v27.4c0 .6-.4 1-1 1h-8.9c-.6 0-1-.4-1-1V73.1c0-6.1-3.1-10.4-9-10.4-5.7 0-9.1 4.2-9.1 10.4v27.4c0 .6-.4 1-1 1h-9.1c-.6 0-1-.4-1-1V54.9c0-.6.4-1 1-1h9.1c.6 0 1 .4 1 1v3.5h.1c2.1-3 6.2-5.5 12.5-5.5 5.6 0 10.2 2.3 13 6.3h.1c3.6-3.9 8.4-6.3 15.2-6.3 11 0 17.3 7.5 17.3 17.7v30c0 .6-.4 1-1 1h-9.1v-.1z\" class=\"__3mmDUGI__st0 \"></path></svg>"

/***/ }),

/***/ "3LnL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'teamable',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "3dfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{'hover' : _vm.menuHover, 'opened' : _vm.navOpened}},[_c('a',{staticClass:"menu-btn",class:{'hover' : _vm.menuHover, 'opened' : _vm.navOpened, 'inside' : _vm.menuInHeader},on:{"click":_vm.navToggle,"mouseenter":_vm.navMouseEnter,"mouseleave":_vm.navMouseLeave}},[_c('span',{staticClass:"ceiling"}),_vm._v(" "),_c('span',{staticClass:"floor"})]),_vm._v(" "),_c('nav',[_c('ul',_vm._l((_vm.navItems),function(navItem,index){return _c('li',{key:index,staticClass:"nav-item",class:{'dim' : _vm.navItemHover, 'hover' : navItem.hover},on:{"mouseenter":function($event){_vm.navItemMouseEnter(index)},"mouseleave":function($event){_vm.navItemMouseLeave(index)}}},[_c('router-link',{attrs:{"to":{ path: navItem.routePath },"exact":navItem.exactPath},nativeOn:{"click":function($event){_vm.navItemClick($event)}}},[_c('h1',[_vm._v(_vm._s(navItem.label))]),_vm._v(" "),_c('em',[_vm._v(_vm._s(navItem.description))])])],1)}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3up/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("Transcope is a cloud-based simple translation tool for both casual and professional translators. It was designed and developed by myself as a personal side project.")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-transcope-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("Transcope has been developed purely by Javascript, without any framework. It runs on Firebase's real-time database, which makes the loading and updating processes almost seamless."),_c('br'),_c('br'),_vm._v("I've also used Google Translate API to enable a Machine Translation feature, to help translators who prefer to have a starting point performed by machine, and a Word Definition feature as well.")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-transcope-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-transcope-03.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-transcope-04.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("I keep trying to find a balance where it's easy and obvious enough to use without an introductory tutorial, and also professional enough to be able to cover most of the translation process.")]),_vm._v(" "),_c('div',{staticClass:"embed"},[_c('figure',[_c('iframe',{attrs:{"src":"https://www.youtube-nocookie.com/embed/30SCeywRROM?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Transcope beta preview video")]),_vm._v(" "),_c('video',{staticClass:"shadow",attrs:{"src":_vm.videoPath + 'works-transcope-autoscroll.mp4',"autoplay":"","loop":""}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Auto scrolling")]),_vm._v(" "),_c('p',[_vm._v("I know that translators don't like to use a mouse while concentrating on translating, just as developers don't like using a mouse either. One of my efforts to reduce the role of the mouse was to make the scroll automatic. It was slightly more complicated than I expected, because the length of sentences can vary. I also didn't want to fix a height position by myself, so that users would have more flexibility with their own working style."),_c('br'),_c('br'),_vm._v("When a user hits the enter key, the document scrolls from the current paragraph's top point to the next paragraph's top point. This ensures that the position of the activated paragraph always stays the same.")]),_vm._v(" "),_c('video',{staticClass:"shadow",attrs:{"src":_vm.videoPath + 'works-transcope-create.mp4',"autoplay":"","loop":""}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Creating a new document")]),_vm._v(" "),_c('p',[_vm._v("With the initial version of Transcope, a document can have three different levels of formatting: Heading, Sub-heading and Paragraph. Transcope automatically divides the whole text into paragraphs and sentences, so users can work sentence by sentence. More advanced formatting options such as lists and block quotes will be supported later with updates.")]),_vm._v(" "),_c('video',{staticClass:"shadow",attrs:{"src":_vm.videoPath + 'works-transcope-word.mp4',"autoplay":"","loop":""}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Word definition")]),_vm._v(" "),_c('p',[_vm._v("Users can easily see the definitions of words that they're going to translate by just clicking the input interface. It gets the data from Google Translator API, based on the original and target languages they chose when creating the document.")]),_vm._v(" "),_c('video',{staticClass:"shadow",attrs:{"src":_vm.videoPath + 'works-transcope-machine.mp4',"autoplay":"","loop":""}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Machine translation")]),_vm._v(" "),_c('p',[_vm._v("In most cases, the quality of machine translation isn't good enough to use as output, but it can be a starting point for translators to work on, which can save some time. Just by clicking the 'Machine Translation' link at the bottom left will get the Google Translator's results into the input field, so users can start making changes to it.")]),_vm._v(" "),_c('video',{staticClass:"shadow",attrs:{"src":_vm.videoPath + 'works-transcope-list.mp4',"autoplay":"","loop":""}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("List sorting")]),_vm._v(" "),_c('p',[_vm._v("jQuery UI is the only Javascript library that's been used while developing the initial version of Transcope that's for the drag-and-drop list sorting feature. This makes the sorting intuitive and easy.")]),_vm._v(" "),_c('video',{staticClass:"shadow",attrs:{"src":_vm.videoPath + 'works-transcope-export.mp4',"autoplay":"","loop":""}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Exporting")]),_vm._v(" "),_c('p',[_vm._v("Users can either copy the output to the clipboard or export it to a .txt file.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4LVk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-header"},[_c('div',{ref:"headerFill",staticClass:"header-fill",style:(_vm.style)},[_c('header',[_c('site-title',{attrs:{"textColor":'#fff',"textDelay":1}}),_vm._v(" "),_c('hgroup',[_vm._t("projectTitle"),_vm._v(" "),_c('ul',{ref:"headerInfo"},[_c('li',[_c('u',[_vm._v("Year")]),_vm._v(" "),_vm._t("year")],2),_vm._v(" "),_c('li',[_c('u',[_vm._v("Team")]),_vm._v(" "),_vm._t("team")],2),_vm._v(" "),_c('li',[_c('u',[_vm._v("Participation")]),_vm._v(" "),_vm._t("participation")],2)])],2),_vm._v(" "),_c('img',{ref:"iconDown",staticClass:"icon-down",attrs:{"src":"/static/image/icon-arrow-down.svg","alt":"Scroll down","width":"20","height":"14"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4zz7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Bg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SiteTitle_vue__ = __webpack_require__("RKQU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TextBlock_vue__ = __webpack_require__("Jpyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer_vue__ = __webpack_require__("TVmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__("+Uzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scrollmagic__ = __webpack_require__("A8vr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ScrollMagicIndicator__ = __webpack_require__("2Pud");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ScrollMagicIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ScrollMagicIndicator__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'photos',
  components: {
    'site-title': __WEBPACK_IMPORTED_MODULE_0__components_SiteTitle_vue__["a" /* default */],
    'text-block': __WEBPACK_IMPORTED_MODULE_1__components_TextBlock_vue__["a" /* default */],
    'site-footer': __WEBPACK_IMPORTED_MODULE_2__components_Footer_vue__["a" /* default */]
  },
  data: function data() {
    return {
      flickrUserId: '103073251@N02',
      flickrApiKey: '3c8c001e3b7b80cff8ff75e1404ed604',
      controller: '',
      loadMoreScene: ''
    };
  },

  methods: {
    loadMoreBtnHandler: function loadMoreBtnHandler() {
      this.$store.commit('loadMorePhoto', 12);
    },
    fetchImages: function fetchImages() {
      return __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'get',
        url: 'https://api.flickr.com/services/rest',
        params: {
          method: 'flickr.photos.search',
          api_key: this.flickrApiKey,
          user_id: this.flickrUserId,
          format: 'json',
          nojsoncallback: 1,
          extras: 'url_h',
          per_page: 500
        }
      });
    }
  },
  created: function created() {
    var _this = this;

    this.fetchImages().then(function (response) {
      _this.$store.commit('loadFlickrData', response.data.photos.photo);
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    // Reavel transition for the pics
    __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].fromTo(this.$refs.pictures, 1.5, { opacity: 0, y: 100 }, { opacity: 1, y: 0, delay: 1.5, ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power3"].easeOut });

    // ScrollMagic setup
    this.controller = new __WEBPACK_IMPORTED_MODULE_5_scrollmagic___default.a.Controller();

    this.loadMoreScene = new __WEBPACK_IMPORTED_MODULE_5_scrollmagic___default.a.Scene({
      triggerElement: this.$refs.loadTrigger,
      triggerHook: 'onEnter'
    }).on('enter leave', function (e) {
      if (e.type === 'enter') {
        _this2.$store.commit('loadMorePhoto', 6);
      }
    }).addTo(this.controller);
    // .addIndicators()
  }
});

/***/ }),

/***/ "5Evu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataPath_vue__ = __webpack_require__("zegB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataPath_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5bzO":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 190 76\"><path d=\"M129.9 73.7l-4.1-4.5h-1.5v6.6h1.4V71l4.4 4.8h1.2v-6.6h-1.4v4.5zm-10.3-1.2c0-1.4-1-2.2-2.5-2.2s-2.5.8-2.5 2.2c0 1.4.9 2.2 2.5 2.2 1.5 0 2.5-.8 2.5-2.2zm1.4 0c0 2.2-1.5 3.5-3.9 3.5s-3.9-1.3-3.9-3.5 1.5-3.5 3.9-3.5 3.9 1.3 3.9 3.5zm-16.8-2h2.7v5.3h1.4v-5.3h2.7v-1.3h-6.8v1.3zm-4.3 1.3h-4.2v-2.6h-1.4v6.6h1.4v-2.7h4.2v2.7h1.4v-6.6h-1.4v2.6zm-12.5 1.5h2.3v.6c-.4.6-1.2.8-2.1.8-1.6 0-2.6-.8-2.6-2.2 0-1.5.9-2.2 2.5-2.2.9 0 1.6.3 2.1.8l1.1-.9c-.6-.6-1.7-1.2-3.2-1.2-2.5 0-4 1.3-4 3.5s1.5 3.5 4 3.5c1.7 0 2.9-.6 3.5-1.5v-2.4h-3.6v1.2zM79 75.8h1.4v-6.6H79v6.6zm-5.9-3.5c.7 0 1.3-.2 1.3-.9s-.5-.9-1.3-.9h-2.8v1.8h2.8zm1 1.2l1.9 2.3h-1.7l-1.8-2.2h-2.2v2.2h-1.4v-6.6h4.2c1.5 0 2.6.7 2.6 2.2.1 1.1-.6 1.8-1.6 2.1zm-9.8.3c0-.7-.5-.8-1.3-.8h-2.9v1.6H63c.9 0 1.3-.1 1.3-.8zm-4.1-1.9h2.6c.8 0 1.2-.1 1.2-.7s-.5-.7-1.2-.7h-2.6v1.4zm5.6 2.1c0 1.2-.9 1.8-2.4 1.8h-4.6v-6.6H63c1.5 0 2.4.6 2.4 1.7 0 .8-.5 1.4-1.4 1.5 1 0 1.8.5 1.8 1.6zM93 5.4h5.8v4.9h1.6V0h-1.6v4.7H93V0h-1.6v10.3H93V5.4zm-9.9 4.9h1.6V.7h3.9V0h-9.3v.7h3.9v9.6zm22.2-4.9h4v-.7h-4V.8h5.3V0h-6.9v10.3h7.1v-.7h-5.5V5.4zm6.9 22.2h10.1v25h3.2v-25h10.1v-1.1h-23.5v1.1zM45.3 38.5c1.3-1 2-2.6 2-4.8 0-2.1-.6-3.6-1.8-4.6-1.1-.9-2.8-1.4-4.9-1.4h-6.1v12.2h6.1c2-.1 3.6-.6 4.7-1.4zm7.1 13.4l.7.6h-4l-.1-.2c-.5-.8-1-1.8-1.5-3.2L46.1 45c-.6-1.6-1.2-2.6-2.1-3.2-.9-.7-2.2-1-4-1h-5.4v11.7h-3.3v-26h9.5c6.4 0 10.1 2.6 10.1 7.1 0 2.3-1 4.1-2.9 5.5-.9.6-2 1.1-3.1 1.4 2.1.6 3.4 1.9 4.2 4.1l1.5 4.2c.4 1.4 1 2.5 1.8 3.1zm107.1-12.4c0-3.9-.9-7-2.5-9.1-1.6-2.1-3.9-3.2-6.8-3.2s-5.2 1.1-6.9 3.2c-1.6 2.1-2.5 5.3-2.5 9.1 0 3.9.9 7 2.5 9.1 1.6 2.1 3.9 3.2 6.9 3.2 2.9 0 5.2-1.1 6.8-3.2 1.7-2.1 2.5-5.2 2.5-9.1zm-.3-9.6c2.5 2.5 3.8 5.9 3.8 9.6 0 3.7-1.4 7.1-3.8 9.6-2.4 2.4-5.6 3.8-9 3.8-3.4 0-6.6-1.3-9.1-3.8s-3.8-5.9-3.8-9.6c0-3.7 1.4-7.1 3.8-9.6 2.4-2.4 5.6-3.8 9.1-3.8 3.4 0 6.6 1.4 9 3.8zm29.7-3.4v21.3l-19.3-21.5-.1-.1h-.7v26.5h1.1V31.2l19.4 21.7h.7V26.5h-1.1zm-116 16l-5.4-11.9-5.2 11.9h10.6zm-4-16.4l12 26.5h-3.4l-4-8.9H62l-3.9 8.9h-1.2l11.5-26.5h.5zM24.1 40.5h-8.4v1.1h5.1v3c-.1 2.1-1 4-2.5 5.3-1.4 1.2-3.3 1.9-5.4 1.9-2.8 0-5.2-1.1-6.8-3.1-1.7-2.1-2.6-5.3-2.6-9.1s1-7 2.7-9.2c1.7-2.1 4.2-3.1 7.1-3.1 2.1 0 3.9.5 5.4 1.5 1.6 1 2.8 2.5 3.6 4.5l.1.4 1-.4-.1-.3c-1.7-4.3-5.3-6.6-10.2-6.6-3.5 0-6.8 1.3-9.3 3.8-2.5 2.5-3.9 5.9-3.9 9.7 0 3.7 1.3 7.2 3.8 9.6 2.4 2.4 5.6 3.8 9.2 3.8 3.8 0 6.4-1.9 7.9-3.9v3.5h3.3V40.5zm62.2-14.4l19.4 21.6V26.5h1.1V53h-.7L86.7 31.3v21.4h-1.1V26.1h.7z\"></path></svg>"

/***/ }),

/***/ "5rsv":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 149.5 112.1\"><path d=\"M14 83.5c-3.7 0-6 1.3-7.3 3.2h-.1V78c0-.4-.3-.6-.6-.6H.8c-.4 0-.6.3-.6.6v32.8c0 .4.3.6.6.6H6c.4 0 .6-.3.6-.6l.1-2c1.3 1.9 3.6 3.2 7.3 3.3 4.7 0 8.1-2.2 9.5-6.6.7-2.1 1-4 1-7.7s-.3-5.6-1-7.7c-1.4-4.5-4.8-6.6-9.5-6.6zm3.4 19.3c-.8 2.2-2.5 3.5-5 3.5-2.6 0-4.4-1.2-5.1-3.5-.4-1.2-.6-2.6-.6-5.1s.2-3.9.6-5.1c.7-2.3 2.5-3.5 5.1-3.5 2.5 0 4.3 1.2 5 3.5.4 1.2.6 2.6.6 5.1s-.2 3.9-.6 5.1zM35.5 84h-5.2c-.4 0-.6.3-.6.6v26.2c0 .4.3.6.6.6h5.2c.4 0 .6-.3.6-.6V84.6c0-.5-.3-.6-.6-.6zm20.7 10.6l-2.9-.3c-3.5-.3-4.5-1.3-4.5-2.9s1.4-2.8 4.1-2.8 5.4 1.1 7.1 2.3c.3.2.6.2.8-.1l2.8-3.3c.2-.2.2-.6-.1-.8-2.5-1.9-6-3.3-10.3-3.3-6.8 0-10.6 3.3-10.6 8.6 0 4.7 2.8 7.5 8.4 8.1l2.9.3c3.5.3 4.5 1.4 4.5 3 0 1.8-1.7 3.2-5 3.2-2.8 0-6-1.3-8-3.1-.2-.2-.6-.2-.8 0l-3.2 3.4c-.2.2-.2.6 0 .8 2.2 2.1 6.1 4.3 11.8 4.1 7.5 0 11.5-3.8 11.5-9.2 0-4.5-2.8-7.5-8.5-8zm24.3-5.5c2.2 0 3.6.9 5 2.4.2.3.5.3.8.1l3.6-2.9c.3-.2.3-.6.1-.8-2.2-2.7-5.4-4.3-9.5-4.3-5.5 0-9.7 2.6-11.3 7.5-.6 1.7-.9 3.8-.9 6.7 0 2.8.3 5 .9 6.7 1.6 4.9 5.8 7.5 11.3 7.4 4.1 0 7.3-1.6 9.5-4.2.1-.3.2-.6-.1-.8l-3.6-3.1c-.3-.2-.6-.2-.8.1-1.3 1.6-2.7 2.4-5 2.4-2.4 0-4.3-1.2-5.1-3.5-.5-1.4-.6-3-.6-5.1s.1-3.6.6-5c.8-2.4 2.7-3.6 5.1-3.6zm36.8-5h-5.2c-.4 0-.6.3-.6.6v15.8c0 3.5-1.9 5.9-5.1 5.9-3.5 0-5.1-2.5-5.1-6V84.6c0-.4-.3-.6-.6-.6h-5.2c-.4 0-.6.3-.6.6v17.2c0 5.9 3.6 10.2 9.4 10.2 3.5 0 5.6-1.3 7.1-3.2h.1v2c0 .4.3.6.6.6v.1h5.2c.4 0 .6-.3.6-.6V84.6c0-.3-.3-.5-.6-.5zm13.3-.1h-5.2c-.4 0-.6.3-.6.6v26.2c0 .4.3.6.6.6h5.2c.4 0 .6-.3.6-.6V84.6c0-.5-.3-.6-.6-.6zm18.2 22.1h-1.4c-1.8 0-2.6-.7-2.6-2.6V89.3c0-.2.1-.3.3-.3h3.6c.4 0 .6-.3.6-.6v-3.8c0-.4-.3-.6-.6-.6h-3.6c-.2 0-.3-.1-.3-.3V78c0-.4-.3-.6-.6-.6H139c-.4 0-.6.3-.6.6v5.7c0 .2-.1.3-.3.3h-1.8c-.4 0-.6.3-.6.6v3.8c0 .4.3.6.6.6h1.8c.2 0 .3.1.3.3v14.4c0 5.3 2.1 8 7.6 8v.1h2.8c.4 0 .6-.3.6-.6v-4.5c0-.4-.3-.6-.6-.6zm-80-35.5L101.4 38c-5.9-6.1-5.8-15.6.1-21.5L85.3.1c-.2-.2-.6-.2-.8 0L41.4 43.3c-.2.2-.2.6 0 .8L68 70.6c.2.2.6.2.8 0z\" class=\"__1-rxuG8__st0 \"></path></svg>"

/***/ }),

/***/ "6xI7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'olasio',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "7Q93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{ref:"text",class:{'marginless': _vm.marginLess, 'quote-type': _vm.quoteType}},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7wV8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'magritte',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "9+LN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("Zigzag is a meta fashion shopping mall app for young female users in South Korea. It was my final project at Croquis, the startup I worked for years as a lead designer.")]),_vm._v(" "),_c('img',{staticClass:"mw630",attrs:{"src":_vm.imagePath + 'works-zigzag-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"mw630",attrs:{"src":_vm.imagePath + 'works-zigzag-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"mw630",attrs:{"src":_vm.imagePath + 'works-zigzag-03.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"mw630",attrs:{"src":_vm.imagePath + 'works-zigzag-04.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("I've created Zigzag's Watch App prototype with Xcode. It's much easier than using Framer or any other third party prototyping tool when creating a Watch App prototype.")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-zigzag-05.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('video',{staticClass:"border-light mw280",attrs:{"src":_vm.videoPath + 'works-zigzag.mp4',"autoplay":"","loop":""}}),_vm._v(" "),_c('p',[_vm._v("I found that the word Zigzag and 지그재그(Korean name of the app) has some similarity in the visual shape and the length. So I tried to find a font that I can use for English, also can be converted to Korean word with some tweaks.")]),_vm._v(" "),_c('img',{staticClass:"mw200",attrs:{"src":_vm.imagePath + 'works-zigzag-06.svg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-zigzag-web-01.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-zigzag-web-02.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-zigzag-web-03.jpg',"alt":this.$options.name}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9GbO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('small',{ref:"subTitleFeatured"},[_c('span',[_vm._v("Featured works")])]),_vm._v(" "),_c('div',{staticClass:"grid"},_vm._l((_vm.items),function(item,index){return _c('figure',{key:item.slug,class:['item-' + index]},[_c('router-link',{attrs:{"to":{ path: '/works/' + item.slug }}},[_c('div',{class:item.slug},[_c('vector',{attrs:{"src":__webpack_require__("TlR/")("./logo-" + item.slug + '.svg'),"context":"home-featured"}})],1)])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AMUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ path: '/works/' + _vm.itemSlug }}},[_c('div',{class:['item-image', _vm.itemSlug, {'hover': _vm.itemHover}],style:({backgroundImage: 'linear-gradient(' + _vm.itemColor + ',' + _vm.itemColor + ')'}),on:{"mouseenter":function($event){_vm.itemHover = true},"mouseleave":function($event){_vm.itemHover = false}}},[_c('vector',{attrs:{"src":__webpack_require__("TlR/")("./logo-" + _vm.itemSlug + '.svg'),"data-context":"work-list"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AUWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 't2',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "Bkc6":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 356.2 63.9\"><path d=\"M162.1 36.8c10.5-1.2 17.9-8.2 17.9-18.5 0-6.2-4.7-17-20.6-17h-25.2V63h10V9.2h12.7c8.9 0 13 4.2 13 10.3 0 5.9-4.5 10.3-14.3 10.3h-10.8l26.5 33.4h12.3l-21.5-26.4zM81.9 1.2v61.7h39.7v-8H91.9V34.5h25.5v-8H91.9V9.4H121v-8c0-.2-39.1-.2-39.1-.2zM238.5 50c-1.8 1.2-6.4 5.5-16.7 5.5-13.3 0-23-9.9-23-23.3 0-12.3 8.5-23.3 23-23.3 9.2 0 14.4 3.6 16.7 5.5l4.7-7.7c-1.8-1.1-8.8-6.4-20.9-6.4-19 0-34.3 12.6-34.3 31.8 0 18.8 14.1 32 34.3 32 11.2 0 19.1-5.2 20.9-6.4l-4.7-7.7zm95.7-13.2c10.5-1.2 17.9-8.2 17.9-18.5 0-6.2-4.7-17-20.6-17h-25.2V63h10V9.2H329c8.9 0 13 4.2 13 10.3 0 5.9-4.5 10.3-14.3 10.3h-10.8l26.5 33.4h12.3l-21.5-26.4zM254 1.2v61.7h39.7v-8H264V34.5h25.5v-8H264V9.4h29.1v-8c0-.2-39.1-.2-39.1-.2zM33.5 49.3L14.1 1.2H0v61.7h9.6V14.8h.2L29.1 63h8.5l20.2-48.5h.2V63h9.7V1.2H53.6L33.7 49.3h-.2z\" class=\"__1CiYA6N__st0 \"></path></svg>"

/***/ }),

/***/ "Bl+D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{ref:"content",staticClass:"project-content"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C1bF":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 103.5 37.4\"><path d=\"M8.7 6.9c-1.9 0-3.4.9-4 2.5V2.8c-.5.1-1.7.3-2.8.3H0v1.7h1.1c.3 0 .4.2.4.7v9.3c0 2.4-.1 3.5-.1 4h1.8l.8-2.7c.7 1.9 2.3 3 4.5 3 3.2 0 5.2-2.4 5.2-6.1.1-3.7-1.8-6.1-5-6.1zm1.7 6.3c0 2.6-1.2 3.9-2.9 3.9s-2.9-1.3-2.9-3.9v-.3C4.6 10.3 5.8 9 7.5 9c1.8 0 2.9 1.3 2.9 3.9v.3zm23.8-6.3c-1.3 0-2.6.8-3.1 2.6V7c-.6.1-1.6.3-2.8.3h-2v1.8h1.1c.3 0 .4.2.4.7v6.7c0 .6-.2.6-.4.6h-2c-.3 0-.4-.2-.4-.6v-5.7c0-2.9-1.5-4-5.1-4-3 0-5.5.8-5.5 3.1 0 1.3.8 1.9 1.9 1.9 1 0 1.9-.7 1.9-1.8 0-.5-.2-.9-.4-1.3.4-.1.8-.2 1.5-.2 1.7 0 2.4.6 2.4 2.2v.7c-4.8.7-7.7 1.6-7.7 4.5 0 1.7 1.3 3 3.5 3 1.9 0 3.6-1 4.2-2.3.2.8.3 1.3.7 1.9h10v-1.8h-1.1c-.3 0-.4-.1-.4-.6v-3.6c0-2.4.8-3.9 2.4-3.9.3 0 .6.1.8.3-.7.3-1.2.8-1.2 1.5 0 .8.8 1.6 1.6 1.6 1.3 0 2.3-1 2.3-2.5.2-1.5-.9-2.6-2.6-2.6zm-12.4 7c0 1.9-1.2 3.3-2.9 3.3-1 0-1.7-.6-1.7-1.6 0-1.6 1.7-2.2 4.6-2.6v.9zm20.8-7c-3.5 0-6.1 2.4-6.1 6.1 0 3.5 2.1 6.1 6.3 6.1 3 0 4.5-1.5 5.2-3.4l-1.7-.8c-.6 1.4-1.5 2.3-3.1 2.3-2.2 0-3.2-1.4-3.3-3.6h8.4V13c-.1-3.8-2.1-6.1-5.7-6.1zm-2.8 5c.2-2.3 1.1-3.3 2.8-3.3s2.4.9 2.4 3.3h-5.2zM53 16.4V9h2.1V7.2H53v-.4c-.1-1.9.3-2.4 1.6-2.4.3 0 .8.1 1 .3V2.9c-.3-.2-1.1-.4-2-.4-2.6 0-3.7 1-3.7 3.9v.8h-1.6V9h1.6v7.4c0 .6-.2.6-.4.6h-1v1.8h6.2V17h-1.3c-.2 0-.4-.1-.4-.6z\" class=\"__3TzjOFr__st0 \"></path><path d=\"M61 6.9c-3.7 0-6.2 2.4-6.2 6.1s2.4 6.1 6.1 6.1c3.7 0 6.2-2.4 6.2-6.1-.1-3.7-2.5-6.1-6.1-6.1zm2.8 6.2c0 2.8-.9 4-2.9 4s-2.9-1.3-2.9-4v-.3c0-2.8.9-4 2.9-4s2.9 1.3 2.9 4v.3zm9.7-6.2c-3.7 0-6.2 2.4-6.2 6.1s2.4 6.1 6.1 6.1 6.2-2.4 6.2-6.1c0-3.7-2.5-6.1-6.1-6.1zm2.9 6.2c0 2.8-.9 4-2.9 4s-2.9-1.3-2.9-4v-.3c0-2.8.9-4 2.9-4s2.9 1.3 2.9 4v.3zm9 4.1c-1 0-1.5-.4-1.5-1.7V9h2.4V7.2H84V3.9h-2.2L81.5 6c-.1.8-.6 1.2-1.4 1.3.1 0-.9.1-.9.1V9h1.6v6.5c0 2.6 1 3.6 3.6 3.6.8 0 1.6-.2 2.1-.3v-1.9c-.3.1-.6.3-1.1.3zM18.8 33.6v-5.1c0-2.9-1.3-4.3-3.8-4.3-1.9 0-3.2.8-4 2.4v-2.3c-.5.1-1.6.3-2.8.3H6.3v1.8h1c.3 0 .4.2.4.7v6.7c0 .6-.2.6-.4.6H5.2c-.3 0-.4-.1-.4-.6v-9.4c-.6.1-1.6.3-2.8.3H.1v1.8H1c.4 0 .5.3.5.9v6.5c0 .5-.1.6-.4.6H0v1.8h12.2v-1.8h-.9c-.3 0-.4-.1-.4-.6v-3.6c0-2.6.9-3.8 2.5-3.8 1.3 0 1.9.7 1.9 2.3v5.1c0 .6-.2.6-.4.6H14v1.8h6v-1.8h-1c-.1-.3-.2-.4-.2-.9zm13.8-7.4v-1.9h-5.2v1.8h1.1c.4 0 .6.3.4.8l-2.4 5.8c-.9-2-2.2-5.1-2.4-5.8-.2-.4 0-.7.4-.7h.8v-1.9h-6.2v1.8h.9c.3 0 .4.1.7.6l4.1 9.3h1.9l4.1-9.3c.2-.4.5-.6.8-.6l1 .1z\" class=\"__3TzjOFr__st0 \"></path><path d=\"M37.7 24.1c-3.5 0-6.1 2.4-6.1 6.1 0 3.5 2.1 6.1 6.3 6.1 3 0 4.5-1.5 5.2-3.4l-1.8-.8c-.6 1.4-1.5 2.3-3.1 2.3-2.2 0-3.2-1.4-3.3-3.6h8.4v-.6c.1-3.9-2-6.1-5.6-6.1zm-2.8 5c.2-2.3 1.1-3.3 2.8-3.3s2.4.9 2.4 3.3h-5.2zm14.4-.2c-1.5-.3-2.7-.4-2.7-1.6 0-.9.8-1.5 2.3-1.5.7 0 1.5.2 1.8.3v2h2.4v-3c-.8-.4-2.7-.9-4.3-.9-3.3 0-5.1 1.5-5.1 3.8 0 2.4 2.1 3.1 4.1 3.5 1.6.3 2.8.6 2.8 1.7s-.9 1.5-2.3 1.5c-.9 0-1.7-.1-2.1-.3v-2.1h-2.4v3.1c1.2.4 2.8.9 4.5.9 3.3 0 5.2-1.5 5.2-3.9 0-2.5-2.1-3.2-4.2-3.5zm8.8 3.7v-6.5h2.4v-1.8h-2.3V21H56l-.3 2.1c-.1.8-.6 1.2-1.4 1.3.1 0-.9.1-.9.1v1.6H55v6.5c0 2.6 1 3.6 3.6 3.6.8 0 1.6-.2 2.1-.3V34c-.3.1-.6.2-1.1.2-1.1 0-1.5-.4-1.5-1.6z\" class=\"__3TzjOFr__st0 \"></path><path d=\"M66.6 24.1c-3.7 0-6.2 2.4-6.2 6.1s2.4 6.1 6.1 6.1c3.7 0 6.2-2.4 6.2-6.1s-2.5-6.1-6.1-6.1zm2.9 6.2c0 2.8-.9 4-2.9 4s-2.9-1.3-2.9-4V30c0-2.8.9-4 2.9-4s2.9 1.3 2.9 4v.3zm11.2-6.2c-1.3 0-2.6.8-3.1 2.6v-2.5c-.6.1-1.6.3-2.8.3h-1.9v1.8H74c.3 0 .4.2.4.7v6.7c0 .6-.2.6-.4.6h-1v1.5h6.2V34h-1.1c-.3 0-.4-.1-.4-.6v-3.6c0-2.4.8-3.9 2.4-3.9.3 0 .6.1.8.3-.7.3-1.2.8-1.2 1.5 0 .8.8 1.6 1.6 1.6 1.3 0 2.3-1 2.3-2.5-.2-1.6-1.2-2.7-2.9-2.7zm-77.3-.8c1.2 0 2-.8 2-1.9s-.8-1.9-2-1.9-2 .8-2 1.9.7 1.9 2 1.9zm99.6-11c-.2-.8.5-1.7.3-2.4-.2-.5-1-1.1-1.5-.6-.9.8.2 1.3.1 2.1 0 0-2.9-2.9-4.5-3.9-1.3-.8-2.8-.9-4.2-.9-1.3 0-.3-1.1.2-1.5.8-.8 1.2-1.9 1-3C94.3.8 93.6.4 92.6.3c-2.4-.1-2.9 4-1.9 5.7.7 1-.6 1.5-1.1 2.4-.6 1.2-.6 2.4-.4 3.6.2 1.1.9 2.3 1.9 2.9 1 .5 2.4.6 3.1 1.8.6 1.1.8 2.2.7 3 0 .4-.3 1.6-.5 2.4-.5 1.4-2.9 3.5-4.5 4.8-1.5 1.1-2.9 3.4-2.9 5.3-.1 1.5 0 3.1 1.6 4 1.4.8 3.4.9 4.6-.2 2.9-2.3 2.4-6.6 3.8-9.6 1.6-3.7 5.3-6.3 6-10.4.3-1.4.2-2.6 0-3.7z\" class=\"__3TzjOFr__st0 \"></path><path d=\"M101.2 8.4c1.3-.5.8-2.6-.5-2.1-1.4.6-.8 2.6.5 2.1zM99.9 6c1.6-1-.3-3.5-1.8-1.7-.6.8.2 2.7 1.8 1.7zm-3.8-1.6c1.4.4 2.6-1.7 1.3-2.5-1.7-.9-2.9 2.1-1.3 2.5z\" class=\"__3TzjOFr__st0 \"></path></svg>"

/***/ }),

/***/ "CIoU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__("+Uzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__script_SplitText__ = __webpack_require__("EyEd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__script_SplitText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__script_SplitText__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'site-title',
  props: {
    text: {
      type: String,
      default: 'Jason Jun'
    },
    textColor: {
      type: String,
      default: '#222'
    },
    textDelay: {
      type: Number,
      default: 0
    }
  },
  computed: {
    titleStyle: function titleStyle() {
      return 'color: ' + this.textColor;
    }
  },
  mounted: function mounted() {
    // Site title animate in
    var titleSplit = new __WEBPACK_IMPORTED_MODULE_1__script_SplitText___default.a(this.$refs.title, { type: 'words' });
    __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].staggerFrom(titleSplit.words, 1, {
      y: 100,
      ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeOut,
      delay: this.textDelay,
      onComplete: function onComplete() {
        titleSplit.revert();
      }
    }, 0.1); // TweenMax
  }
});

/***/ }),

/***/ "DNKD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DcGR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DvM2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_vm._v("This website is built with "),_c('a',{attrs:{"href":"https://vuejs.org/","target":"_blank"}},[_vm._v("Vue.js")]),_vm._v(", and hosted on "),_c('a',{attrs:{"href":"https://www.netlify.com/","target":"_blank"}},[_vm._v("Netlify")]),_vm._v(".")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EyEd":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
var define = false;

/*!
 * VERSION: 0.5.8
 * DATE: 2017-08-22
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * SplitText is a Club GreenSock membership benefit; You must have a valid membership to use
 * this code without violating the terms of use. Visit http://greensock.com/club/ to sign up or get more details.
 * This work is subject to the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
(function(window) {
	
	"use strict";
	var _globals = window.GreenSockGlobals || window,
		_namespace = function(ns) {
			var a = ns.split("."),
				p = _globals, i;
			for (i = 0; i < a.length; i++) {
				p[a[i]] = p = p[a[i]] || {};
			}
			return p;
		},
		pkg = _namespace("com.greensock.utils"),
		_getText = function(e) {
			var type = e.nodeType,
				result = "";
			if (type === 1 || type === 9 || type === 11) {
				if (typeof(e.textContent) === "string") {
					return e.textContent;
				} else {
					for ( e = e.firstChild; e; e = e.nextSibling ) {
						result += _getText(e);
					}
				}
			} else if (type === 3 || type === 4) {
				return e.nodeValue;
			}
			return result;
		},
		_doc = document,
		_getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function() {},
		_capsExp = /([A-Z])/g,
		_getStyle = function(t, p, cs, str) {
			var result;
			if ((cs = cs || _getComputedStyle(t, null))) {
				t = cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
				result = (t || cs.length) ? t : cs[p]; //Opera behaves VERY strangely - length is usually 0 and cs[p] is the only way to get accurate results EXCEPT when checking for -o-transform which only works with cs.getPropertyValue()!
			} else if (t.currentStyle) {
				cs = t.currentStyle;
				result = cs[p];
			}
			return str ? result : parseInt(result, 10) || 0;
		},
		_isArrayLike = function(e) {
			return (e.length && e[0] && ((e[0].nodeType && e[0].style && !e.nodeType) || (e[0].length && e[0][0]))) ? true : false; //could be an array of jQuery objects too, so accommodate that.
		},
		_flattenArray = function(a) {
			var result = [],
				l = a.length,
				i, e, j;
			for (i = 0; i < l; i++) {
				e = a[i];
				if (_isArrayLike(e)) {
					j = e.length;
					for (j = 0; j < e.length; j++) {
						result.push(e[j]);
					}
				} else {
					result.push(e);
				}
			}
			return result;
		},
		_stripExp = /(?:\r|\n|\t\t)/g, //find carriage returns, new line feeds and double-tabs.
		_multipleSpacesExp = /(?:\s\s+)/g,
		_emojiStart = 0xD800,
		_emojiEnd = 0xDBFF,
		_emojiLowStart = 0xDC00,
		_emojiRegionStart = 0x1F1E6,
		_emojiRegionEnd = 0x1F1FF,
		_emojiModStart = 0x1f3fb,
		_emojiModEnd = 0x1f3ff,
		_emojiPairCode = function(s) {
			return ((s.charCodeAt(0) - _emojiStart) << 10) + (s.charCodeAt(1) - _emojiLowStart) + 0x10000;
		},
		_isOldIE = (_doc.all && !_doc.addEventListener),
		_divStart = " style='position:relative;display:inline-block;" + (_isOldIE ? "*display:inline;*zoom:1;'" : "'"), //note: we must use both display:inline-block and *display:inline for IE8 and earlier, otherwise it won't flow correctly (and if we only use display:inline, IE won't render most of the property tweens - very odd).
		_cssClassFunc = function(cssClass, tag) {
			cssClass = cssClass || "";
			var iterate = (cssClass.indexOf("++") !== -1),
				num = 1;
			if (iterate) {
				cssClass = cssClass.split("++").join("");
			}
			return function() {
				return "<" + tag + _divStart + (cssClass ? " class='" + cssClass + (iterate ? num++ : "") + "'>" : ">");
			};
		},
		SplitText = pkg.SplitText = _globals.SplitText = function(element, vars) {
			if (typeof(element) === "string") {
				element = SplitText.selector(element);
			}
			if (!element) {
				throw("cannot split a null element.");
			}
			this.elements = _isArrayLike(element) ? _flattenArray(element) : [element];
			this.chars = [];
			this.words = [];
			this.lines = [];
			this._originals = [];
			this.vars = vars || {};
			this.split(vars);
		},
		_swapText = function(element, oldText, newText) {
			var type = element.nodeType;
			if (type === 1 || type === 9 || type === 11) {
				for (element = element.firstChild; element; element = element.nextSibling) {
					_swapText(element, oldText, newText);
				}
			} else if (type === 3 || type === 4) {
				element.nodeValue = element.nodeValue.split(oldText).join(newText);
			}
		},
		_pushReversed = function(a, merge) {
			var i = merge.length;
			while (--i > -1) {
				a.push(merge[i]);
			}
		},
		_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
			var b = [],
				l = a.length,
				i;
			for (i = 0; i !== l; b.push(a[i++])) {}
			return b;
		},
		_isBeforeWordDelimiter = function(e, root, wordDelimiter) {
			var next;
			while (e && e !== root) {
				next = e._next || e.nextSibling;
				if (next) {
					return next.textContent.charAt(0) === wordDelimiter;
				}
				e = e.parentNode || e._parent;
			}
			return false;
		},
		_deWordify = function(e) {
			var children = _slice(e.childNodes),
				l = children.length,
				i, child;
			for (i = 0; i < l; i++) {
				child = children[i];
				if (child._isSplit) {
					_deWordify(child);
				} else {
					if (i && child.previousSibling.nodeType === 3) {
						child.previousSibling.nodeValue += (child.nodeType === 3) ? child.nodeValue : child.firstChild.nodeValue;
					} else if (child.nodeType !== 3) {
						e.insertBefore(child.firstChild, child);
					}
					e.removeChild(child);
				}
			}
		},
		_setPositionsAfterSplit = function(element, vars, allChars, allWords, allLines, origWidth, origHeight) {
			var cs = _getComputedStyle(element),
				paddingLeft = _getStyle(element, "paddingLeft", cs),
				lineOffsetY = -999,
				borderTopAndBottom = _getStyle(element, "borderBottomWidth", cs) + _getStyle(element, "borderTopWidth", cs),
				borderLeftAndRight = _getStyle(element, "borderLeftWidth", cs) + _getStyle(element, "borderRightWidth", cs),
				padTopAndBottom = _getStyle(element, "paddingTop", cs) + _getStyle(element, "paddingBottom", cs),
				padLeftAndRight = _getStyle(element, "paddingLeft", cs) + _getStyle(element, "paddingRight", cs),
				lineThreshold = _getStyle(element, "fontSize") * 0.2,
				textAlign = _getStyle(element, "textAlign", cs, true),
				charArray = [],
				wordArray = [],
				lineArray = [],
				wordDelimiter = vars.wordDelimiter || " ",
				tag = vars.span ? "span" : "div",
				types = vars.type || vars.split || "chars,words,lines",
				lines = (allLines && types.indexOf("lines") !== -1) ? [] : null,
				words = (types.indexOf("words") !== -1),
				chars = (types.indexOf("chars") !== -1),
				absolute = (vars.position === "absolute" || vars.absolute === true),
				linesClass = vars.linesClass,
				iterateLine = ((linesClass || "").indexOf("++") !== -1),
				spaceNodesToRemove = [],
				i, j, l, node, nodes, isChild, curLine, addWordSpaces, style, lineNode, lineWidth, offset;
			if (lines && element.children.length === 1 && element.children[0]._isSplit) { //lines are always split on the main element (not inside nested elements), so if there's only one child, bust apart lines inside that rather than forcing it all into one big line. Like <div><div>lots of stuff</div></div> - if they split the outer one, it'd all be in one line.
				element = element.children[0];
			}
			if (iterateLine) {
				linesClass = linesClass.split("++").join("");
			}

			//copy all the descendant nodes into an array (we can't use a regular nodeList because it's live and we may need to renest things)
			j = element.getElementsByTagName("*");
			l = j.length;
			nodes = [];
			for (i = 0; i < l; i++) {
				nodes[i] = j[i];
			}

			//for absolute positioning, we need to record the x/y offsets and width/height for every <div>. And even if we're not positioning things absolutely, in order to accommodate lines, we must figure out where the y offset changes so that we can sense where the lines break, and we populate the lines array.
			if (lines || absolute) {
				for (i = 0; i < l; i++) {
					node = nodes[i];
					isChild = (node.parentNode === element);
					if (isChild || absolute || (chars && !words)) {
						offset = node.offsetTop;
						if (lines && isChild && Math.abs(offset - lineOffsetY) > lineThreshold && (node.nodeName !== "BR" || i === 0)) { //we found some rare occasions where a certain character like &#8209; could cause the offsetTop to be off by 1 pixel, so we build in a threshold.
							curLine = [];
							lines.push(curLine);
							lineOffsetY = offset;
						}
						if (absolute) { //record offset x and y, as well as width and height so that we can access them later for positioning. Grabbing them at once ensures we don't trigger a browser paint & we maximize performance.
							node._x = node.offsetLeft;
							node._y = offset;
							node._w = node.offsetWidth;
							node._h = node.offsetHeight;
						}
						if (lines) {
							if ((node._isSplit && isChild) || (!chars && isChild) || (words && isChild) || (!words && node.parentNode.parentNode === element && !node.parentNode._isSplit)) {
								curLine.push(node);
								node._x -= paddingLeft;
								if (_isBeforeWordDelimiter(node, element, wordDelimiter)) {
									node._wordEnd = true;
								}
							}
							if (node.nodeName === "BR" && ((node.nextSibling && node.nextSibling.nodeName === "BR") || i === 0)) { //two consecutive <br> tags signify a new [empty] line. Also, if the entire block of content STARTS with a <br>, add a line.
								lines.push([]);
							}
						}
					}
				}
			}

			for (i = 0; i < l; i++) {
				node = nodes[i];
				isChild = (node.parentNode === element);
				if (node.nodeName === "BR") {
					if (lines || absolute) {
						if (node.parentNode) {
							node.parentNode.removeChild(node);
						}
						nodes.splice(i--, 1);
						l--;
					} else if (!words) {
						element.appendChild(node);
					}
					continue;
				}

				if (absolute) {
					style = node.style;
					if (!words && !isChild) {
						node._x += node.parentNode._x;
						node._y += node.parentNode._y;
					}
					style.left = node._x + "px";
					style.top = node._y + "px";
					style.position = "absolute";
					style.display = "block";
					//if we don't set the width/height, things collapse in older versions of IE and the origin for transforms is thrown off in all browsers.
					style.width = (node._w + 1) + "px"; //IE is 1px short sometimes. Avoid wrapping
					style.height = node._h + "px";
				}

				if (!words && chars) {
					//we always start out wrapping words in their own <div> so that line breaks happen correctly, but here we'll remove those <div> tags if necessary and renest the characters directly into the element rather than inside the word <div>
					if (node._isSplit) {
						node._next = node.nextSibling;
						node.parentNode.appendChild(node); //put it at the end to keep the order correct.

					} else if (node.parentNode._isSplit) {
						node._parent = node.parentNode;
						if (!node.previousSibling && node.firstChild) {
							node.firstChild._isFirst = true;
						}
						if (node.nextSibling && node.nextSibling.textContent === " " && !node.nextSibling.nextSibling) { //if the last node inside a nested element is just a space (like T<span>nested </span>), remove it otherwise it'll get placed in the wrong order. Don't remove it right away, though, because we need to sense when words/characters are before a space like _isBeforeWordDelimiter(). Removing it now would make that a false negative.
							spaceNodesToRemove.push(node.nextSibling);
						}
						node._next = (node.nextSibling && node.nextSibling._isFirst) ? null : node.nextSibling;
						node.parentNode.removeChild(node);
						nodes.splice(i--, 1);
						l--;
					} else if (!isChild) {
						offset = (!node.nextSibling && _isBeforeWordDelimiter(node.parentNode, element, wordDelimiter)); //if this is the last letter in the word (and we're not breaking by lines and not positioning things absolutely), we need to add a space afterwards so that the characters don't just mash together
						if (node.parentNode._parent) {
							node.parentNode._parent.appendChild(node);
						}
						if (offset) {
							node.parentNode.appendChild(_doc.createTextNode(" "));
						}
						if (vars.span) {
							node.style.display = "inline"; //so that word breaks are honored properly.
						}
						charArray.push(node);
					}
				} else if (node.parentNode._isSplit && !node._isSplit && node.innerHTML !== "") {
					wordArray.push(node);
				} else if (chars && !node._isSplit) {
					if (vars.span) {
						node.style.display = "inline";
					}
					charArray.push(node);
				}
			}

			i = spaceNodesToRemove.length;
			while (--i > -1) {
				spaceNodesToRemove[i].parentNode.removeChild(spaceNodesToRemove[i]);
			}

			if (lines) {
				//the next 7 lines just give us the line width in the most reliable way and figure out the left offset (if position isn't relative or absolute). We must set the width along with text-align to ensure everything works properly for various alignments.
				if (absolute) {
					lineNode = _doc.createElement(tag);
					element.appendChild(lineNode);
					lineWidth = lineNode.offsetWidth + "px";
					offset = (lineNode.offsetParent === element) ? 0 : element.offsetLeft;
					element.removeChild(lineNode);
				}
				style = element.style.cssText;
				element.style.cssText = "display:none;"; //to improve performance, set display:none on the element so that the browser doesn't have to worry about reflowing or rendering while we're renesting things. We'll revert the cssText later.
				//we can't use element.innerHTML = "" because that causes IE to literally delete all the nodes and their content even though we've stored them in an array! So we must loop through the children and remove them.
				while (element.firstChild) {
					element.removeChild(element.firstChild);
				}
				addWordSpaces = (wordDelimiter === " " && (!absolute || (!words && !chars)));
				for (i = 0; i < lines.length; i++) {
					curLine = lines[i];
					lineNode = _doc.createElement(tag);
					lineNode.style.cssText = "display:block;text-align:" + textAlign + ";position:" + (absolute ? "absolute;" : "relative;");
					if (linesClass) {
						lineNode.className = linesClass + (iterateLine ? i+1 : "");
					}
					lineArray.push(lineNode);
					l = curLine.length;
					for (j = 0; j < l; j++) {
						if (curLine[j].nodeName !== "BR") {
							node = curLine[j];
							lineNode.appendChild(node);
							if (addWordSpaces && node._wordEnd) {
								lineNode.appendChild(_doc.createTextNode(" "));
							}
							if (absolute) {
								if (j === 0) {
									lineNode.style.top = (node._y) + "px";
									lineNode.style.left = (paddingLeft + offset) + "px";
								}
								node.style.top = "0px";
								if (offset) {
									node.style.left = (node._x - offset) + "px";
								}
							}
						}
					}
					if (l === 0) { //if there are no nodes in the line (typically meaning there were two consecutive <br> tags, just add a non-breaking space so that things display properly.
						lineNode.innerHTML = "&nbsp;";
					} else if (!words && !chars) {
						_deWordify(lineNode);
						_swapText(lineNode, String.fromCharCode(160), " ");
					}
					if (absolute) {
						lineNode.style.width = lineWidth;
						lineNode.style.height = node._h + "px";
					}
					element.appendChild(lineNode);
				}
				element.style.cssText = style;
			}

			//if everything shifts to being position:absolute, the container can collapse in terms of height or width, so fix that here.
			if (absolute) {
				if (origHeight > element.clientHeight) {
					element.style.height = (origHeight - padTopAndBottom) + "px";
					if (element.clientHeight < origHeight) { //IE8 and earlier use a different box model - we must include padding and borders
						element.style.height = (origHeight + borderTopAndBottom)+ "px";
					}
				}
				if (origWidth > element.clientWidth) {
					element.style.width = (origWidth - padLeftAndRight) + "px";
					if (element.clientWidth < origWidth) { //IE8 and earlier use a different box model - we must include padding and borders
						element.style.width = (origWidth + borderLeftAndRight)+ "px";
					}
				}
			}
			_pushReversed(allChars, charArray);
			_pushReversed(allWords, wordArray);
			_pushReversed(allLines, lineArray);
		},
		_splitRawText = function(element, vars, wordStart, charStart) {
			var tag = vars.span ? "span" : "div",
				types = vars.type || vars.split || "chars,words,lines",
				//words = (types.indexOf("words") !== -1),
				chars = (types.indexOf("chars") !== -1),
				absolute = (vars.position === "absolute" || vars.absolute === true),
				wordDelimiter = vars.wordDelimiter || " ",
				space = wordDelimiter !== " " ? "" : (absolute ? "&#173; " : " "),
				wordEnd = vars.span ? "</span>" : "</div>",
				wordIsOpen = true,
				text, splitText, i, j, l, character, hasTagStart, emojiPair1, emojiPair2,
				container = _doc.createElement("div"),
				parent = element.parentNode;

			parent.insertBefore(container, element);
			container.textContent = element.nodeValue;
			parent.removeChild(element);
			element = container;
			text = _getText(element);
			hasTagStart = text.indexOf("<") !== -1;

			if (vars.reduceWhiteSpace !== false) {
				text = text.replace(_multipleSpacesExp, " ").replace(_stripExp, "");
			}
			if (hasTagStart) {
				text = text.split("<").join("{{LT}}"); //we can't leave "<" in the string, or when we set the innerHTML, it can be interpreted as a node
			}
			l = text.length;
			splitText = ((text.charAt(0) === " ") ? space : "") + wordStart();
			for (i = 0; i < l; i++) {
				character = text.charAt(i);
				if (character === wordDelimiter && text.charAt(i-1) !== wordDelimiter && i) {
					splitText += wordIsOpen ? wordEnd : "";
					wordIsOpen = false;
					while (text.charAt(i + 1) === wordDelimiter) { //skip over empty spaces (to avoid making them words)
						splitText += space;
						i++;
					}
					if (i === l-1) {
						splitText += space;
					} else if (text.charAt(i + 1) !== ")") {
						splitText += space + wordStart();
						wordIsOpen = true;
					}

				} else if (character === "{" && text.substr(i, 6) === "{{LT}}") {
					splitText += chars ? charStart() + "{{LT}}" + "</" + tag + ">" : "{{LT}}";
					i += 5;

				} else if ((character.charCodeAt(0) >= _emojiStart && character.charCodeAt(0) <= _emojiEnd) || (text.charCodeAt(i+1) >= 0xFE00 && text.charCodeAt(i+1) <= 0xFE0F)) { //special emoji characters use 2 or 4 unicode characters that we must keep together.
					emojiPair1 = _emojiPairCode(text.substr(i, 2));
					emojiPair2 = _emojiPairCode(text.substr(i + 2, 2));
					j = ((emojiPair1 >= _emojiRegionStart && emojiPair1 <= _emojiRegionEnd && emojiPair2 >= _emojiRegionStart && emojiPair2 <= _emojiRegionEnd) || (emojiPair2 >= _emojiModStart && emojiPair2 <= _emojiModEnd)) ? 4 : 2;
					splitText += (chars && character !== " ") ? charStart() + text.substr(i, j) + "</" + tag + ">" : text.substr(i, j);
					i += j - 1;
				} else {
					splitText += (chars && character !== " ") ? charStart() + character + "</" + tag + ">" : character;
				}
			}
			element.outerHTML = splitText + (wordIsOpen ? wordEnd : "");
			if (hasTagStart) {
				_swapText(parent, "{{LT}}", "<"); //note: don't perform this on "element" because that gets replaced with all new elements when we set element.outerHTML.
			}
		},
		_split = function(element, vars, wordStart, charStart) {
			var children = _slice(element.childNodes),
				l = children.length,
				absolute = (vars.position === "absolute" || vars.absolute === true),
				i, child;

			if (element.nodeType !== 3 || l > 1) {
				vars.absolute = false;
				for (i = 0; i < l; i++) {
					child = children[i];
					if (child.nodeType !== 3 || /\S+/.test(child.nodeValue)) {
						if (absolute && child.nodeType !== 3 && _getStyle(child, "display", null, true) === "inline") { //if there's a child node that's display:inline, switch it to inline-block so that absolute positioning works properly (most browsers don't report offsetTop/offsetLeft properly inside a <span> for example)
							child.style.display = "inline-block";
							child.style.position = "relative";
						}
						child._isSplit = true;
						_split(child, vars, wordStart, charStart); //don't split lines on child elements
					}
				}
				vars.absolute = absolute;
				element._isSplit = true;
				return;
			}

			_splitRawText(element, vars, wordStart, charStart);

		},
		p = SplitText.prototype;

	p.split = function(vars) {
		if (this.isSplit) {
			this.revert();
		}
		this.vars = vars = vars || this.vars;
		this._originals.length = this.chars.length = this.words.length = this.lines.length = 0;
		var i = this.elements.length,
			tag = vars.span ? "span" : "div",
			wordStart = _cssClassFunc(vars.wordsClass, tag),
			charStart = _cssClassFunc(vars.charsClass, tag),
			origHeight, origWidth, e;
		//we split in reversed order so that if/when we position:absolute elements, they don't affect the position of the ones after them in the document flow (shifting them up as they're taken out of the document flow).
		while (--i > -1) {
			e = this.elements[i];
			this._originals[i] = e.innerHTML;
			origHeight = e.clientHeight;
			origWidth = e.clientWidth;
			_split(e, vars, wordStart, charStart);
			_setPositionsAfterSplit(e, vars, this.chars, this.words, this.lines, origWidth, origHeight);
		}
		this.chars.reverse();
		this.words.reverse();
		this.lines.reverse();
		this.isSplit = true;
		return this;
	};

	p.revert = function() {
		if (!this._originals) {
			throw("revert() call wasn't scoped properly.");
		}
		var i = this._originals.length;
		while (--i > -1) {
			this.elements[i].innerHTML = this._originals[i];
		}
		this.chars = [];
		this.words = [];
		this.lines = [];
		this.isSplit = false;
		return this;
	};

	SplitText.selector = window.$ || window.jQuery || function(e) {
		var selector = window.$ || window.jQuery;
		if (selector) {
			SplitText.selector = selector;
			return selector(e);
		}
		return (typeof(document) === "undefined") ? e : (document.querySelectorAll ? document.querySelectorAll(e) : document.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
	};
	SplitText.version = "0.5.8";
	
})(_gsScope);

//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
(function(name) {
	"use strict";
	var getGlobal = function() {
		return (_gsScope.GreenSockGlobals || _gsScope)[name];
	};
	if (typeof(module) !== "undefined" && module.exports) { //node
		module.exports = getGlobal();
	} else if (typeof(define) === "function" && define.amd) { //AMD
		define([], getGlobal);
	}
}("SplitText"));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "GBx5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RbiScheduler_vue__ = __webpack_require__("ngXg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d045acb4_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RbiScheduler_vue__ = __webpack_require__("0xWZ");
function injectStyle (ssrContext) {
  __webpack_require__("DNKD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d045acb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RbiScheduler_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d045acb4_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RbiScheduler_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gffb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__("+Uzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'featured-grid',
  data: function data() {
    return {
      itemHover: false,
      items: [{
        slug: 'olasio',
        hover: false
      }, {
        slug: 'rbi-website',
        hover: false
      }, {
        slug: 'transcope',
        hover: false
      }, {
        slug: 'teamable',
        hover: false
      }, {
        slug: 'biscuit',
        hover: false
      }]
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].staggerFrom('.grid > figure', 1, {
      y: 50,
      opacity: 0,
      ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeOut,
      delay: 1.0
    }, 0.1); // TweenMax

    __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].from(this.$refs.subTitleFeatured, 0.3, {
      opacity: 0,
      delay: 1.0
    }); // TweenMax

    __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].from(this.$refs.subTitleFeatured.querySelector('span'), 1, {
      x: 100,
      opacity: 0,
      ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeOut,
      delay: 1.0
    });
  }
});

/***/ }),

/***/ "Gin+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H/xS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scrollmagic__ = __webpack_require__("A8vr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ScrollMagicIndicator__ = __webpack_require__("2Pud");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ScrollMagicIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ScrollMagicIndicator__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-body',
  data: function data() {
    return {
      controller: '',
      menuBtnScene: '',
      revealScene: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('inHeader');
    this.controller = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Controller();
    this.menuBtnScene = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
      triggerElement: this.$refs.content
    }).on('enter leave', function (e) {
      if (e.type === 'enter') {
        _this.$store.commit('outHeader');
      } else {
        _this.$store.commit('inHeader');
      }
    }).addTo(this.controller);

    this.$refs.content.childNodes.forEach(function (item) {
      if (item.nodeType === Node.ELEMENT_NODE) {
        item.classList.add('mounted');

        _this.revealScene = new __WEBPACK_IMPORTED_MODULE_0_scrollmagic___default.a.Scene({
          triggerElement: item,
          triggerHook: 'onEnter',
          offset: 200
        })
        // .addIndicators()
        .on('enter leave', function (e) {
          if (e.type === 'enter') {
            item.classList.add('reveal');
          } else {
            item.classList.remove('reveal');
          }
        }).addTo(_this.controller);
      }
    }); // forEach

    this.$refs.content.classList.add('loaded');
  },
  // mounted
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('outHeader');
    this.controller.destroy();
    this.controller = '';
    this.menuBtnScene = '';
    this.revealScene = '';
  }
});

/***/ }),

/***/ "H18i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('site-title',{attrs:{"text":'Photos by Jason',"textDelay":0.5}}),_vm._v(" "),_c('text-block',{attrs:{"revealTransition":true,"marginLess":true,"quoteType":true}},[_vm._v("“What I like about photographs is that they capture a moment that’s gone forever, impossible to reproduce.” "),_c('cite',[_vm._v("— Karl Lagerfeld")])])],1),_vm._v(" "),_c('article',{ref:"pictures"},[(this.$store.state.flickrData)?_c('div',{staticClass:"frames"},_vm._l((this.$store.state.flickrData.slice(0, this.$store.state.numberOfPhoto)),function(image){return _c('figure',{key:image.id},[_c('img',{attrs:{"src":image.url_h,"alt":image.title}}),_vm._v(" "),_c('figcaption',[_vm._v(_vm._s(image.title))])])})):_c('div',{staticClass:"frames"},_vm._l((6),function(n){return _c('figure',{key:n},[_c('div',{staticClass:"img-placeholder"}),_vm._v(" "),_c('figcaption',[_vm._v("Loading..")])])})),_vm._v(" "),_c('div',{ref:"loadTrigger"})]),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HPGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transcope_vue__ = __webpack_require__("ugqt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ce0a9db_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transcope_vue__ = __webpack_require__("3up/");
function injectStyle (ssrContext) {
  __webpack_require__("0T80")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ce0a9db"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transcope_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ce0a9db_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transcope_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HQxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Magritte_vue__ = __webpack_require__("7wV8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94aa5d4c_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Magritte_vue__ = __webpack_require__("mTkj");
function injectStyle (ssrContext) {
  __webpack_require__("UM5L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94aa5d4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Magritte_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94aa5d4c_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Magritte_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HW4H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("dPB5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e031ec_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("yuix");
function injectStyle (ssrContext) {
  __webpack_require__("x0EL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43e031ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e031ec_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I9NK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IF4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedGrid_vue__ = __webpack_require__("Gffb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e5eac07_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturedGrid_vue__ = __webpack_require__("9GbO");
function injectStyle (ssrContext) {
  __webpack_require__("vRXY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e5eac07"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeaturedGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e5eac07_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeaturedGrid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IbzO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("Biscuit is a multi-platform and cloud-based dictionary made by South Korean startup company Croquis, where I worked as a lead designer for about two years.")]),_vm._v(" "),_c('img',{staticClass:"mw630",attrs:{"src":_vm.imagePath + 'works-biscuit-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("We made Biscuit with the aim of creating a better dictionary that fits the mobile environment. While other dictionary apps focused on their content, we focused on the experience.")]),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-biscuit-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-biscuit-03.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-biscuit-04.png',"alt":this.$options.name}})]),_vm._v(" "),_c('p',[_vm._v("Mobile OSs have improved recently, but when we started this project, checking the meaning of a word in a smartphone dictionary was a really painful process. Moreover, it always required more unnecessary effort to learn the vocabulary words later."),_c('br'),_c('br'),_vm._v("Biscuit astonishingly reduces these painful steps using the notification center on iOS and making a definition popup for Android. When Biscuit is running in the background, the user can copy the word to check its definition and hear its pronunciation instantly.")]),_vm._v(" "),_c('div',{staticClass:"embed"},[_c('figure',[_c('iframe',{attrs:{"src":"https://player.vimeo.com/video/98535214?title=0&byline=0&portrait=0","width":"1140","height":"641","frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])]),_vm._v(" "),_c('p',[_vm._v("An app should allow users to achieve their goal by the same amount of effort, in any device. Therefore, it’s reasonable to maintain the core part as similarly as possible, while the structure of the app should be similar to each OS's interface that the users are already comfortable with.")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-biscuit-05.png',"alt":this.$options.name}}),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-biscuit-06.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-biscuit-07.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-biscuit-08.jpg',"alt":this.$options.name}})]),_vm._v(" "),_c('p',[_vm._v("The logo is designed to be simple, clear, and geometric instead of being too descriptive about the product or the name.")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-biscuit-09.svg',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("The team’s goal was to cover as many devices as possible, so we spent many time and effort to design and develop Biscuit for mobile, tablet, wearables and desktop.")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-biscuit-10.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"mw600",attrs:{"src":_vm.imagePath + 'works-biscuit-11.svg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"mw280",attrs:{"src":_vm.imagePath + 'works-biscuit-12.png',"alt":this.$options.name}}),_vm._v(" "),_c('div',{staticClass:"embed"},[_c('figure',[_c('iframe',{attrs:{"src":"https://player.vimeo.com/video/70011200?title=0&byline=0&portrait=0","width":"1140","height":"641","frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])]),_vm._v(" "),_c('p',[_vm._v("We wanted to make the desktop version of Biscuit as a seamless dictionary that can be used for reading articles, so we decided to develop a browser extension instead of a standalone application.")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-biscuit-13.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("The desktop environment has more states than touch interfaces, such as hover and focus states. These small differences are crucial for designers to consider, because the level of understanding and the proper use of those states could decide the quality of the application.")]),_vm._v(" "),_c('img',{staticClass:"mw730",attrs:{"src":_vm.imagePath + 'works-biscuit-14.png',"alt":this.$options.name}}),_vm._v(" "),_c('div',{staticClass:"embed"},[_c('figure',[_c('iframe',{attrs:{"src":"https://player.vimeo.com/video/99317816?title=0&byline=0&portrait=0","width":"1140","height":"641","frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])]),_vm._v(" "),_c('div',{staticClass:"cols col-2-row-4"},[_c('img',{attrs:{"src":_vm.imagePath + 'works-biscuit-15.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-biscuit-16.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-biscuit-17.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-biscuit-18.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-biscuit-19.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-biscuit-20.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-biscuit-21.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-biscuit-22.jpg',"alt":this.$options.name}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JOi6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JTu9":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 363.9 37.1\"><path d=\"M30.2 6.5H18.6v30h-7v-30H0V.3h30.2v6.2zm12.1 30.1V.4h16c1.7 0 3.2.3 4.6 1s2.6 1.6 3.6 2.8c1 1.1 1.8 2.4 2.4 3.9.6 1.4.9 2.9.9 4.4 0 2.3-.6 4.5-1.8 6.4-1.2 1.9-2.8 3.3-4.8 4.2l8.3 13.6h-7.9l-7.4-12.1h-6.9v12.1l-7-.1c0 .1 0 0 0 0zm7.1-18.3h8.8c.6 0 1.3-.2 1.8-.5.6-.3 1-.7 1.5-1.2.4-.5.7-1.1 1-1.9.2-.7.4-1.5.4-2.3s-.1-1.6-.4-2.3c-.3-.7-.6-1.3-1.1-1.9-.5-.5-1-.9-1.6-1.2-.6-.3-1.2-.4-1.8-.4h-8.5v11.7h-.1zM93.6.4h6.2l13.8 36.2h-7.2l-3.4-9H90.4l-3.3 9h-7.2L93.6.4zm8.2 22.2l-5-14.2-5.2 14.2h10.2zm30.5-9.2v23.2h-7V.4h5.5l18.9 23.8V.4h7v36.2H151l-18.7-23.2zm61.1-3.5c-.2-.2-.7-.6-1.3-1s-1.4-.8-2.3-1.2c-.9-.4-1.9-.7-2.9-1-1.1-.3-2.1-.4-3.2-.4-1.9 0-3.4.4-4.3 1.1-1 .7-1.4 1.7-1.4 3 0 .7.2 1.4.5 1.9.4.5.9.9 1.6 1.3.7.4 1.5.7 2.6 1 1 .3 2.2.6 3.6 1 1.8.5 3.4 1 4.8 1.5s2.7 1.2 3.7 2 1.8 1.8 2.3 2.9.8 2.5.8 4.2c0 1.9-.4 3.6-1.1 5-.7 1.4-1.7 2.5-3 3.3-1.2.9-2.7 1.5-4.3 1.9s-3.3.6-5.1.6c-2.7 0-5.4-.4-8.1-1.2-2.7-.8-5-2-7.1-3.5l3.1-6.1c.3.3.9.7 1.7 1.2s1.7 1 2.8 1.5 2.3.9 3.6 1.2 2.7.5 4.1.5c3.9 0 5.8-1.2 5.8-3.7 0-.8-.2-1.4-.7-2-.4-.5-1.1-1-1.9-1.4-.8-.4-1.8-.8-3-1.1s-2.4-.7-3.9-1.1c-1.7-.5-3.2-1-4.5-1.6s-2.3-1.2-3.2-2-1.5-1.6-1.9-2.7c-.4-1-.6-2.2-.6-3.6 0-1.8.3-3.5 1-4.9s1.6-2.6 2.8-3.6 2.6-1.7 4.2-2.2c1.6-.5 3.3-.7 5.2-.7 2.6 0 4.9.4 7 1.2s4 1.7 5.6 2.8l-3 5.9zm15.2 8.3c0-2.2.4-4.4 1.2-6.6s2-4.1 3.5-5.8 3.4-3.1 5.6-4.1c2.2-1.1 4.7-1.6 7.6-1.6 3.3 0 6.2.7 8.6 2.2 2.4 1.5 4.2 3.4 5.4 5.7l-5.4 3.7c-.5-1-1.1-1.9-1.7-2.6-.7-.7-1.4-1.3-2.2-1.7-.8-.4-1.6-.7-2.4-.9-.9-.2-1.7-.3-2.5-.3-1.8 0-3.3.4-4.6 1.1s-2.4 1.6-3.3 2.8c-.9 1.1-1.5 2.4-2 3.9-.4 1.4-.7 2.9-.7 4.3 0 1.6.3 3.1.8 4.6s1.2 2.8 2.2 3.9c.9 1.1 2.1 2 3.4 2.7 1.3.7 2.7 1 4.3 1 .8 0 1.7-.1 2.6-.3.9-.2 1.7-.5 2.5-1 .8-.4 1.5-1 2.2-1.7s1.2-1.5 1.6-2.5l5.8 3.3c-.6 1.4-1.4 2.6-2.5 3.6s-2.3 1.9-3.6 2.6-2.8 1.3-4.3 1.6c-1.5.4-3 .6-4.5.6-2.6 0-4.9-.5-7.1-1.6-2.1-1.1-4-2.5-5.5-4.3s-2.8-3.7-3.6-6c-1-2-1.4-4.3-1.4-6.6zm59.9 18.6c-2.7 0-5.1-.5-7.2-1.6-2.2-1-4-2.4-5.6-4.1-1.5-1.7-2.7-3.7-3.6-5.9-.9-2.2-1.3-4.5-1.3-6.8 0-2.4.5-4.7 1.4-6.9s2.1-4.2 3.7-5.9c1.6-1.7 3.5-3.1 5.6-4.1 2.2-1 4.5-1.5 7.1-1.5s5 .5 7.2 1.6 4 2.5 5.5 4.2 2.7 3.7 3.6 5.9c.8 2.2 1.3 4.5 1.3 6.7 0 2.4-.4 4.7-1.3 6.9s-2.1 4.1-3.7 5.8-3.4 3-5.6 4c-2.2 1.2-4.5 1.7-7.1 1.7zM258 18.5c0 1.6.2 3.1.7 4.5.5 1.5 1.2 2.8 2.1 3.9s2 2 3.3 2.7 2.8 1 4.5 1 3.2-.3 4.5-1 2.4-1.6 3.3-2.8 1.6-2.5 2-3.9c.5-1.4.7-2.9.7-4.4 0-1.6-.2-3.1-.7-4.5-.5-1.5-1.2-2.8-2.1-3.9s-2-2-3.3-2.7-2.8-1-4.4-1c-1.7 0-3.2.3-4.5 1s-2.4 1.6-3.3 2.8c-.9 1.1-1.6 2.4-2 3.9-.6 1.4-.8 2.9-.8 4.4zm41.3 18.1V.4h15.4c1.7 0 3.2.3 4.6 1s2.6 1.6 3.6 2.8c1 1.1 1.8 2.4 2.4 3.9.6 1.4.9 2.9.9 4.4s-.3 3-.8 4.5c-.5 1.4-1.3 2.7-2.3 3.9-1 1.1-2.2 2-3.6 2.7s-2.9 1-4.6 1h-8.6v12.1h-7v-.1zm7-18.3h8.2c1.3 0 2.4-.5 3.2-1.6.9-1.1 1.3-2.5 1.3-4.3 0-.9-.1-1.7-.4-2.5-.3-.7-.6-1.4-1.1-1.9-.4-.5-1-.9-1.6-1.1-.6-.3-1.2-.4-1.8-.4h-7.9l.1 11.8zm57.6 12.1v6.2h-25.1V.4h24.7v6.2h-17.7v8.7h15.3V21h-15.3v9.4h18.1z\" class=\"__30NUIWj__st0 \"></path></svg>"

/***/ }),

/***/ "JnOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SiteTitle_vue__ = __webpack_require__("RKQU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__("+Uzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__script_SplitText__ = __webpack_require__("EyEd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__script_SplitText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__script_SplitText__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-header',
  props: ['bgColor'],
  components: {
    'site-title': __WEBPACK_IMPORTED_MODULE_0__components_SiteTitle_vue__["a" /* default */]
  },
  data: function data() {
    return {
      headerTimeline: null
    };
  },

  computed: {
    style: function style() {
      return 'background-color: ' + this.bgColor;
    }
  },
  beforeMount: function beforeMount() {
    this.headerTimeline = new __WEBPACK_IMPORTED_MODULE_1_gsap__["TimelineMax"]({ paused: true });
  },
  mounted: function mounted() {
    // Header
    this.headerTimeline.fromTo(this.$refs.headerFill, 1.4, { height: '0%' }, { height: '100%', ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power4"].easeInOut, force3D: true }, '+=0.5');

    // Project info list
    var headerInfoList = [];

    this.$refs.headerInfo.childNodes.forEach(function (listItem) {
      if (listItem.nodeType === Node.ELEMENT_NODE) {
        headerInfoList.push(listItem);
      }
    });
    this.headerTimeline.staggerFromTo(headerInfoList, 1, { opacity: 0, y: 30 }, { opacity: 1, y: 0, ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power3"].easeOut }, 0.04);

    // Icon down
    this.headerTimeline.fromTo(this.$refs.iconDown, 1, { y: -20, opacity: 0 }, { y: 0, opacity: 1, ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power3"].easeOut }, '-=0.5');

    this.headerTimeline.restart();
  },
  updated: function updated() {
    // Project title
    var projectTitleSplit = new __WEBPACK_IMPORTED_MODULE_2__script_SplitText___default.a(this.$parent.$refs.projectTitle, { type: 'words' });
    __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].staggerFrom(projectTitleSplit.words, 1, {
      y: 100,
      ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power3"].easeOut,
      delay: 1.2,
      onComplete: function onComplete() {
        projectTitleSplit.revert();
      }
    }, 0.1);
  }
});

/***/ }),

/***/ "JoHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{ref:"contentFooter"},[_c('ul',{staticClass:"footer-info"},[_c('li',[_c('u',[_vm._v("Project")]),_vm._v(" "),_vm._t("projectTitle")],2),_vm._v(" "),_c('li',[_c('u',[_vm._v("Year")]),_vm._v(" "),_vm._t("year")],2),_vm._v(" "),_c('li',[_c('u',[_vm._v("Team")]),_vm._v(" "),_vm._t("team")],2),_vm._v(" "),_c('li',[_c('u',[_vm._v("Participation")]),_vm._v(" "),_vm._t("participation")],2)]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/works/' + _vm.nextSlug }}},[_c('div',{staticClass:"footer-next",style:(_vm.nextProjectStyle)},[_c('hgroup',[_c('i',[_vm._v("Next project")]),_vm._v(" "),_vm._t("nextProject")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jpyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBlock_vue__ = __webpack_require__("loMn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_001af83d_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextBlock_vue__ = __webpack_require__("7Q93");
function injectStyle (ssrContext) {
  __webpack_require__("hKuE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-001af83d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_001af83d_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KFcL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectFooter_vue__ = __webpack_require__("zai1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262b5a9c_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectFooter_vue__ = __webpack_require__("JoHH");
function injectStyle (ssrContext) {
  __webpack_require__("JOi6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-262b5a9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262b5a9c_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KMdB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KmIK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkList_vue__ = __webpack_require__("MKRp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_433021e7_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkList_vue__ = __webpack_require__("zUDM");
function injectStyle (ssrContext) {
  __webpack_require__("l0Ad")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-433021e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_433021e7_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KtWP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'granton',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "KvrH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KyEk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Works_vue__ = __webpack_require__("TNak");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e2b8023_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Works_vue__ = __webpack_require__("gk9y");
function injectStyle (ssrContext) {
  __webpack_require__("c/lV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e2b8023"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Works_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e2b8023_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Works_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L2Wx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mercer_vue__ = __webpack_require__("+8F3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225c0012_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mercer_vue__ = __webpack_require__("UK4w");
function injectStyle (ssrContext) {
  __webpack_require__("4zz7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-225c0012"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mercer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225c0012_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mercer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lvoq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__("+Uzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidenav',
  data: function data() {
    return {
      menuHover: false,
      navOpened: false,
      navTransitionTl: null,
      navItems: [{
        label: 'Home',
        description: 'The first page.',
        routePath: '/',
        exactPath: true,
        hover: false
      }, {
        label: 'Works',
        description: 'Selected projects.',
        routePath: '/works',
        exactPath: false,
        hover: false
      }, {
        label: 'Photos',
        description: 'Pictures I took.',
        routePath: '/photos',
        exactPath: false,
        hover: false
      }, {
        label: 'About',
        description: 'Quick brief about myself.',
        routePath: '/about',
        exactPath: false,
        hover: false
      }],
      navItemHover: false
    };
  },

  computed: {
    menuInHeader: function menuInHeader() {
      return this.$store.state.menuBtnInHeader;
    }
  },
  methods: {
    navToggle: function navToggle(event) {
      var _this = this;

      this.navOpened = !this.navOpened;
      document.getElementById('matters').classList.toggle('opened');

      if (this.navOpened) {
        this.navTransitionTl.restart();
      } else {
        setTimeout(function () {
          if (_this.navOpened === false) {
            __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].set('.nav-item', { display: 'none' });
          }
        }, 400);
      }
    },
    navMouseEnter: function navMouseEnter(event) {
      this.menuHover = true;
    },
    navMouseLeave: function navMouseLeave(event) {
      this.menuHover = false;
    },
    navItemMouseEnter: function navItemMouseEnter(i) {
      this.navItemHover = true;
      this.navItems[i].hover = true;
    },
    navItemMouseLeave: function navItemMouseLeave(i) {
      this.navItemHover = false;
      this.navItems[i].hover = false;
    },
    navItemClick: function navItemClick(event) {
      var _this2 = this;

      this.navOpened = !this.navOpened;
      document.getElementById('matters').classList.toggle('opened');
      setTimeout(function () {
        if (_this2.navOpened === false) {
          __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].set('.nav-item', { display: 'none' });
        }
      }, 400);
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].set('.nav-item', { display: 'none' });

    this.navTransitionTl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });
    this.navTransitionTl.set('.nav-item', { display: 'block' });
    this.navTransitionTl.staggerFromTo('.nav-item h1', 1.2, { opacity: 0 }, { opacity: 1, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power2"].easeOut, force3D: true }, 0.1, 0);
    this.navTransitionTl.staggerFromTo('.nav-item h1', 1, { x: 200 }, { x: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeOut, force3D: true }, 0.05, 0);
    this.navTransitionTl.staggerFromTo('.nav-item em', 1.2, { opacity: 0 }, { opacity: 0.2, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power2"].easeOut, force3D: true }, 0.1, 0.3);
    this.navTransitionTl.staggerFromTo('.nav-item em', 1, { x: 20 }, { x: 0, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power4"].easeOut, force3D: true }, 0.05, 0.3);
  }
});

/***/ }),

/***/ "M2xv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WikiPrice_vue__ = __webpack_require__("Ogyp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8127827c_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WikiPrice_vue__ = __webpack_require__("QYk7");
function injectStyle (ssrContext) {
  __webpack_require__("SJpK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8127827c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WikiPrice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8127827c_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WikiPrice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42806fa7_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("as5o");
function injectStyle (ssrContext) {
  __webpack_require__("30DY")
  __webpack_require__("NRRd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42806fa7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42806fa7_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MKRp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__("+Uzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scrollmagic__ = __webpack_require__("A8vr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WorkListItem_vue__ = __webpack_require__("yLFQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'work-list',
  props: ['listType'],
  components: { 'work-list-item': __WEBPACK_IMPORTED_MODULE_3__components_WorkListItem_vue__["a" /* default */] },
  data: function data() {
    return {
      items: '',
      theListType: ''
    };
  },
  created: function created() {
    var _this = this;

    var displayList = null;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/static/data/works.json').then(function (response) {
      if (_this.listType === 'latest') {
        displayList = response.data.projects.filter(function (work) {
          if (!work.featured) {
            return work;
          }
        });
      } else {
        displayList = response.data.projects;
      }
      _this.items = displayList;
    }).catch(function (error) {
      console.log(error);
    });
  },
  mounted: function mounted() {
    this.theListType = this.listType;
    __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].from(this.$refs.latestList, 0.7, { opacity: 0, delay: 0.5 });
  },
  updated: function updated() {
    var controller = new __WEBPACK_IMPORTED_MODULE_2_scrollmagic___default.a.Controller();

    this.$refs.latestList.childNodes.forEach(function (item) {
      if (item.nodeType === Node.ELEMENT_NODE) {
        item.classList.add('mounted');

        new __WEBPACK_IMPORTED_MODULE_2_scrollmagic___default.a.Scene({
          triggerElement: item,
          triggerHook: 'onEnter',
          offset: 200
        }).on('enter leave', function (e) {
          if (e.type === 'enter') {
            item.classList.add('reveal');
          } else {
            item.classList.remove('reveal');
          }
        }).addTo(controller);
      }
    }); // forEach
  }
});

/***/ }),

/***/ "MzWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

// see vue-loader.conf
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['src', 'context']
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css__ = __webpack_require__("uMhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_store_js__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_webfontloader__ = __webpack_require__("01M/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_webfontloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_webfontloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Vector__ = __webpack_require__("mBR5");
/*** IMPORTS FROM imports-loader ***/
var define = false;

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_5_webfontloader___default.a.load({
  // custom: {
  //   families: ['SF Display'],
  //   urls: ['../static/fonts/fonts.css']
  // }
  google: {
    families: ['Roboto:300,400,500']
  },
  classes: false,
  timeout: 2000
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('vector', __WEBPACK_IMPORTED_MODULE_6__components_Vector__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  store: __WEBPACK_IMPORTED_MODULE_4__vuex_store_js__["a" /* default */],
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NRRd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nrlj":
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Ogyp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wikiprice',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "P8nJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("The Granton's design concept is done by One Fell Swoop, and I was participated in website's design. The goal was to keep the same visual language, but also translate it into interactive inteface design.")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-granton-01.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-granton-02.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-granton-03.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-granton-04.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-granton-05.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-granton-06.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-granton-07.png',"alt":this.$options.name}}),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-granton-m-01.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-granton-m-02.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-granton-m-03.jpg',"alt":this.$options.name}})]),_vm._v(" "),_c('p',[_vm._v("The layout designs are based on number of modules, so it's easy to maintain and scale.")]),_vm._v(" "),_c('div',{staticClass:"cols col-2-row-4"},[_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-granton-module-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-granton-module-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-granton-module-03.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-granton-module-04.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-granton-module-05.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-granton-module-06.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-granton-module-07.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-granton-module-08.png',"alt":this.$options.name}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PAk0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QA6N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QYk7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("Wikiprice was my major project during my last semester at Sydney Uni. The idea was to make an interactive currency comparison tool powered by people around the world, instead of some specific organisation.")]),_vm._v(" "),_c('img',{staticClass:"mw280",attrs:{"src":_vm.imagePath + 'works-wikiprice-00.svg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border shadow round",attrs:{"src":_vm.imagePath + 'works-wikiprice-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border shadow round",attrs:{"src":_vm.imagePath + 'works-wikiprice-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border shadow round",attrs:{"src":_vm.imagePath + 'works-wikiprice-03.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("This price comparison index is based on the theory of purchasing-power parity (PPP). Purchasing power parity is a component of some economic theories and is a technique used to determine the relative value of different currencies.")]),_vm._v(" "),_c('div',{staticClass:"cols col-2"},[_c('img',{staticClass:"border round",attrs:{"src":_vm.imagePath + 'works-wikiprice-04.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border round",attrs:{"src":_vm.imagePath + 'works-wikiprice-05.png',"alt":this.$options.name}})]),_vm._v(" "),_c('img',{staticClass:"mw800",attrs:{"src":_vm.imagePath + 'works-wikiprice-06.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"mw730 border",attrs:{"src":_vm.imagePath + 'works-wikiprice-07.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Sketches")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R0MY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rbi-emails',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "RKQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteTitle_vue__ = __webpack_require__("CIoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa91e7d4_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteTitle_vue__ = __webpack_require__("ij/B");
function injectStyle (ssrContext) {
  __webpack_require__("QA6N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa91e7d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa91e7d4_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RKkW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S0Vn":
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 263 139.9\" style=\"enable-background:new 0 0 263 139.9;\" xml:space=\"preserve\"><style type=\"text/css\"> .__2S2p4H8__st0{fill-rule:evenodd;clip-rule:evenodd;} </style><g><path d=\"M20.5,0c4.2,0,7.4,1,9.8,3.1c2.3,2,3.5,4.8,3.5,8.4c0,2.7-0.6,5-1.8,7s-3.1,3.4-5.8,4.1v0.1c1.3,0.2,2.3,0.7,3.1,1.2 c0.8,0.6,1.4,1.3,1.9,2c0.5,0.8,0.8,1.7,1,2.7s0.4,2,0.5,3.1s0.1,2.1,0.2,3.2c0,1.1,0.1,2.2,0.3,3.2c0.2,1.1,0.4,2.1,0.7,3 c0.3,1,0.8,1.8,1.4,2.5h-6.5c-0.4-0.4-0.7-1.1-0.8-1.8c-0.1-0.8-0.2-1.6-0.3-2.6c0-1-0.1-2-0.1-3.1s-0.2-2.2-0.4-3.2 c-0.2-1.1-0.4-2.1-0.6-3c-0.2-1-0.6-1.8-1.2-2.5c-0.5-0.7-1.2-1.3-2.1-1.7s-2-0.6-3.4-0.6H5.8v18.7H0V0H20.5z M21.7,19.8 c1.2-0.2,2.3-0.6,3.2-1.2c0.9-0.6,1.7-1.4,2.2-2.4c0.6-1,0.8-2.3,0.8-3.9c0-2.2-0.6-4-1.8-5.4s-3.2-2.1-5.9-2.1H5.8V20h12.1 C19.2,20.1,20.5,20,21.7,19.8z\"></path><path d=\"M54,0c0.9,0,1.9,0,3,0s2.2,0.1,3.2,0.2c1.1,0.1,2,0.3,3,0.5c0.9,0.2,1.7,0.5,2.4,0.9c1.4,0.9,2.6,2,3.6,3.5 s1.5,3.4,1.5,5.6c0,2.3-0.6,4.3-1.7,6s-2.7,2.9-4.8,3.8v0.1c2.7,0.6,4.8,1.8,6.2,3.7c1.4,1.9,2.1,4.2,2.1,6.9 c0,1.6-0.3,3.1-0.9,4.7c-0.6,1.5-1.4,2.8-2.5,4s-2.5,2.1-4.2,2.8s-3.6,1.1-5.7,1.1h-21V0H54z M55.6,18.7c3.3,0,5.7-0.6,7.1-1.7 c1.4-1.2,2.2-2.9,2.2-5.2c0-1.5-0.2-2.8-0.7-3.7S63,6.5,62.2,6s-1.8-0.8-3-0.9c-1.1-0.1-2.3-0.2-3.6-0.2H44v13.9L55.6,18.7 L55.6,18.7z M58.6,38.8c2.6,0,4.6-0.7,6-2.1c1.4-1.4,2.2-3.3,2.2-5.8c0-1.4-0.3-2.6-0.8-3.6c-0.5-0.9-1.2-1.7-2.1-2.2 c-0.9-0.6-1.9-0.9-3-1.2c-1.1-0.2-2.3-0.3-3.5-0.3H44v15.2H58.6z\"></path><path d=\"M82.5,0v43.7h-5.8V0H82.5z\"></path></g><g id=\"Artboard\"><g id=\"logo-rbi-report\"><path id=\"CST-Scheduler\" class=\"__2S2p4H8__st0 \" d=\"M31.4,63.1c-0.2-1.1-0.5-2.1-1.1-3s-1.3-1.7-2.1-2.4c-0.9-0.7-1.8-1.2-2.9-1.6 c-1.1-0.4-2.2-0.6-3.4-0.6c-2.2,0-4,0.4-5.5,1.3c-1.5,0.8-2.7,2-3.7,3.4c-0.9,1.4-1.6,3-2,4.8c-0.4,1.8-0.6,3.6-0.6,5.6 c0,1.8,0.2,3.6,0.6,5.3c0.4,1.7,1.1,3.3,2,4.7c0.9,1.4,2.2,2.5,3.7,3.3c1.5,0.8,3.3,1.3,5.5,1.3c2.9,0,5.2-0.9,6.9-2.7 c1.6-1.8,2.7-4.1,3-7.1h9.3c-0.2,2.7-0.9,5.2-1.9,7.4c-1,2.2-2.4,4.1-4,5.6s-3.6,2.7-5.9,3.5c-2.2,0.8-4.7,1.2-7.4,1.2 c-3.3,0-6.3-0.6-9-1.7C10.2,90,8,88.4,6.2,86.4c-1.8-2-3.2-4.4-4.2-7.2c-1-2.7-1.5-5.7-1.5-8.9c0-3.3,0.5-6.3,1.5-9.1 c1-2.8,2.4-5.2,4.2-7.3c1.8-2.1,4.1-3.7,6.7-4.9c2.7-1.2,5.7-1.8,9-1.8c2.4,0,4.7,0.3,6.8,1s4,1.7,5.7,3s3.1,3,4.2,4.9 c1.1,2,1.8,4.2,2.1,6.7H31.4z M50.5,77.5c0,1.5,0.3,2.7,0.8,3.7c0.5,1,1.2,1.8,2.1,2.5c0.9,0.6,1.9,1.1,3.1,1.4 c1.2,0.3,2.4,0.5,3.7,0.5c0.9,0,1.8-0.1,2.7-0.2s1.9-0.4,2.7-0.8c0.9-0.4,1.6-1,2.1-1.7s0.9-1.6,0.9-2.7c0-1.2-0.4-2.1-1.1-2.9 c-0.8-0.7-1.7-1.3-3-1.8c-1.2-0.5-2.6-0.9-4.1-1.3c-1.5-0.4-3.1-0.8-4.7-1.2c-1.6-0.4-3.2-0.9-4.8-1.5c-1.5-0.6-2.9-1.4-4.1-2.3 c-1.2-0.9-2.2-2.1-3-3.5c-0.8-1.4-1.1-3.1-1.1-5.1c0-2.2,0.5-4.2,1.4-5.8c1-1.6,2.2-3,3.8-4.1c1.5-1.1,3.3-1.9,5.2-2.4 c2-0.5,3.9-0.8,5.9-0.8c2.3,0,4.5,0.3,6.6,0.8c2.1,0.5,4,1.3,5.6,2.5c1.6,1.1,2.9,2.6,3.9,4.4c1,1.8,1.4,3.9,1.4,6.4h-9.3 c-0.1-1.3-0.4-2.4-0.8-3.2c-0.5-0.9-1.1-1.5-1.9-2c-0.8-0.5-1.7-0.8-2.7-1c-1-0.2-2.1-0.3-3.3-0.3c-0.8,0-1.5,0.1-2.3,0.2 c-0.8,0.2-1.5,0.4-2.1,0.9c-0.6,0.4-1.1,0.9-1.6,1.5C52.2,58,52,58.8,52,59.8c0,0.9,0.2,1.5,0.5,2.1c0.3,0.5,1,1,1.9,1.5 c1,0.4,2.3,0.9,4,1.3c1.7,0.4,3.9,1,6.6,1.7c0.8,0.2,1.9,0.5,3.4,0.9c1.4,0.4,2.9,1.1,4.3,2c1.4,0.9,2.7,2.2,3.7,3.8 c1,1.6,1.6,3.6,1.6,6c0,2-0.4,3.8-1.2,5.6c-0.8,1.7-1.9,3.2-3.4,4.4c-1.5,1.2-3.4,2.2-5.7,2.9s-4.9,1-7.8,1c-2.4,0-4.7-0.3-7-0.9 s-4.2-1.5-6-2.8c-1.7-1.3-3.1-2.9-4.1-4.8c-1-2-1.5-4.3-1.5-7H50.5z M89.6,56.5H76.6v-8.1h35.7v8.1H99.2V92h-9.6V56.5z M8.9,124.5 c0,1.5,0.3,2.7,0.8,3.7c0.5,1,1.2,1.8,2.1,2.5c0.9,0.6,1.9,1.1,3.1,1.4c1.2,0.3,2.4,0.5,3.7,0.5c0.9,0,1.8-0.1,2.7-0.2 c1-0.1,1.9-0.4,2.7-0.8c0.9-0.4,1.6-1,2.1-1.7s0.9-1.6,0.9-2.7c0-1.2-0.4-2.1-1.1-2.9c-0.8-0.7-1.7-1.3-3-1.8 c-1.2-0.5-2.6-0.9-4.1-1.3c-1.5-0.4-3.1-0.8-4.7-1.2c-1.6-0.4-3.2-0.9-4.8-1.5c-1.5-0.6-2.9-1.4-4.1-2.3c-1.2-0.9-2.2-2.1-3-3.5 s-1.1-3.1-1.1-5.1c0-2.2,0.5-4.2,1.4-5.8c1-1.6,2.2-3,3.8-4.1s3.3-1.9,5.2-2.4c2-0.5,3.9-0.8,5.9-0.8c2.3,0,4.5,0.3,6.6,0.8 c2.1,0.5,4,1.3,5.6,2.5s2.9,2.6,3.9,4.4c1,1.8,1.4,3.9,1.4,6.4h-9.3c-0.1-1.3-0.4-2.4-0.8-3.2s-1.1-1.5-1.9-2 c-0.8-0.5-1.7-0.8-2.7-1c-1-0.2-2.1-0.3-3.3-0.3c-0.8,0-1.5,0.1-2.3,0.2c-0.8,0.2-1.5,0.4-2.1,0.9c-0.6,0.4-1.1,0.9-1.6,1.5 s-0.6,1.4-0.6,2.3c0,0.9,0.2,1.5,0.5,2.1c0.3,0.5,1,1,1.9,1.5s2.3,0.9,4,1.3c1.7,0.4,3.9,1,6.6,1.7c0.8,0.2,1.9,0.5,3.4,0.9 s2.9,1.1,4.3,2c1.4,0.9,2.7,2.2,3.7,3.8s1.6,3.6,1.6,6c0,2-0.4,3.8-1.2,5.6s-1.9,3.2-3.4,4.4c-1.5,1.2-3.4,2.2-5.7,2.9 c-2.3,0.7-4.9,1-7.8,1c-2.4,0-4.7-0.3-7-0.9c-2.3-0.6-4.2-1.5-6-2.8c-1.7-1.3-3.1-2.9-4.1-4.8s-1.5-4.3-1.5-7H8.9z M58.9,118.5 c-0.6-3.6-2.7-5.4-6.4-5.4c-1.4,0-2.5,0.3-3.5,0.9c-0.9,0.6-1.7,1.4-2.3,2.4c-0.6,1-1,2.1-1.3,3.3c-0.2,1.2-0.4,2.4-0.4,3.6 c0,1.1,0.1,2.3,0.4,3.5c0.2,1.2,0.6,2.2,1.2,3.2c0.5,1,1.3,1.7,2.2,2.3s2.1,0.9,3.4,0.9c2.1,0,3.7-0.6,4.8-1.7 c1.1-1.2,1.8-2.7,2.1-4.7h8.4c-0.6,4.2-2.2,7.4-4.9,9.6c-2.7,2.2-6.1,3.3-10.3,3.3c-2.4,0-4.5-0.4-6.5-1.2s-3.6-1.9-5-3.3 c-1.4-1.4-2.5-3.1-3.2-5.1s-1.2-4.1-1.2-6.5c0-2.4,0.4-4.7,1.1-6.8c0.7-2.1,1.8-3.9,3.1-5.4c1.4-1.5,3.1-2.7,5.1-3.6 c2-0.9,4.3-1.3,6.8-1.3c1.9,0,3.7,0.2,5.4,0.7c1.7,0.5,3.3,1.2,4.6,2.2s2.5,2.2,3.3,3.7c0.9,1.5,1.3,3.2,1.5,5.3H58.9z M68.9,95.4 h8.7v16.4h0.2c1.1-1.8,2.5-3.2,4.2-4s3.4-1.3,5-1.3c2.3,0,4.2,0.3,5.7,0.9c1.5,0.6,2.7,1.5,3.5,2.6s1.5,2.5,1.8,4.1 c0.3,1.6,0.5,3.4,0.5,5.3V139h-8.7v-17.8c0-2.6-0.4-4.5-1.2-5.8s-2.3-1.9-4.3-1.9c-2.4,0-4.1,0.7-5.1,2.1 c-1.1,1.4-1.6,3.7-1.6,6.9V139h-8.7V95.4z M122.7,119.8c-0.4-2.2-1.1-3.9-2.2-5c-1-1.1-2.6-1.7-4.7-1.7c-1.4,0-2.5,0.2-3.4,0.7 c-0.9,0.5-1.6,1-2.2,1.7c-0.5,0.7-0.9,1.4-1.2,2.2c-0.2,0.8-0.4,1.5-0.4,2.1H122.7z M108.6,125.3c0.1,2.8,0.8,4.8,2.1,6.1 c1.3,1.3,3.2,1.9,5.6,1.9c1.7,0,3.3-0.4,4.5-1.3c1.3-0.9,2-1.8,2.3-2.8h7.6c-1.2,3.8-3.1,6.5-5.6,8.1c-2.5,1.6-5.6,2.4-9.2,2.4 c-2.5,0-4.7-0.4-6.7-1.2s-3.7-1.9-5.1-3.4c-1.4-1.5-2.5-3.2-3.2-5.2c-0.8-2-1.1-4.3-1.1-6.7c0-2.4,0.4-4.6,1.2-6.6 c0.8-2,1.9-3.8,3.3-5.3c1.4-1.5,3.1-2.7,5.1-3.5c2-0.9,4.2-1.3,6.6-1.3c2.7,0,5,0.5,7,1.6c2,1,3.6,2.4,4.9,4.2 c1.3,1.7,2.2,3.7,2.8,6s0.8,4.6,0.6,7H108.6z M155.2,123.1c0-1.3-0.1-2.6-0.4-3.8c-0.2-1.2-0.7-2.3-1.3-3.2 c-0.6-0.9-1.4-1.7-2.3-2.2c-0.9-0.6-2.1-0.9-3.5-0.9s-2.6,0.3-3.6,0.9c-1,0.6-1.8,1.3-2.3,2.3c-0.6,0.9-1,2-1.3,3.2 c-0.3,1.2-0.4,2.5-0.4,3.8c0,1.2,0.1,2.4,0.4,3.7c0.3,1.2,0.7,2.3,1.4,3.3s1.4,1.7,2.4,2.3c1,0.6,2.1,0.9,3.4,0.9 c1.4,0,2.6-0.3,3.6-0.9c1-0.6,1.7-1.3,2.3-2.3s1-2,1.2-3.3C155.1,125.7,155.2,124.4,155.2,123.1z M155.4,134.9h-0.1 c-1,1.7-2.3,2.9-4,3.7s-3.5,1.1-5.6,1.1c-2.4,0-4.4-0.5-6.2-1.4c-1.8-0.9-3.3-2.2-4.4-3.7c-1.2-1.6-2-3.4-2.6-5.4 c-0.6-2-0.9-4.1-0.9-6.3c0-2.1,0.3-4.2,0.9-6.1s1.5-3.7,2.6-5.2c1.2-1.5,2.6-2.7,4.4-3.6c1.7-0.9,3.8-1.4,6.1-1.4 c1.9,0,3.6,0.4,5.3,1.2c1.7,0.8,3,2,4,3.5h0.1V95.4h8.7V139h-8.2V134.9z M196.1,139h-8.2v-4.4h-0.2c-1.1,1.8-2.5,3.2-4.3,4 s-3.5,1.2-5.4,1.2c-2.3,0-4.2-0.3-5.7-0.9c-1.5-0.6-2.7-1.5-3.5-2.6c-0.9-1.1-1.5-2.5-1.8-4.1c-0.3-1.6-0.5-3.4-0.5-5.3v-19.4h8.7 v17.8c0,2.6,0.4,4.5,1.2,5.8s2.3,1.9,4.3,1.9c2.4,0,4.1-0.7,5.1-2.1c1.1-1.4,1.6-3.7,1.6-6.9v-16.5h8.7V139z M199.3,95.4h8.7V139 h-8.7V95.4z M232.5,119.8c-0.4-2.2-1.1-3.9-2.2-5c-1-1.1-2.6-1.7-4.7-1.7c-1.4,0-2.5,0.2-3.4,0.7c-0.9,0.5-1.6,1-2.2,1.7 c-0.5,0.7-0.9,1.4-1.2,2.2c-0.2,0.8-0.4,1.5-0.4,2.1H232.5z M218.4,125.3c0.1,2.8,0.8,4.8,2.1,6.1c1.3,1.3,3.2,1.9,5.6,1.9 c1.7,0,3.3-0.4,4.5-1.3c1.3-0.9,2-1.8,2.3-2.8h7.6c-1.2,3.8-3.1,6.5-5.6,8.1s-5.6,2.4-9.1,2.4c-2.5,0-4.7-0.4-6.7-1.2 s-3.7-1.9-5.1-3.4c-1.4-1.5-2.5-3.2-3.2-5.2c-0.8-2-1.1-4.3-1.1-6.7c0-2.4,0.4-4.6,1.2-6.6c0.8-2,1.9-3.8,3.3-5.3 c1.4-1.5,3.1-2.7,5.1-3.5c2-0.9,4.2-1.3,6.6-1.3c2.7,0,5,0.5,7,1.6c2,1,3.6,2.4,4.9,4.2c1.3,1.7,2.2,3.7,2.8,6 c0.6,2.2,0.8,4.6,0.6,7H218.4z M242.7,107.4h8.2v5.9h0.1c0.4-1,1-1.9,1.6-2.7c0.7-0.8,1.5-1.5,2.4-2.1c0.9-0.6,1.9-1,2.9-1.4 c1-0.3,2.1-0.5,3.2-0.5c0.6,0,1.2,0.1,1.9,0.3v8.1c-0.4-0.1-0.9-0.2-1.5-0.2c-0.6-0.1-1.1-0.1-1.6-0.1c-1.6,0-2.9,0.3-4,0.8 c-1.1,0.5-2,1.3-2.7,2.2c-0.7,0.9-1.1,2-1.4,3.2c-0.3,1.2-0.4,2.5-0.4,4V139h-8.7V107.4z\"></path></g></g></svg>"

/***/ }),

/***/ "SCE7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photos_vue__ = __webpack_require__("5Bg6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_737c1300_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Photos_vue__ = __webpack_require__("H18i");
function injectStyle (ssrContext) {
  __webpack_require__("Gin+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-737c1300"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Photos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_737c1300_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Photos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SJpK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SQqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("Olasio is a SaaS product startup company backed by Carsales. It's in the very early stages of launching so I can't talk much about the details, but I've been lucky to get an opportunity to lead this new startup's design from scratch, and implemented the initial brand design of the product.")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-olasio-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"mw730",attrs:{"src":_vm.imagePath + 'works-olasio-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("The scale of the product will be huge, and it's going to cover many different industries and fields, thus the logo has been designed to be as simple and neutral as possible, with flexibility in mind.")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-olasio-03.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-olasio-04.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-olasio-05.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-olasio-06.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-olasio-07.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-olasio-08.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("The brand design has been implemented with a number of product mockups, so that the team can understand it easily and get the feeling of the brand in a real context.")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-olasio-web-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-olasio-web-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-olasio-web-03.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Olasio dashboard concept design")]),_vm._v(" "),_c('img',{staticClass:"mw630",attrs:{"src":_vm.imagePath + 'works-olasio-mobile-01.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-olasio-mobile-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-olasio-mobile-03.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-olasio-mobile-04.png',"alt":this.$options.name}})]),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-olasio-mobile-05.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-olasio-mobile-06.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-olasio-mobile-07.png',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Olasio Verify app concept design")]),_vm._v(" "),_c('div',{staticClass:"cols col-2"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-olasio-ipad-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-olasio-ipad-02.png',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Olasio Inspector iPad app concept design")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TNak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SiteTitle_vue__ = __webpack_require__("RKQU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TextBlock_vue__ = __webpack_require__("Jpyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer_vue__ = __webpack_require__("TVmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WorkList_vue__ = __webpack_require__("KmIK");
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'works',
  components: {
    'site-title': __WEBPACK_IMPORTED_MODULE_0__components_SiteTitle_vue__["a" /* default */],
    'text-block': __WEBPACK_IMPORTED_MODULE_1__components_TextBlock_vue__["a" /* default */],
    'site-footer': __WEBPACK_IMPORTED_MODULE_2__components_Footer_vue__["a" /* default */],
    'work-list': __WEBPACK_IMPORTED_MODULE_3__components_WorkList_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56a42cfb_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("DvM2");
function injectStyle (ssrContext) {
  __webpack_require__("hbdi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56a42cfb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56a42cfb_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TlR/":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./logo-barefoot.svg": "C1bF",
	"./logo-biscuit.svg": "5rsv",
	"./logo-collision.svg": "zoQ1",
	"./logo-granton.svg": "5bzO",
	"./logo-magritte.svg": "dZVC",
	"./logo-mercer.svg": "Bkc6",
	"./logo-olasio.svg": "xW9d",
	"./logo-rbi-emails.svg": "woY9",
	"./logo-rbi-report.svg": "rRYK",
	"./logo-rbi-scheduler.svg": "S0Vn",
	"./logo-rbi-website.svg": "aEtE",
	"./logo-t2.svg": "nJIZ",
	"./logo-teamable.svg": "3JwC",
	"./logo-transcope.svg": "JTu9",
	"./logo-wikiprice.svg": "p1oC",
	"./logo-zigzag.svg": "Uld7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TlR/";

/***/ }),

/***/ "UK4w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("Mercer is the world's largest human resources consulting firm. Headquartered in New York City, Mercer has more than 20,500 employees, is based in more than 40 countries, and operates internationally in more than 130 countries.")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-mercer-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("Melbourne Mercer announces the Global Pension Index annually. The announcement includes many data and charts, generally in a PDF document. The Mercer Interactive Data project was to create an interactive web app based on the annual report data.")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-mercer-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-mercer-03.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("The app is built on React/Redux, and most of the transitions and animations are done with the GreenSock Animation Platform.")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-mercer-04.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("Although I did both the design and front-end development, I put a lot of effort into creating high fidelity and specific designs, because this is the best communication method that I know of that helps everyone to be on the same page and discover issues prior to development.")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-mercer-05.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-mercer-06.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("The transitions are all designed and coded by myself. The goal was to make the overall experience more app-like, where the transition between different pages and states are seamless and natural.")]),_vm._v(" "),_c('video',{staticClass:"shadow",attrs:{"src":_vm.videoPath + 'works-mercer.mp4',"autoplay":"","loop":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UM5L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ufvi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("RedBook Inspect is a vehicle inspection service by Carsales. They provide an inspection service, not only to individual customers, but to car dealers and finance companies. Also, a big part of the business is roadworthy inspection for drivers of ride-share services such as Uber, Ola and Didi.\n  "),_c('br'),_c('br'),_vm._v("The inspection report is what customers actually receive, so it's a crucial part of the business. My first project at the RBI team was to design online dynamic report to replace the existing PDF report.")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-report-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("The main focus of the report design was to make information accessible, readable, and fast. When there's a medium conversion from static PDF to online web page, it's easy to get too excited about possible interactions, and add a lot of interactivity to the page.\n  "),_c('br'),_c('br'),_vm._v("However, interactivity should be implemented only when it's necessary. And that was my intention when I was designing this dynamic report.")]),_vm._v(" "),_c('div',{staticClass:"cols col-2"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-report-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-report-03.png',"alt":this.$options.name}})]),_vm._v(" "),_c('p',[_vm._v("The service provides several types of inspection with different sets of information, and the PDF format was no longer suitable in this environment due to the lack of flexibity. The dynamic report has been structured by modular design, so the service can provide customized and even personalized reports based on different requirements.")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-report-04.png',"alt":this.$options.name}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uld7":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 583.6 118.9\"><path d=\"M159.4 97.4h96.3V118h-96.3zm96.8-96h-94.7V22h57.3l-36.3 54.7h29.6l44.1-68.9zM97 118V97.4H69.7L56.3 118zm.5-116.6H2.8V22h57.4L.8 111.7v6.3h26.4l39.1-61.4L97.5 7.8zM135.9 118h-23.5V1.4h23.5V118zm240.9 0V97.4h-27.6L336.1 118zm.4-116.6h-94.6V22h57.2l-59.4 89.7v6.3h26.4l39.3-61.4 31.1-48.8zm108.9 96h96.3V118h-96.3zm96.7-96h-94.7V22h57.3l-36.3 54.7h29.7l44-68.9zM415.6 118h-23.5V1.4h23.5V118zm46.8 0h-23.5V1.4h23.5V118z\" class=\"__250r_LR__st0 \"></path><path d=\"M402.6 49.4h48.2V70h-48.2z\" class=\"__250r_LR__st0 \"></path></svg>"

/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer'
});

/***/ }),

/***/ "WMUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'biscuit',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "WVja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RbiWebsite_vue__ = __webpack_require__("tPgL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68ecf0c0_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RbiWebsite_vue__ = __webpack_require__("zz8+");
function injectStyle (ssrContext) {
  __webpack_require__("u4mn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68ecf0c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RbiWebsite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68ecf0c0_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RbiWebsite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XwyV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectBody_vue__ = __webpack_require__("H/xS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c0d1430_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectBody_vue__ = __webpack_require__("Bl+D");
function injectStyle (ssrContext) {
  __webpack_require__("PAk0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c0d1430"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectBody_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c0d1430_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectBody_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XxVZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y8sc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Home__ = __webpack_require__("HXef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Works__ = __webpack_require__("KyEk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_About__ = __webpack_require__("en7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Photos__ = __webpack_require__("SCE7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Error__ = __webpack_require__("f2KA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Access__ = __webpack_require__("xolb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contents_Mercer__ = __webpack_require__("L2Wx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__contents_Biscuit__ = __webpack_require__("0e2X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__contents_TeaTwo__ = __webpack_require__("yc4b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__contents_Teamable__ = __webpack_require__("kD1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__contents_Transcope__ = __webpack_require__("HPGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__contents_Granton__ = __webpack_require__("Z+Jl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__contents_Zigzag__ = __webpack_require__("d8Ax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__contents_Magritte__ = __webpack_require__("HQxS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__contents_WikiPrice__ = __webpack_require__("M2xv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__contents_Collision__ = __webpack_require__("25Mm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__contents_RbiReport__ = __webpack_require__("2iSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__contents_RbiWebsite__ = __webpack_require__("WVja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__contents_Olasio__ = __webpack_require__("necw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__contents_RbiEmails__ = __webpack_require__("wG1P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__contents_RbiScheduler__ = __webpack_require__("GBx5");

/*** IMPORTS FROM imports-loader ***/
var define = false;




























__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/access',
    name: 'Access',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_Access__["a" /* default */]
  }, {
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Home__["a" /* default */],
    alias: '/home'
  }, {
    path: '/works',
    name: 'Works',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Works__["a" /* default */]
  }, {
    path: '/photos',
    name: 'Photos',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Photos__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_About__["a" /* default */]
  }, {
    path: '/works/mercer',
    name: 'Mercer',
    component: __WEBPACK_IMPORTED_MODULE_10__contents_Mercer__["a" /* default */]
  }, {
    path: '/works/biscuit',
    name: 'Biscuit',
    component: __WEBPACK_IMPORTED_MODULE_11__contents_Biscuit__["a" /* default */]
  }, {
    path: '/works/t2',
    name: 'TeaTwo',
    component: __WEBPACK_IMPORTED_MODULE_12__contents_TeaTwo__["a" /* default */]
  }, {
    path: '/works/teamable',
    name: 'Teamable',
    component: __WEBPACK_IMPORTED_MODULE_13__contents_Teamable__["a" /* default */]
  }, {
    path: '/works/transcope',
    name: 'Transcope',
    component: __WEBPACK_IMPORTED_MODULE_14__contents_Transcope__["a" /* default */]
  }, {
    path: '/works/granton',
    name: 'Granton',
    component: __WEBPACK_IMPORTED_MODULE_15__contents_Granton__["a" /* default */]
  }, {
    path: '/works/zigzag',
    name: 'Zigzag',
    component: __WEBPACK_IMPORTED_MODULE_16__contents_Zigzag__["a" /* default */]
  }, {
    path: '/works/magritte',
    name: 'Magritte',
    component: __WEBPACK_IMPORTED_MODULE_17__contents_Magritte__["a" /* default */]
  }, {
    path: '/works/wikiprice',
    name: 'WikiPrice',
    component: __WEBPACK_IMPORTED_MODULE_18__contents_WikiPrice__["a" /* default */]
  }, {
    path: '/works/collision',
    name: 'Collision',
    component: __WEBPACK_IMPORTED_MODULE_19__contents_Collision__["a" /* default */]
  }, {
    path: '/works/rbi-report',
    name: 'RbiReport',
    component: __WEBPACK_IMPORTED_MODULE_20__contents_RbiReport__["a" /* default */]
  }, {
    path: '/works/rbi-website',
    name: 'RbiWebsite',
    component: __WEBPACK_IMPORTED_MODULE_21__contents_RbiWebsite__["a" /* default */]
  }, {
    path: '/works/olasio',
    name: 'Olasio',
    component: __WEBPACK_IMPORTED_MODULE_22__contents_Olasio__["a" /* default */]
  }, {
    path: '/works/rbi-emails',
    name: 'RbiEmails',
    component: __WEBPACK_IMPORTED_MODULE_23__contents_RbiEmails__["a" /* default */]
  }, {
    path: '/works/rbi-scheduler',
    name: 'RbiScheduler',
    component: __WEBPACK_IMPORTED_MODULE_24__contents_RbiScheduler__["a" /* default */]
  }, {
    path: '*',
    name: 'Error',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Error__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      setTimeout(function () {
        resolve({ x: 0, y: 0 });
      }, 200);
    });
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_analytics___default.a, {
  id: 'UA-110410306-1',
  router: router
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yivk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'collision',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "YtJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__("424j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/*** IMPORTS FROM imports-loader ***/
var define = false;






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    flickrData: null,
    menuBtnInHeader: false,
    numberOfPhoto: 6,
    siteAccess: true
  },
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])({
    paths: ['siteAccess'],
    storage: {
      getItem: function getItem(key) {
        return __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get(key);
      },
      setItem: function setItem(key, value) {
        return __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set(key, value, { expires: 3, secure: true });
      },
      removeItem: function removeItem(key) {
        return __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.remove(key);
      }
    }
  })],
  mutations: {
    inHeader: function inHeader(state) {
      state.menuBtnInHeader = true;
    },
    outHeader: function outHeader(state) {
      state.menuBtnInHeader = false;
    },
    loadFlickrData: function loadFlickrData(state, data) {
      state.flickrData = data;
    },
    loadMorePhoto: function loadMorePhoto(state, number) {
      state.numberOfPhoto += number;
    },
    accessGrant: function accessGrant(state) {
      state.siteAccess = true;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "Z+Jl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Granton_vue__ = __webpack_require__("KtWP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed27189_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Granton_vue__ = __webpack_require__("P8nJ");
function injectStyle (ssrContext) {
  __webpack_require__("aBXF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ed27189"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Granton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed27189_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Granton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aBXF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aEtE":
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 253.3 95.5\" style=\"enable-background:new 0 0 253.3 95.5;\" xml:space=\"preserve\"><style type=\"text/css\"> .__2tfFtjP__st0{opacity:0.4;} </style><g><path d=\"M25.4,29.4c1.1,1.1,1.8,2.8,2.2,5.2c0.3,1.8,0.4,3.7,0.6,5.7c0.1,2,0.5,3.7,1,5.2h10c-0.5-0.6-0.8-1.4-1-2.3 c-0.2-0.9-0.4-1.9-0.5-2.9s-0.2-2-0.2-3s-0.1-1.8-0.1-2.5c-0.1-1.1-0.2-2.3-0.5-3.4c-0.2-1.1-0.6-2.2-1.1-3.2s-1.2-1.8-2-2.5 s-1.8-1.2-3.1-1.6V24c2.5-1,4.4-2.5,5.5-4.5s1.7-4.3,1.7-6.9c0-1.7-0.3-3.4-0.9-4.9c-0.6-1.5-1.5-2.8-2.7-4c-1.2-1.1-2.6-2-4.2-2.7 c-1.6-0.7-3.5-1-5.5-1H0v34.9h10v-7.1h10C22.4,27.8,24.2,28.3,25.4,29.4z M10,7.8h10.9c2.3,0,4,0.5,5.2,1.5c1.1,1,1.7,2.6,1.7,4.8 c0,2.3-0.6,3.9-1.7,5c-1.1,1-2.9,1.5-5.2,1.5H10V7.8z\"></path><path d=\"M44.1,41.6c1.4,1.5,3.2,2.7,5.3,3.5c2.1,0.8,4.4,1.2,7,1.2c3.7,0,6.9-0.8,9.5-2.5s4.6-4.5,5.9-8.5h-8c-0.3,1-1.1,2-2.4,2.9 s-2.9,1.4-4.7,1.4c-2.5,0-4.5-0.7-5.9-2s-2.1-3.4-2.2-6.4h23.7c0.2-2.5,0-5-0.6-7.3s-1.6-4.4-2.9-6.2s-3-3.3-5.1-4.4 s-4.5-1.6-7.3-1.6c-2.5,0-4.8,0.4-6.8,1.3c-2.1,0.9-3.8,2.1-5.3,3.7c-1.5,1.5-2.6,3.4-3.4,5.5c-0.8,2.1-1.2,4.4-1.2,6.9 s0.4,4.9,1.2,7C41.5,38.2,42.6,40,44.1,41.6z M49,23.4c0.2-0.8,0.6-1.6,1.2-2.3s1.3-1.3,2.3-1.8s2.2-0.7,3.6-0.7 c2.2,0,3.8,0.6,4.9,1.8s1.8,2.9,2.3,5.2H48.6C48.6,24.9,48.8,24.2,49,23.4z\"></path><path d=\"M87.2,46.3c2.2,0,4.1-0.4,5.8-1.2c1.7-0.8,3.1-2.1,4.2-3.8h0.1v4.2h8.6V0.1h-9v16.5h-0.1c-1-1.6-2.4-2.8-4.2-3.7 c-1.8-0.8-3.6-1.2-5.6-1.2c-2.4,0-4.5,0.5-6.4,1.4c-1.8,1-3.3,2.2-4.5,3.8c-1.2,1.6-2.1,3.4-2.7,5.4c-0.6,2.1-0.9,4.2-0.9,6.4 c0,2.3,0.3,4.5,0.9,6.6s1.5,4,2.7,5.6s2.7,2.9,4.6,3.9C82.6,45.9,84.7,46.3,87.2,46.3z M81.9,25.1c0.3-1.3,0.7-2.4,1.3-3.3 s1.4-1.8,2.5-2.4c1-0.6,2.3-0.9,3.8-0.9s2.7,0.3,3.7,0.9c1,0.6,1.8,1.4,2.4,2.3s1.1,2.1,1.3,3.3c0.3,1.3,0.4,2.6,0.4,3.9 c0,1.4-0.1,2.7-0.4,3.9c-0.3,1.3-0.7,2.4-1.3,3.4c-0.6,1-1.4,1.8-2.4,2.4c-1,0.6-2.2,0.9-3.7,0.9c-1.4,0-2.6-0.3-3.6-0.9 c-1-0.6-1.8-1.4-2.5-2.4s-1.1-2.1-1.4-3.4c-0.3-1.3-0.4-2.5-0.4-3.8C81.5,27.7,81.6,26.4,81.9,25.1z\"></path><path d=\"M137.8,44.7c1.9-0.5,3.6-1.3,5.2-2.4c1.5-1.1,2.7-2.4,3.6-4.1c0.9-1.7,1.3-3.7,1.3-6c0-2.8-0.7-5.3-2.1-7.3 c-1.4-2-3.5-3.4-6.3-4.2c2-1,3.6-2.2,4.6-3.8c1-1.5,1.6-3.4,1.6-5.7c0-2.1-0.3-3.9-1-5.3s-1.7-2.6-3-3.5s-2.8-1.5-4.6-1.9 s-3.8-0.6-5.9-0.6h-21.4v45.4h22C133.9,45.5,135.9,45.3,137.8,44.7z M119.8,7.8h9.4c0.9,0,1.8,0.1,2.6,0.2s1.6,0.4,2.2,0.8 c0.6,0.4,1.1,0.9,1.5,1.6s0.6,1.5,0.6,2.6c0,1.9-0.6,3.3-1.7,4.1c-1.1,0.8-2.6,1.3-4.4,1.3h-10.1V7.8H119.8z M119.8,37.7V25.3h10.9 c2.2,0,3.9,0.5,5.2,1.5s2,2.7,2,5c0,1.2-0.2,2.2-0.6,2.9c-0.4,0.8-0.9,1.4-1.6,1.8c-0.7,0.4-1.5,0.8-2.4,1s-1.8,0.3-2.8,0.3h-10.7 L119.8,37.7L119.8,37.7z\"></path><path d=\"M153.5,41.7c1.5,1.5,3.3,2.7,5.3,3.5c2.1,0.8,4.4,1.2,7,1.2s4.9-0.4,7-1.2s3.9-2,5.4-3.5s2.6-3.3,3.4-5.4 c0.8-2.1,1.2-4.5,1.2-7.1s-0.4-5-1.2-7.2c-0.8-2.1-2-4-3.4-5.5c-1.5-1.5-3.3-2.7-5.4-3.5c-2.1-0.8-4.4-1.2-7-1.2s-4.9,0.4-7,1.2 c-2.1,0.8-3.9,2-5.3,3.5c-1.5,1.5-2.6,3.3-3.4,5.5c-0.8,2.1-1.2,4.5-1.2,7.2c0,2.6,0.4,5,1.2,7.1C150.9,38.3,152,40.2,153.5,41.7z M158.3,25.2c0.3-1.3,0.7-2.4,1.3-3.4s1.4-1.8,2.5-2.4s2.3-0.9,3.8-0.9s2.8,0.3,3.8,0.9c1,0.6,1.9,1.4,2.5,2.4s1,2.1,1.3,3.4 c0.3,1.3,0.4,2.6,0.4,3.9c0,1.3-0.1,2.6-0.4,3.8c-0.3,1.3-0.7,2.4-1.3,3.4s-1.4,1.8-2.5,2.4c-1,0.6-2.3,0.9-3.8,0.9 s-2.8-0.3-3.8-0.9c-1-0.6-1.8-1.4-2.5-2.4s-1-2.1-1.3-3.4c-0.3-1.3-0.4-2.5-0.4-3.8C157.9,27.8,158,26.5,158.3,25.2z\"></path><path d=\"M213.3,16.5c-1.5-1.5-3.3-2.7-5.4-3.5c-2.1-0.8-4.4-1.2-7-1.2s-4.9,0.4-7,1.2c-2.1,0.8-3.9,2-5.3,3.5 c-1.5,1.5-2.6,3.3-3.4,5.5c-0.8,2.1-1.2,4.5-1.2,7.2c0,2.6,0.4,5,1.2,7.1s2,3.9,3.4,5.4c1.5,1.5,3.3,2.7,5.3,3.5 c2.1,0.8,4.4,1.2,7,1.2s4.9-0.4,7-1.2s3.9-2,5.4-3.5s2.6-3.3,3.4-5.4c0.8-2.1,1.2-4.5,1.2-7.1s-0.4-5-1.2-7.2 C215.9,19.8,214.8,18,213.3,16.5z M208.5,32.9c-0.3,1.3-0.7,2.4-1.3,3.4s-1.4,1.8-2.5,2.4c-1,0.6-2.3,0.9-3.8,0.9s-2.8-0.3-3.8-0.9 c-1-0.6-1.8-1.4-2.5-2.4c-0.6-1-1.1-2.1-1.3-3.4c-0.3-1.3-0.4-2.5-0.4-3.8s0.1-2.6,0.4-3.9c0.3-1.3,0.7-2.4,1.3-3.4 s1.4-1.8,2.5-2.4c1-0.6,2.3-0.9,3.8-0.9s2.8,0.3,3.8,0.9c1,0.6,1.9,1.4,2.5,2.4s1.1,2.1,1.3,3.4c0.3,1.3,0.4,2.6,0.4,3.9 C208.9,30.4,208.8,31.7,208.5,32.9z\"></path><polygon points=\"239.5,24.7 251.9,12.6 241.2,12.6 229.9,24.4 229.9,0.1 220.8,0.1 220.8,45.5 229.9,45.5 229.9,34.2 233.4,30.8 242.4,45.5 253.3,45.5 \"></polygon></g><g class=\"__2tfFtjP__st0 \"><rect y=\"38.6\" width=\"10\" height=\"45.4\"></rect><path d=\"M42.4,54c-0.9-1.2-2.1-2.1-3.7-2.7c-1.5-0.7-3.5-1-5.9-1c-1.9,0-3.8,0.4-5.6,1.3s-3.3,2.3-4.5,4.2h-0.2v-4.6h-8.6v32.9h9 V66.8c0-3.4,0.6-5.8,1.7-7.2c1.1-1.5,2.9-2.2,5.3-2.2c2.2,0,3.7,0.7,4.5,2s1.3,3.4,1.3,6.1v18.6h9V63.8c0-2-0.2-3.9-0.5-5.6 C43.9,56.6,43.3,55.2,42.4,54z\"></path><path d=\"M73.5,67.1c-1-0.7-2.1-1.3-3.3-1.7c-1.3-0.4-2.5-0.8-3.8-1.1c-1.3-0.3-2.5-0.6-3.8-0.8c-1.2-0.3-2.3-0.5-3.3-0.9 c-1-0.3-1.7-0.7-2.3-1.2c-0.6-0.5-0.9-1.2-0.9-2c0-0.7,0.2-1.2,0.5-1.6s0.8-0.7,1.2-0.9c0.5-0.2,1-0.3,1.6-0.4s1.1-0.1,1.7-0.1 c1.6,0,3,0.3,4.2,0.9s1.8,1.8,2,3.5h8.6c-0.2-2-0.7-3.7-1.6-5.1s-2-2.4-3.3-3.2c-1.3-0.8-2.8-1.4-4.5-1.7c-1.7-0.3-3.4-0.5-5.2-0.5 c-1.8,0-3.5,0.2-5.2,0.5s-3.2,0.9-4.6,1.7c-1.4,0.8-2.4,1.9-3.3,3.2c-0.8,1.4-1.2,3.1-1.2,5.2c0,1.4,0.3,2.7,0.9,3.7 c0.6,1,1.4,1.8,2.4,2.5s2.1,1.2,3.3,1.6c1.3,0.4,2.5,0.8,3.8,1.1c3.2,0.7,5.7,1.4,7.5,2c1.8,0.7,2.7,1.7,2.7,3.1 c0,0.8-0.2,1.5-0.6,2s-0.9,1-1.4,1.3s-1.2,0.6-1.9,0.7c-0.7,0.1-1.4,0.2-2,0.2c-0.9,0-1.8-0.1-2.6-0.3c-0.8-0.2-1.6-0.5-2.2-1 c-0.6-0.4-1.2-1-1.6-1.7s-0.6-1.5-0.6-2.5h-8.6c0.1,2.2,0.6,4,1.5,5.5s2.1,2.6,3.5,3.5s3,1.5,4.9,1.9c1.8,0.4,3.7,0.6,5.6,0.6 s3.7-0.2,5.5-0.5c1.8-0.4,3.4-1,4.8-1.9s2.5-2.1,3.4-3.5c0.9-1.5,1.3-3.3,1.3-5.4c0-1.5-0.3-2.8-0.9-3.8 C75.3,68.6,74.5,67.8,73.5,67.1z\"></path><path d=\"M108.1,55.6c-1.2-1.6-2.8-2.9-4.6-3.9c-1.9-1-4.1-1.5-6.7-1.5c-2,0-3.9,0.4-5.6,1.2c-1.7,0.8-3.1,2.1-4.2,3.9h-0.1v-4.2 h-8.6v44.4h9V80h0.1c1.1,1.6,2.5,2.8,4.2,3.7c1.7,0.8,3.6,1.2,5.6,1.2c2.4,0,4.5-0.5,6.3-1.4s3.3-2.2,4.5-3.8 c1.2-1.6,2.1-3.4,2.7-5.4s0.9-4.2,0.9-6.4c0-2.3-0.3-4.6-0.9-6.7C110.2,59.1,109.3,57.2,108.1,55.6z M102.3,71.6 c-0.3,1.3-0.7,2.4-1.3,3.3c-0.6,1-1.4,1.7-2.4,2.3c-1,0.6-2.2,0.9-3.7,0.9c-1.4,0-2.7-0.3-3.7-0.9s-1.8-1.4-2.5-2.3 c-0.6-1-1.1-2.1-1.3-3.3C87.1,70.3,87,69,87,67.7c0-1.4,0.1-2.7,0.4-3.9c0.3-1.3,0.7-2.4,1.3-3.4c0.6-1,1.4-1.8,2.4-2.4 s2.2-0.9,3.7-0.9c1.4,0,2.7,0.3,3.7,0.9s1.8,1.4,2.5,2.4c0.6,1,1.1,2.1,1.4,3.4c0.3,1.3,0.4,2.6,0.4,3.9 C102.7,69,102.5,70.3,102.3,71.6z\"></path><path d=\"M140.9,56.3c-1.3-1.8-3-3.3-5.1-4.4s-4.5-1.6-7.3-1.6c-2.5,0-4.8,0.4-6.8,1.3c-2.1,0.9-3.8,2.1-5.3,3.7 c-1.5,1.5-2.6,3.4-3.4,5.5c-0.8,2.1-1.2,4.4-1.2,6.9s0.4,4.9,1.2,7c0.8,2.1,1.9,3.9,3.3,5.5c1.4,1.5,3.2,2.7,5.3,3.5s4.4,1.2,7,1.2 c3.7,0,6.9-0.8,9.5-2.5s4.6-4.5,5.9-8.5h-8c-0.3,1-1.1,2-2.4,2.9c-1.3,0.9-2.9,1.4-4.7,1.4c-2.5,0-4.5-0.7-5.9-2s-2.1-3.4-2.2-6.4 h23.7c0.2-2.5,0-5-0.6-7.3C143.2,60.2,142.3,58.1,140.9,56.3z M120.7,64.1c0-0.6,0.2-1.4,0.4-2.2c0.2-0.8,0.6-1.6,1.2-2.3 c0.6-0.7,1.3-1.3,2.3-1.8s2.2-0.7,3.6-0.7c2.2,0,3.8,0.6,4.9,1.8c1.1,1.2,1.8,2.9,2.3,5.2H120.7z\"></path><path d=\"M181.1,42.3v8.9h-5.5v6c-0.9-1.5-2-2.8-3.4-3.8s-3-1.8-4.8-2.3s-3.7-0.8-5.6-0.8c-2.7,0-5,0.4-7.1,1.3s-3.8,2.1-5.3,3.7 c-1.4,1.6-2.5,3.5-3.3,5.7c-0.7,2.2-1.1,4.5-1.1,7.1c0,2.5,0.4,4.7,1.2,6.8c0.8,2.1,1.9,3.8,3.4,5.3c1.4,1.5,3.2,2.6,5.2,3.5 c2.1,0.8,4.3,1.2,6.8,1.2c4.4,0,8-1.1,10.8-3.4s4.5-5.6,5.1-10h-8.7c-0.3,2-1,3.7-2.2,4.9c-1.2,1.2-2.8,1.8-5,1.8 c-1.4,0-2.6-0.3-3.6-1c-1-0.6-1.8-1.5-2.3-2.5c-0.6-1-1-2.1-1.2-3.3c-0.3-1.2-0.4-2.4-0.4-3.6s0.1-2.5,0.4-3.7 c0.3-1.3,0.7-2.4,1.3-3.4s1.4-1.9,2.4-2.5c1-0.7,2.2-1,3.6-1c3.9,0,6.1,1.9,6.7,5.7h8.8c-0.1-2.1-0.6-4-1.5-5.5l0,0h5.4v19.4 c0,1.7,0.3,3,0.8,4c0.6,1,1.3,1.8,2.3,2.4s2.1,0.9,3.3,1.1c1.3,0.2,2.6,0.3,4,0.3c0.9,0,1.8,0,2.7-0.1c0.9,0,1.8-0.1,2.5-0.3v-7 c-0.4,0.1-0.9,0.1-1.3,0.2c-0.5,0-1,0.1-1.5,0.1c-1.5,0-2.5-0.3-3.1-0.8c-0.5-0.5-0.8-1.5-0.8-3.1V57.2h6.6v-6h-6.6v-2.9\"></path></g></svg>"

/***/ }),

/***/ "aY1u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("Originating in Australia, T2 is one of most popular tea brands now expanding globally to the UK, USA and Singapore. The Power of T2 Campaign was planned to encourage customers to share their feelings with their favorite tea.")]),_vm._v(" "),_c('img',{staticClass:"mw730",attrs:{"src":_vm.imagePath + 'works-t2-00.gif',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("Although the design from the client was different, our team decided to structure the app as a single page application instead of multiple pages with routing, so that it could be easily embeded into any page of the client’s existing website.")]),_vm._v(" "),_c('div',{staticClass:"cols col-2-row-2"},[_c('img',{attrs:{"src":_vm.imagePath + 'works-t2-01.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-t2-02.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-t2-03.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-t2-04.jpg',"alt":this.$options.name}})]),_vm._v(" "),_c('p',[_vm._v("The app has been built with React and Next.js in order to generate static files to deliver to the client. The transitions between pages are all done with GSAP. The desktop and mobile are different so that the transition style fits with the layout.")]),_vm._v(" "),_c('div',{staticClass:"cols col-2-row-2"},[_c('img',{attrs:{"src":_vm.imagePath + 'works-t2-05.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-t2-06.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-t2-07.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-t2-08.jpg',"alt":this.$options.name}})]),_vm._v(" "),_c('p',[_vm._v("The actual image area is HTML5 Canvas. It generates a base64 PNG image to send to the server, which then handles the image and generates sharable pages for them.")]),_vm._v(" "),_c('video',{attrs:{"src":_vm.videoPath + 'works-t2.mp4',"autoplay":"","loop":""}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-t2-09.jpg',"alt":this.$options.name}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "as5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.state.siteAccess)?_c('main',[_c('sidenav'),_vm._v(" "),_c('div',{attrs:{"id":"matters"}},[_c('transition',{attrs:{"name":"fade","appear":""}},[_c('router-view')],1)],1)],1):_c('div',[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-access",attrs:{"id":"matters"}},[_c('section',[_c('h2',[_vm._v("Jason Jun's Portfolio Website")]),_vm._v(" "),_c('p',[_vm._v("Hello, I put my website under private mode due to some of my works are not allowed to be public.")]),_vm._v(" "),_c('p',[_vm._v("If you want to check out my works, please don't hesitate to contact me. I'll give you an access link right away.")]),_vm._v(" "),_c('p',[_vm._v("You can reach me on Twitter "),_c('a',{attrs:{"href":"https://twitter.com/jsonjun"}},[_vm._v("@jsonjun")]),_vm._v(" or email me at uxd.jun@gmail.com")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c/lV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d8Ax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Zigzag_vue__ = __webpack_require__("kNZs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_161a6ffe_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Zigzag_vue__ = __webpack_require__("9+LN");
function injectStyle (ssrContext) {
  __webpack_require__("XxVZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-161a6ffe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Zigzag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_161a6ffe_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Zigzag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dPB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SiteTitle_vue__ = __webpack_require__("RKQU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TextBlock_vue__ = __webpack_require__("Jpyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FeaturedGrid_vue__ = __webpack_require__("IF4R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WorkList_vue__ = __webpack_require__("KmIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Footer__ = __webpack_require__("TVmP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    'site-title': __WEBPACK_IMPORTED_MODULE_0__components_SiteTitle_vue__["a" /* default */],
    'text-block': __WEBPACK_IMPORTED_MODULE_1__components_TextBlock_vue__["a" /* default */],
    'featured-grid': __WEBPACK_IMPORTED_MODULE_2__components_FeaturedGrid_vue__["a" /* default */],
    'work-list': __WEBPACK_IMPORTED_MODULE_3__components_WorkList_vue__["a" /* default */],
    'site-footer': __WEBPACK_IMPORTED_MODULE_4__components_Footer__["a" /* default */]
  },
  mounted: function mounted() {} // mounted

});

/***/ }),

/***/ "dZVC":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 214 33\"><path d=\"M5.7 4c0-1.1 0-1.2 1.8-1.2 3.5 0 5.4 2.1 5.4 5.4 0 2.9-1.3 5-4.9 5.6-.2.1-.2.6 0 .7 1.4 0 3.2-.3 4.6-1 1.4-.7 3.4-2.2 3.4-5.3 0-2.3-1.1-4.1-2.7-5-1.6-1-3.7-1.3-6.4-1.3C4.1 1.7 2 1.8.2 2c-.2.1-.3.6 0 .9l1.2.1c1.5.2 1.6.7 1.6 3.6V19c0 3.5-.1 3.9-2 4.2l-.7.1c-.3.1-.2.7 0 .8C1.7 24 3 24 4.4 24c1.3 0 2.5 0 4.4.1.2-.1.2-.7 0-.9l-.9-.1c-2.2-.2-2.2-.7-2.2-4.2V4zm13.2 14.5l4-1.4c.5-.2.6-.5.6-1v-1.5c0-1.2-.4-2.9-2.5-2.9-.9 0-2.1.5-2.1 1.5 0 .5-.1.9-.3 1.1-.5.4-1.4.6-1.9.6-.3 0-.5-.2-.5-.5 0-1.7 3.8-4.1 6.2-4.1 2.4 0 3.6 1.4 3.5 3.9l-.2 5.8c0 1.6.3 3 1.6 3 .3 0 .6-.1.8-.2.2-.1.3-.2.4-.2.1 0 .2.2.2.4s-1.2 1.5-2.8 1.5c-.8 0-1.6-.3-2.2-1-.1-.2-.3-.5-.5-.5s-.6.3-1.3.7c-.7.4-1.5.8-2.4.8-1 0-1.8-.3-2.4-.8-.7-.6-1-1.5-1-2.3 0-1.4.7-2.1 2.8-2.9zm-.2 2.4c0 .6.4 2 2.1 2 .7 0 1.7-.5 2-.8.4-.4.4-.9.4-1.6l.1-2c0-.4-.1-.4-.3-.4-.2 0-.8.1-1.4.3-1.9.7-2.9 1.2-2.9 2.5zm12.4-.7c0 2.4 0 2.7-1.3 2.9l-.6.1c-.2.2-.2.7.1.8 1-.1 2.1-.1 3.1-.1 1.2 0 2.2 0 3.7.1.2-.1.3-.7.1-.8l-1.2-.1c-1.3-.1-1.3-.5-1.3-2.9v-4.6c0-1.1.1-2.1.4-2.6.3-.4.7-.7 1.2-.7s1 .2 1.5.5c.2.1.4.2.7.2.8 0 1.5-.7 1.4-1.5 0-.8-.7-1.3-1.5-1.3-1.2 0-2.5 1-3.7 2-.1 0-.1-.1-.1-.3V10c0-.1-.1-.2-.3-.2-.8.5-2.6 1.4-3.4 1.6-.2.1-.2.5 0 .6l.3.2c.9.6.9.8.9 2.1v5.9zm11.1-1.7l4-1.4c.5-.2.6-.5.6-1v-1.5c0-1.2-.4-2.9-2.5-2.9-.9 0-2.1.5-2.2 1.5 0 .5-.1.9-.3 1.1-.5.4-1.4.6-1.9.6-.3 0-.5-.2-.5-.5 0-1.7 3.8-4.1 6.2-4.1 2.4 0 3.6 1.4 3.5 3.9l-.1 5.9c0 1.5.3 2.9 1.6 2.9.3 0 .6-.1.8-.2.2-.1.3-.2.4-.2.1 0 .2.2.2.4s-1.2 1.5-2.8 1.5c-.8 0-1.6-.3-2.2-1-.1-.2-.3-.5-.5-.5s-.6.3-1.3.7c-.7.4-1.5.8-2.4.8-1 0-1.8-.3-2.4-.8-.7-.6-1-1.5-1-2.3 0-1.4.6-2.1 2.8-2.9zm-.2 2.4c0 .6.4 2 2.1 2 .7 0 1.7-.5 2-.8.4-.4.4-.9.4-1.6l.1-2c0-.4-.1-.4-.3-.4-.2 0-.8.1-1.4.3-1.9.7-2.9 1.2-2.9 2.5zM56.5 4.4v15.9c0 2.4.1 2.8 1.3 2.9l.8.1c.2.2.2.7-.1.8-1-.1-2.1-.1-3.2-.1-1.2 0-2.2 0-3.2.1-.2-.1-.3-.7-.1-.8l.8-.1c1.2-.2 1.2-.6 1.2-3V5.1c0-2 0-2.2-1-2.8l-.3-.2c-.2-.1-.2-.6 0-.7.8-.3 2.4-.8 3.6-1.4.1 0 .3.1.3.2 0 1-.1 2.7-.1 4.2zm7.6 0c0-1.5.1-3.2.1-4.2-.1-.1-.2-.2-.3-.2-1.2.6-2.8 1.1-3.6 1.4-.2.1-.2.6 0 .7l.3.2c1 .6 1 .8 1 2.8v15.2c0 2.4 0 2.8-1.3 2.9l-.8.1c-.2.2-.2.7.1.8 1.1-.1 2.1-.1 3.2-.1 1.2 0 2.2 0 3.3.1.2-.1.3-.7.1-.8l-.8-.1c-1.2-.2-1.3-.5-1.3-2.9V4.4zm6.1 14.1l4-1.4c.5-.2.6-.5.6-1v-1.5c0-1.2-.4-2.9-2.5-2.9-.9 0-2.1.5-2.2 1.5 0 .5-.1.9-.3 1.1-.5.4-1.4.6-1.9.6-.3 0-.5-.2-.5-.5 0-1.7 3.8-4.1 6.2-4.1 2.4 0 3.6 1.4 3.5 3.9l-.1 5.9c-.1 1.5.2 2.9 1.5 2.9.3 0 .6-.1.8-.2.2-.1.3-.2.4-.2.1 0 .2.2.2.4s-1.2 1.5-2.8 1.5c-.8 0-1.6-.3-2.2-1-.1-.2-.3-.5-.5-.5s-.6.3-1.3.7c-.7.4-1.5.8-2.4.8-1 0-1.8-.3-2.4-.8-.7-.6-1-1.5-1-2.3.1-1.4.7-2.1 2.9-2.9zm-.2 2.4c0 .6.4 2 2.1 2 .7 0 1.7-.5 2.1-.8.4-.4.4-.9.4-1.6l.1-2c0-.4-.1-.4-.3-.4-.2 0-.8.1-1.4.3-2 .7-3 1.2-3 2.5zm15-3.6L82 13c-.5-.7-1.1-1.3-2-1.4l-.5-.1c-.2-.2-.2-.7.1-.8 1.3.1 2.1.1 2.9.1.8 0 1.5 0 2.9-.1.2.1.2.7 0 .8l-.5.1c-.9.2-.9.4-.3 1.2l1.6 2.3c.1.2.3.5.4.6.1-.1 1.2-1.8 1.9-2.9.6-.9.5-1-.3-1.2l-.4-.1c-.2-.2-.1-.7.1-.8.8.1 1.6.1 2.5.1.8 0 1.8 0 2.5-.1.3.1.3.7.1.8l-.5.1c-.8.2-1.3.3-1.7.6-.6.5-1.8 2-3.2 3.8-.4.5-.4.6 0 1.2l3.1 4.4c.8 1.1 1.3 1.5 2.2 1.6h.5c.2.2.2.7-.1.8h-3.2c-1.1 0-2.1 0-3.2.1-.3-.1-.3-.7-.1-.8l1-.1c1-.1 1-.4.6-1l-1.7-2.5c-.4-.6-.6-.9-.7-1-.2.3-.4.5-.6.8L84 21.7c-.7 1.1-.7 1.3.1 1.5l.6.1c.2.2.2.7-.1.8-1.6-.1-3.3-.1-4.9 0-.3-.1-.3-.7-.1-.8l.8-.1c.6-.1 1.1-.4 1.7-1 .7-.7 2.2-3 3-3.9.1-.5.2-.6-.1-1zm17.1-14.2c1.3.2 2.1.7 2.1 2.7 0 1.8-.1 4.5-.2 6.8-.2 3.2-.3 6.1-.5 7.7-.2 2.1-.4 2.3-2.1 2.6l-.6.1c-.3.2-.3 1 .1 1.2 1.2-.1 2.5-.1 3.7-.1 1.3 0 2.7 0 4 .1.3-.2.3-.9.1-1.2l-1.3-.2c-1.3-.2-1.5-.7-1.5-2.3 0-2 0-5.4.1-7.5 0-1.7.1-3.2.2-5.4h.1c1.9 4.4 6 12.7 7.3 16.8.2.1.6.2.9.2.3 0 .5-.1.7-.2 2.2-5.7 4.9-11.3 7.4-16.6h.1v3.8l.1 8.7c0 2 0 2.4-1.5 2.6l-1 .1c-.3.2-.3 1 .1 1.2 1.6-.1 3.5-.1 5-.1 1.6 0 3.1 0 4.6.1.3-.1.3-.9.1-1.2l-1.1-.1c-1.3-.2-1.4-1-1.5-2.5-.2-4.2-.3-7.8-.3-14.8 0-1.8.7-2.2 2.1-2.4l1-.2c.3-.3.3-1-.1-1.2-1.2.1-2.8.1-3.9.1-1 0-1.8 0-3.3-.1-.7 2.9-1.6 4.7-3.2 8.1l-1.7 3.7c-.9 2-1.4 3-1.9 3.8-.5-.8-1.7-3-2-3.6L111.6 9c-1.5-3.2-2.7-5.2-2.7-7.3-1.2.1-2.2.1-3.3.1-1.6 0-3.1 0-4.2-.1-.4.1-.4.9-.1 1.2l.8.2zM142.3 15l-.2 4.4c-.1 2.3.8 2.9 1.5 2.9.4 0 .7-.1 1.3-.4.3.1.5.5.4.8-.4.5-2 1.8-3.9 1.8-1.2 0-1.9-.4-2.8-1.2-.2-.2-.4-.3-.5-.3-.2 0-.4.1-.7.4-.6.4-1.6 1.1-2.9 1.1-1.9 0-3.8-1.2-3.8-3.5 0-1.7 1-2.8 3.5-3.5 1.3-.4 2.2-.7 3.2-.9.6-.2.8-.4.8-.7 0-.4.1-.7.1-1.1 0-1.3-.5-2.9-1.9-2.9-.8 0-1.5.5-1.7 1.9-.1.5-.3.8-.6 1.1-.5.4-1.8.8-2.4.8-.6 0-.8-.4-.8-.8 0-.9.8-1.9 1.6-2.6 1.1-.9 3.3-2 5.6-2 2.7-.2 4.4 1.2 4.2 4.7zm-4.3 5.6l.1-2.1c0-.5 0-.6-.2-.6-1.5.2-2.8.8-2.8 2.3 0 1.1.8 2 1.7 2 .9.1 1.1-.5 1.2-1.6zm18.4-9.3h3.9c.2.2.3.5.3.8 0 .5-.2 1.1-.5 1.3h-2.5c.1.3.1.6.1 1.2 0 2.6-1.6 5.9-6.9 5.9-.5 0-1-.1-1.4-.1-.3.1-.6.4-.6.8 0 .7.7 1.2 1.7 1.2 1.1 0 2.5-.1 4.1-.1 2.5 0 5.2.7 5.2 4.1 0 2.1-1.3 4-3 5.1-1.7 1-3.9 1.5-5.9 1.5-4.8 0-6.6-2.2-6.6-4.3 0-.8.5-1.3 1.1-1.7.7-.4 1.3-.8 1.6-1 .4-.2.3-.4 0-.5-1.2-.4-2.1-1.5-2.1-2.7 0-.3.1-.5.2-.7.9-.6 1.9-1.4 2.1-1.6.3-.2.4-.4.3-.7-1.7-.7-2.9-2.3-2.9-4.3 0-2.8 2.2-5.4 6.6-5.4 2.2 0 4 .6 5.2 1.2zm-7.2 3.6c0 2.5 1 4.1 2.3 4.1 1 0 1.9-1 1.9-3.4 0-2.7-1-4-2.2-4-.9 0-2 1-2 3.3zm3.9 11h-2.3c-.9 0-1.6.2-1.9.4-.3.3-.5.7-.5 1.2 0 2.3 1.7 3.8 4.4 3.8 2.1 0 3.5-1 3.5-2.6.1-2.1-1.4-2.8-3.2-2.8zm8.9-5.8v-5c0-1.3 0-1.7-.6-2.1l-.5-.3c-.2-.2-.2-.8 0-1 1.5-.4 3.9-1.3 4.9-2 .3 0 .5.1.6.3-.1.7-.1 1.1-.1 1.4 0 .2.1.3.3.4.9-.6 1.9-1.7 3.3-1.7.9 0 1.8.7 1.8 2 0 1.5-1.1 2.2-2.1 2.2-.5 0-.9-.2-1.3-.6-.8-.6-1.1-.7-1.3-.7-.5 0-.6.7-.6 2v5.1c0 2.3.1 2.6 1.2 2.7l1.1.1c.3.2.3 1 0 1.2-1.6-.1-3-.1-4.5-.1-1.3 0-2.6 0-4 .1-.3-.2-.3-1 0-1.2l.6-.1c1-.1 1.2-.4 1.2-2.7zm16.1-6.2v6.2c0 2.3.1 2.6 1.2 2.8l.6.1c.3.2.3 1 0 1.2-1.3-.1-2.7-.1-4-.1-1.5 0-2.9 0-4 .1-.3-.2-.3-1 0-1.2l.6-.1c1.1-.1 1.2-.4 1.2-2.8V15c0-1.3 0-1.7-.6-2.1l-.5-.3c-.2-.2-.2-.8 0-1 1.6-.4 4-1.3 5-1.9.3 0 .5.1.6.3-.1.9-.1 2.4-.1 3.9zM176 2.5c-1.3 0-2.5 1-2.5 2.4s.9 2.4 2.4 2.4c1.3 0 2.5-.8 2.5-2.4 0-1.3-1-2.4-2.4-2.4zm14.2 9.9h-3c-.4 0-.5 0-.5.8v5c0 1.9 0 4 2.4 4 .5 0 1-.2 1.4-.5.3.1.5.5.5.9-.9 1-2.8 1.9-4.8 1.9-2.8 0-3.8-1.6-3.8-3.8v-7.5c0-.7 0-.8-.6-.8h-1c-.4-.1-.5-.8-.2-1 1-.4 2-1 2.8-1.5.6-.4 1.4-1.1 2.5-2.6.2-.1.8-.1 1 .2V10c0 .6 0 .7.6.7h3c.2.1.3.3.3.6-.1.3-.2.9-.6 1.1zm10.2 0h-3c-.4 0-.5 0-.5.8v5c0 1.9 0 4 2.4 4 .5 0 1-.2 1.4-.5.3.1.5.5.5.9-.9 1-2.8 1.9-4.8 1.9-2.8 0-3.8-1.6-3.8-3.8v-7.5c0-.7 0-.8-.6-.8h-1c-.4-.1-.5-.8-.2-1 1-.4 2-1 2.8-1.5.6-.4 1.4-1.1 2.5-2.6.2-.1.8-.1 1 .2V10c0 .6 0 .7.6.7h3c.2.1.3.3.3.6-.2.3-.3.9-.6 1.1zm12.2 3.6h-6.4c-.8 0-.8.1-.8.6 0 2.5 1.6 5 4.7 5 .9 0 2.2-.2 3.1-1.7.4-.1.8.2.9.6v.1c-1.4 2.9-3.9 3.8-5.9 3.8-4.5 0-7-3.2-7-6.8 0-4.2 3.1-7.5 7.3-7.5 3.5 0 5.4 2.2 5.4 4.8-.1.7-.3 1.1-1.3 1.1zm-5.5-1.4h1.2c.5 0 1-.1 1.4-.3.2-.1.2-.4.2-.8 0-1.1-.6-1.8-1.8-1.8-1.4 0-2.6 1.3-2.6 2.4 0 .4.5.5 1.6.5z\"></path></svg>"

/***/ }),

/***/ "en7K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("nfpj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_039aae36_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("2ZmN");
function injectStyle (ssrContext) {
  __webpack_require__("xZjo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-039aae36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_039aae36_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f2KA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__ = __webpack_require__("Nrlj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91388bae_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__ = __webpack_require__("hNY9");
function injectStyle (ssrContext) {
  __webpack_require__("HW4H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-91388bae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91388bae_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fPBP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectLayout_vue__ = __webpack_require__("jXl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1bfc2e_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectLayout_vue__ = __webpack_require__("1aee");
function injectStyle (ssrContext) {
  __webpack_require__("kCx7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a1bfc2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1bfc2e_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gk9y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('site-title',{attrs:{"text":'Selected Works',"textDelay":0.5}}),_vm._v(" "),_c('text-block',{attrs:{"revealTransition":true}},[_vm._v("Check out some of the works I've done in the last few years.")])],1),_vm._v(" "),_c('work-list',{attrs:{"listType":"all"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hKuE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hN1j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hNY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('hgroup',[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('p',[_vm._v("There's nothing in here.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hbdi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iTUb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'access',
  created: function created() {
    this.$router.push('/');
  }
});

/***/ }),

/***/ "ij/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"site-title",attrs:{"to":{ path: '/'}}},[_c('h1',{ref:"title",style:(_vm.titleStyle)},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jXl0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProjectHeader_vue__ = __webpack_require__("und+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProjectBody_vue__ = __webpack_require__("XwyV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProjectFooter_vue__ = __webpack_require__("KFcL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-layout',
  props: ['projectName'],
  components: {
    'project-header': __WEBPACK_IMPORTED_MODULE_1__components_ProjectHeader_vue__["a" /* default */],
    'project-body': __WEBPACK_IMPORTED_MODULE_2__components_ProjectBody_vue__["a" /* default */],
    'project-footer': __WEBPACK_IMPORTED_MODULE_3__components_ProjectFooter_vue__["a" /* default */]
  },
  data: function data() {
    return {
      projectData: '',
      nextProjectData: ''
    };
  },
  created: function created() {
    var _this = this;

    var thisProjectNumber = 0;
    var nextProjectNumber = 0;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/static/data/works.json').then(function (response) {
      response.data.projects.forEach(function (work) {
        if (work.slug === _this.projectName) {
          _this.projectData = work;
          nextProjectNumber = thisProjectNumber + 1;
        }
        thisProjectNumber++;
      });

      if (response.data.projects[nextProjectNumber]) {
        _this.nextProjectData = response.data.projects[nextProjectNumber];
      } else {
        _this.nextProjectData = response.data.projects[0];
      }
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),

/***/ "kCx7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kD1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Teamable_vue__ = __webpack_require__("3LnL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11f70075_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Teamable_vue__ = __webpack_require__("lyfr");
function injectStyle (ssrContext) {
  __webpack_require__("Y8sc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11f70075"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Teamable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11f70075_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Teamable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kNZs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'zigzag',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "l0Ad":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "loMn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__("+Uzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__script_SplitText__ = __webpack_require__("EyEd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__script_SplitText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__script_SplitText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard__ = __webpack_require__("V33R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_clipboard__);
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'text-block',
  props: {
    revealTransition: {
      type: Boolean,
      default: false
    },
    marginLess: {
      type: Boolean,
      default: false
    },
    quoteType: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (this.revealTransition) {
      this.textSplit();
    }

    var clipboard = new __WEBPACK_IMPORTED_MODULE_2_clipboard___default.a('.clip');

    clipboard.on('success', function (e) {
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });
      tl.to('.clip-message', 0.3, { opacity: 1 });
      tl.to('.clip-message', 0.3, { opacity: 0, delay: 2 });
      tl.restart();
    });
  },

  methods: {
    textSplit: function textSplit() {
      var textSplit = new __WEBPACK_IMPORTED_MODULE_1__script_SplitText___default.a(this.$refs.text, { type: 'lines, words' });

      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });
      tl.set(textSplit.lines, { overflow: 'hidden' }, 0);
      tl.staggerFrom(textSplit.words, 1, { y: 80, ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power3"].easeOut, onComplete: function onComplete() {
          textSplit.revert();
        } }, 0.02, 0.8);
      tl.restart();
    }
  }
});

/***/ }),

/***/ "lyfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("Teamable is a mobile application that allows amateur athletes to easily set up matches and efficiently manage their teams.")]),_vm._v(" "),_c('img',{staticClass:"mw630",attrs:{"src":_vm.imagePath + 'works-teamable-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("Managing an amateur sports team is unnecessarily time-consuming. Every time a team has a game, the manager has to check which members can attend, mostly by texting or making phone calls. Setting up a game isn't easy either.")]),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-teamable-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-teamable-03.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-teamable-04.png',"alt":this.$options.name}})]),_vm._v(" "),_c('p',[_vm._v("Finding a local team to play against is difficult, and the teams use various Meetup-type services to manage their teams, which disperses them over different databases. Teamable is designed to solve these problems and simplify the tasks.")]),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-teamable-05.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-teamable-06.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-teamable-07.png',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Teamable mobile app")]),_vm._v(" "),_c('div',{staticClass:"cols col-3-row-2"},[_c('img',{staticClass:"border circle",attrs:{"src":_vm.imagePath + 'works-teamable-detail-01.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border circle",attrs:{"src":_vm.imagePath + 'works-teamable-detail-02.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border circle",attrs:{"src":_vm.imagePath + 'works-teamable-detail-03.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border circle",attrs:{"src":_vm.imagePath + 'works-teamable-detail-04.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border circle",attrs:{"src":_vm.imagePath + 'works-teamable-detail-05.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border circle",attrs:{"src":_vm.imagePath + 'works-teamable-detail-06.jpg',"alt":this.$options.name}})]),_vm._v(" "),_c('img',{staticClass:"mw280",attrs:{"src":_vm.imagePath + 'works-teamable-09.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("The process of designing Teamable was more iterative than incremental. We have continuosly done testing with couple of amateur football teams, and took the feedbacks from them seriously.")]),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-teamable-10.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-teamable-11.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"border",attrs:{"src":_vm.imagePath + 'works-teamable-12.png',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Earlier version of Teamable app")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-teamable-13.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-teamable-14.jpg',"alt":this.$options.name}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mBR5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vector_vue__ = __webpack_require__("MzWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_260b933a_hasScoped_false_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vector_vue__ = __webpack_require__("r02/");
function injectStyle (ssrContext) {
  __webpack_require__("1Awh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Vector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_260b933a_hasScoped_false_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Vector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mTkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("Parallax Magritte is a web experiment to make the art works of Rene Magritte to be like 3D space, so the viewers can see the unseen part of the original painting by tilting their tablet or smartphone.")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-magritte-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('div',{staticClass:"embed mw960"},[_c('figure',[_c('iframe',{attrs:{"src":"https://player.vimeo.com/video/86180095?color=ffffff&title=0&byline=0&portrait=0","frameborder":"0","webkitAllowFullScreen":"","mozallowfullscreen":"","allowFullScreen":""}})])]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-magritte-07.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v(" To build a 3D space from a plane painting, first I needed to separate each layer of the painting by using Photoshop. The tricky part of this step was filling the empty spots by copying-and-pasting from another similar part of the painting. Some layers of the painting needed to be expanded so they could have some extra space to show when the image is moving.")]),_vm._v(" "),_c('img',{staticClass:"mw730",attrs:{"src":_vm.imagePath + 'works-magritte-03.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"mw730",attrs:{"src":_vm.imagePath + 'works-magritte-04.png',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("Making the separated images into a 3D space using Parallax.js was mostly about sizing and positioning the each layer with CSS, so that each painting could demonstrate the best parallax effect within given boundaries.")]),_vm._v(" "),_c('div',{staticClass:"embed mw960"},[_c('figure',[_c('iframe',{attrs:{"src":"//player.vimeo.com/video/86203133?title=0&byline=0&portrait=0&color=ffffff&autoplay=1&loop=1","frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])]),_vm._v(" "),_c('img',{staticClass:"mw730",attrs:{"src":_vm.imagePath + 'works-magritte-pic-01.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"mw730",attrs:{"src":_vm.imagePath + 'works-magritte-pic-02.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"mw730",attrs:{"src":_vm.imagePath + 'works-magritte-pic-03.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"mw730",attrs:{"src":_vm.imagePath + 'works-magritte-pic-04.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("Built with Parallax.js by Matthew Wagerfield & Claudio Guglieri.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nJIZ":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 81.4 51.4\"><path d=\"M76.2.9h-1.1V.5h2.6v.4h-1.1v2.8h-.4zm1.9-.4h.6l1 2.7 1-2.7h.6v3.2h-.4V1.1l-1 2.6h-.4l-1-2.6v2.6h-.4zM40.3.5H.1v9.1H15v41.8h10.8V9.6h14.8V.5zm8.9 3.2c-3.1 2.4-4.9 6.2-5.5 11.6v1.1H54v-1.1c.3-2.2.9-3.9 1.9-4.9 1.1-1.1 2.7-1.7 4.6-1.7 2 0 3.5.6 4.6 1.7s1.7 2.7 1.7 4.8c0 1.9-.7 3.8-1.9 5.8-1 1.4-3.6 4.2-8 8.2-5.5 5-9.2 9.1-11 12.1-1.8 3.1-3 6.3-3.3 9.8v.3H77v-9.5H58c.5-.7 1-1.5 1.6-2.2.8-.9 2.7-2.7 5.8-5.6 3.1-2.8 5.2-5 6.4-6.5 1.8-2.2 3.1-4.5 3.9-6.5.8-2.1 1.2-4.3 1.2-6.6 0-4.1-1.5-7.5-4.3-10.2C69.7 1.6 65.7.2 60.7.2c-4.6 0-8.5 1.2-11.5 3.5\" class=\"__2TcSWlg__st0 \"></path></svg>"

/***/ }),

/***/ "nVSC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "necw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Olasio_vue__ = __webpack_require__("6xI7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fd5fa0c_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Olasio_vue__ = __webpack_require__("SQqU");
function injectStyle (ssrContext) {
  __webpack_require__("hN1j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fd5fa0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Olasio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fd5fa0c_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Olasio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nfpj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SiteTitle_vue__ = __webpack_require__("RKQU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__ = __webpack_require__("TVmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__("+Uzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about',
  components: {
    'site-title': __WEBPACK_IMPORTED_MODULE_0__components_SiteTitle_vue__["a" /* default */],
    'site-footer': __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__["a" /* default */]
  },
  data: function data() {
    return {
      links: [{
        type: 'linkedin',
        label: 'LinkedIn',
        url: 'https://www.linkedin.com/in/jsonjun'
      }, {
        type: 'codepen',
        label: 'CodePen',
        url: 'https://codepen.io/jsonjun'
      }, {
        type: 'vimeo',
        label: 'Vimeo',
        url: 'https://vimeo.com/jsonjun'
      }, {
        type: 'behance',
        label: 'Behance',
        url: 'https://behance.net/jsonjun'
      }, {
        type: 'twitter',
        label: 'Twitter',
        url: 'https://twitter.com/jsonjun'
      }, {
        type: 'blog',
        label: 'Blog',
        url: 'https://jasonjun.blog'
      }]
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].from(this.$refs.profileImg, 1, { opacity: 0, y: 40, delay: 0.5, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power3"].easeOut });
    __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].from(this.$refs.introCopy, 1, { opacity: 0, y: 40, delay: 0.8, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power3"].easeOut });
    __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].from(this.$refs.links, 1, { opacity: 0, y: 40, delay: 1, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power3"].easeOut });
  }
});

/***/ }),

/***/ "ngXg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rbi-scheduler',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "oVxY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p1oC":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 165 22\"><path d=\"M8.3 14.1l-.8-3.4H3.8l.9 3.4h3.6zm1.3 0l.9-3.4h3.3l-.9 3.4H9.6zm2.4 3.4l-1.1 4.1H6.5l-1-4.1H12zm8-3.4l-.9-3.4h-3.3l.9 3.4H20zm1.4 0l.8-3.4h3.7l-.9 3.4h-3.6zm2.8 3.4l-1 4.1h-4.4l-1.1-4.1h6.5zM6.7 7.2l-.9-3.9h2.5v-3H0v3h2l1 3.9h3.7zm4.7 0L13.2.3h3.2l1.8 6.9H15c-.1-.3-.1-.6-.1-1h-.1s0 .4-.1 1h-3.3zm11.6 0l.9-3.9h-2.5v-3h8.3v3h-2l-1 3.9H23zm8.1 14.4v-2.9h2.6V3.3h-2.5v-3h9.1v3h-2.6v15.4h2.6v2.9h-9.2zm11.6 0v-2.9h2.6V3.3h-2.5v-3h8.5v3h-2v5.8h2.4l4.1-5.8H54v-3h7.8v3h-1.9l-5.1 7.1s.7.3 1.4 1.6l3.3 5.9c.3.5.7.7 1.4.7h1v2.9h-2.7c-1.8 0-2.4-.5-3-1.6l-3.7-7c-.3-.6-.8-.8-1.6-.8h-1.4v6.4H52v2.9l-9.3.2zm20.9 0v-2.9h2.6V3.3h-2.5v-3h9.1v3h-2.6v15.4h2.6v2.9h-9.2zm11.6 0v-2.9h2.6V3.3h-2.6v-3h10.2c1.3 0 2.6.1 3.6.5 2.3 1 3.8 3.3 3.8 6.3s-1.6 5.6-4.1 6.5c-1 .3-2.1.4-3.3.4h-3.8v4.6h2.6v2.9h-9v.1zm6.5-10.7H85c.9 0 1.6-.1 2.2-.4 1.1-.6 1.7-1.8 1.7-3.3 0-1.5-.6-2.6-1.6-3.2-.6-.3-1.3-.5-2.3-.5h-3.3v7.4zm12.9 10.7v-2.9h2.6V3.3h-2.6v-3h9.4c1.6 0 2.8.1 4.1.4 2.4.8 3.9 2.7 3.9 5.7s-1.6 5.1-4 5.9c0 .1.6.4 1.1 1.2l2.5 4.4c.3.5.7.7 1.4.7h.7v2.9h-2.5c-1.8 0-2.3-.4-3-1.6l-3-5.5c-.4-.8-.8-1.1-2.1-1.1h-1.9v5.2h2.5v2.9h-9.1v.2zm6.5-11.3h3.5c2.1 0 3.4-1.2 3.4-3.5 0-1.4-.5-2.5-1.7-2.9-.6-.3-1.4-.4-2.4-.4H101v6.8h.1zm14.4 11.3v-2.9h2.6V3.3h-2.6v-3h9.1v3H122v15.4h2.6v2.9h-9.1zm11.2-10.7c0-6.3 4.8-10.9 11-10.9 2.6 0 8.3.9 8.3 4.3v2.9h-3.6V5.5c0-1.6-2.8-2.1-4.6-2.1-4.1 0-7.1 2.9-7.1 7.4 0 4.8 3.1 7.9 7.3 7.9 1.3 0 4.6-.4 4.6-2.1V15h3.6v2.9c0 3.2-5.5 4.2-8.4 4.2-6.4-.1-11.1-5-11.1-11.2zm22 10.7v-2.9h2.6V3.3h-2.6v-3h15.8v5.5h-3.4V3.5h-6v5.8h7v3.1h-7v6h6.4V16h3.4v5.5l-16.2.1z\"></path></svg>"

/***/ }),

/***/ "r02/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"inline-svg",attrs:{"data-context":_vm.context},domProps:{"innerHTML":_vm._s(_vm.src)}})}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rRYK":
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 226.4 148.7\" style=\"enable-background:new 0 0 226.4 148.7;\" xml:space=\"preserve\"><g><path d=\"M20.5,0c4.2,0,7.4,1,9.8,3.1c2.3,2,3.5,4.8,3.5,8.4c0,2.7-0.6,5-1.8,7s-3.1,3.4-5.8,4.1v0.1c1.3,0.2,2.3,0.7,3.1,1.2 c0.8,0.6,1.4,1.3,1.9,2c0.5,0.8,0.8,1.7,1,2.7s0.4,2,0.5,3.1s0.1,2.1,0.2,3.2c0,1.1,0.1,2.2,0.3,3.2c0.2,1.1,0.4,2.1,0.7,3 c0.3,1,0.8,1.8,1.4,2.5h-6.5c-0.4-0.4-0.7-1.1-0.8-1.8c-0.1-0.8-0.2-1.6-0.3-2.6c0-1-0.1-2-0.1-3.1s-0.2-2.2-0.4-3.2 c-0.2-1.1-0.4-2.1-0.6-3c-0.2-1-0.6-1.8-1.2-2.5c-0.5-0.7-1.2-1.3-2.1-1.7s-2-0.6-3.4-0.6H5.8v18.7H0V0H20.5z M21.7,19.8 c1.2-0.2,2.3-0.6,3.2-1.2c0.9-0.6,1.7-1.4,2.2-2.4c0.6-1,0.8-2.3,0.8-3.9c0-2.2-0.6-4-1.8-5.4s-3.2-2.1-5.9-2.1H5.8V20h12.1 C19.2,20.1,20.5,20,21.7,19.8z\"></path><path d=\"M54,0c0.9,0,1.9,0,3,0s2.2,0.1,3.2,0.2c1.1,0.1,2,0.3,3,0.5c0.9,0.2,1.7,0.5,2.4,0.9c1.4,0.9,2.6,2,3.6,3.5 s1.5,3.4,1.5,5.6c0,2.3-0.6,4.3-1.7,6s-2.7,2.9-4.8,3.8v0.1c2.7,0.6,4.8,1.8,6.2,3.7c1.4,1.9,2.1,4.2,2.1,6.9 c0,1.6-0.3,3.1-0.9,4.7c-0.6,1.5-1.4,2.8-2.5,4s-2.5,2.1-4.2,2.8s-3.6,1.1-5.7,1.1h-21V0H54z M55.6,18.7c3.3,0,5.7-0.6,7.1-1.7 c1.4-1.2,2.2-2.9,2.2-5.2c0-1.5-0.2-2.8-0.7-3.7c-0.5-0.9-1.2-1.6-2-2.1s-1.8-0.8-3-0.9c-1.1-0.1-2.3-0.2-3.6-0.2H44v13.9 L55.6,18.7L55.6,18.7z M58.6,38.8c2.6,0,4.6-0.7,6-2.1c1.4-1.4,2.2-3.3,2.2-5.8c0-1.4-0.3-2.6-0.8-3.6c-0.5-0.9-1.2-1.7-2.1-2.2 c-0.9-0.6-1.9-0.9-3-1.2c-1.1-0.2-2.3-0.3-3.5-0.3H44v15.2H58.6z\"></path><path d=\"M82.5,0v43.7h-5.8V0H82.5z\"></path><path d=\"M18.2,47c2.8,0,5.4,0.4,7.9,1.3c2.4,0.9,4.5,2.2,6.3,4s3.2,4,4.2,6.7s1.5,5.9,1.5,9.5c0,3.2-0.4,6.1-1.2,8.8 c-0.8,2.7-2,5-3.7,7s-3.7,3.5-6.2,4.6c-2.5,1.1-5.4,1.7-8.7,1.7H-0.6V47H18.2z M17.6,82.6c1.4,0,2.7-0.2,4-0.7 c1.3-0.4,2.5-1.2,3.5-2.2s1.8-2.4,2.4-4.1c0.6-1.7,0.9-3.7,0.9-6.1c0-2.2-0.2-4.2-0.6-6c-0.4-1.8-1.1-3.3-2.1-4.6 c-1-1.3-2.3-2.2-3.9-2.9c-1.6-0.7-3.6-1-6-1H8.9v27.5L17.6,82.6L17.6,82.6z\"></path><path d=\"M51.8,100.1c-1.7,1.1-4,1.7-7,1.7c-0.9,0-1.8,0-2.7-0.1c-0.9-0.1-1.8-0.1-2.7-0.2v-7.2c0.8,0.1,1.7,0.2,2.5,0.2 c0.9,0.1,1.7,0.1,2.6,0.1c1.1-0.1,2-0.6,2.5-1.3c0.6-0.8,0.8-1.6,0.8-2.6c0-0.7-0.1-1.3-0.4-2L36.5,59h9.2l7.2,21.7H53L59.9,59h9 L55.7,94.5C54.8,97.2,53.5,99,51.8,100.1z\"></path><path d=\"M76.5,59v4.4h0.2c1.1-1.8,2.5-3.2,4.3-4s3.5-1.3,5.4-1.3c2.3,0,4.2,0.3,5.7,0.9s2.7,1.5,3.5,2.6c0.9,1.1,1.5,2.5,1.8,4.1 c0.3,1.6,0.5,3.4,0.5,5.4v19.5h-8.7V72.8c0-2.6-0.4-4.6-1.2-5.8c-0.8-1.3-2.3-1.9-4.3-1.9c-2.4,0-4.1,0.7-5.1,2.1 c-1.1,1.4-1.6,3.7-1.6,6.9v16.6h-8.7V59H76.5z\"></path><path d=\"M100.5,68.8c0.1-2,0.6-3.7,1.5-5.1c0.9-1.3,2-2.4,3.4-3.2c1.4-0.8,2.9-1.4,4.7-1.7c1.7-0.3,3.5-0.5,5.2-0.5 c1.6,0,3.2,0.1,4.8,0.3c1.6,0.2,3.1,0.7,4.5,1.3c1.3,0.7,2.4,1.6,3.3,2.7c0.9,1.2,1.3,2.7,1.3,4.6v16.5c0,1.4,0.1,2.8,0.2,4.1 c0.2,1.3,0.4,2.3,0.9,2.9h-8.8c-0.2-0.5-0.3-1-0.4-1.5c-0.1-0.5-0.2-1-0.2-1.6c-1.4,1.4-3,2.4-4.9,3c-1.9,0.6-3.8,0.9-5.8,0.9 c-1.5,0-2.9-0.2-4.2-0.6c-1.3-0.4-2.4-0.9-3.4-1.7s-1.7-1.8-2.3-2.9c-0.6-1.2-0.8-2.6-0.8-4.2c0-1.8,0.3-3.3,0.9-4.4 c0.6-1.2,1.4-2.1,2.4-2.8c1-0.7,2.1-1.2,3.4-1.6c1.3-0.3,2.6-0.6,3.9-0.8c1.3-0.2,2.6-0.4,3.9-0.5c1.3-0.1,2.4-0.3,3.4-0.6 c1-0.2,1.8-0.6,2.3-1.1c0.6-0.5,0.8-1.2,0.8-2.1c0-0.9-0.2-1.7-0.5-2.2c-0.3-0.6-0.7-1-1.2-1.3s-1.1-0.5-1.8-0.6 c-0.7-0.1-1.4-0.2-2.2-0.2c-1.7,0-3.1,0.4-4,1.1c-1,0.7-1.6,2-1.7,3.7L100.5,68.8L100.5,68.8z M120.5,75.2 c-0.4,0.3-0.8,0.6-1.4,0.8c-0.6,0.2-1.1,0.3-1.8,0.5c-0.6,0.1-1.3,0.2-2,0.3s-1.4,0.2-2.1,0.3c-0.7,0.1-1.3,0.3-1.9,0.5 c-0.6,0.2-1.2,0.5-1.7,0.8s-0.8,0.8-1.1,1.3s-0.4,1.2-0.4,2s0.1,1.4,0.4,2c0.3,0.5,0.7,0.9,1.2,1.3c0.5,0.3,1.1,0.5,1.7,0.6 c0.7,0.1,1.3,0.2,2,0.2c1.7,0,3-0.3,4-0.9c0.9-0.6,1.6-1.3,2.1-2.1c0.4-0.8,0.7-1.6,0.8-2.4s0.2-1.5,0.2-2V75.2z\"></path><path d=\"M140.7,59v4.3h0.1c1.1-1.6,2.5-2.9,4.1-3.8s3.5-1.3,5.5-1.3s3.8,0.4,5.5,1.2c1.7,0.8,2.9,2.1,3.8,4.1 c0.9-1.4,2.2-2.6,3.8-3.7s3.5-1.6,5.7-1.6c1.7,0,3.2,0.2,4.7,0.6c1.4,0.4,2.7,1.1,3.7,2s1.8,2.1,2.4,3.5c0.6,1.4,0.9,3.2,0.9,5.2 v21.2h-8.7v-18c0-1.1,0-2.1-0.1-3c-0.1-0.9-0.3-1.8-0.7-2.4c-0.4-0.7-0.9-1.2-1.6-1.7c-0.7-0.4-1.7-0.6-2.9-0.6 c-1.2,0-2.2,0.2-3,0.7c-0.8,0.5-1.3,1.1-1.8,1.8c-0.4,0.8-0.7,1.6-0.9,2.6c-0.1,1-0.2,1.9-0.2,2.9v17.6h-8.6V72.9 c0-0.9,0-1.9-0.1-2.8c0-0.9-0.2-1.8-0.5-2.5c-0.3-0.8-0.8-1.4-1.5-1.9c-0.7-0.5-1.8-0.7-3.2-0.7c-0.4,0-0.9,0.1-1.6,0.3 c-0.7,0.2-1.3,0.5-2,1c-0.6,0.5-1.2,1.2-1.6,2.2s-0.7,2.2-0.7,3.8v18.4h-8.7V59H140.7z\"></path><path d=\"M184.3,54.1v-7.2h8.7v7.2H184.3z M193,59v31.6h-8.7V59H193z\"></path><path d=\"M211.3,64.7c-1.4,0-2.5,0.3-3.5,0.9c-0.9,0.6-1.7,1.4-2.3,2.4s-1,2.1-1.3,3.3c-0.2,1.2-0.4,2.4-0.4,3.6 c0,1.1,0.1,2.3,0.4,3.5c0.2,1.2,0.6,2.3,1.2,3.2c0.6,1,1.3,1.7,2.2,2.4c0.9,0.6,2.1,0.9,3.4,0.9c2.1,0,3.7-0.6,4.8-1.7 c1.1-1.2,1.8-2.7,2.1-4.7h8.4c-0.6,4.2-2.2,7.4-4.9,9.6c-2.7,2.2-6.1,3.3-10.3,3.3c-2.4,0-4.5-0.4-6.5-1.2s-3.7-1.9-5-3.3 c-1.4-1.4-2.5-3.1-3.2-5.1c-0.8-2-1.2-4.2-1.2-6.5c0-2.4,0.4-4.7,1.1-6.8s1.8-3.9,3.2-5.4c1.4-1.5,3.1-2.7,5.1-3.6s4.3-1.3,6.9-1.3 c1.9,0,3.7,0.2,5.4,0.7c1.7,0.5,3.3,1.2,4.7,2.2s2.5,2.2,3.3,3.7c0.9,1.5,1.3,3.3,1.5,5.3h-8.5C217.1,66.5,215,64.7,211.3,64.7z\"></path><path d=\"M23,94c2,0,3.7,0.3,5.3,0.9c1.6,0.6,2.9,1.5,4,2.6c1.1,1.1,2,2.4,2.6,3.8c0.6,1.4,0.9,3,0.9,4.7c0,2.6-0.5,4.8-1.6,6.7 s-2.8,3.3-5.3,4.3v0.1c1.2,0.3,2.2,0.8,2.9,1.5c0.8,0.7,1.4,1.5,1.9,2.4s0.8,1.9,1.1,3c0.2,1.1,0.4,2.2,0.5,3.3 c0,0.7,0.1,1.5,0.1,2.4s0.1,1.9,0.2,2.9c0.1,1,0.3,1.9,0.5,2.8c0.2,0.9,0.6,1.6,1,2.2h-9.7c-0.5-1.4-0.9-3-1-5 c-0.1-1.9-0.3-3.8-0.6-5.5c-0.3-2.3-1-4-2.1-5c-1.1-1.1-2.8-1.6-5.2-1.6H8.9v17.1h-9.5V93.9H23V94z M19.5,113.8 c2.2,0,3.9-0.5,5-1.5s1.7-2.6,1.7-4.8c0-2.1-0.6-3.7-1.7-4.6c-1.1-0.9-2.8-1.4-5-1.4H9v12.3H19.5z\"></path><path d=\"M48.3,130.1c1.3,1.3,3.2,1.9,5.6,1.9c1.8,0,3.3-0.4,4.5-1.3c1.3-0.9,2-1.8,2.3-2.8h7.7c-1.2,3.8-3.1,6.5-5.6,8.1 s-5.6,2.4-9.2,2.4c-2.5,0-4.7-0.4-6.7-1.2s-3.7-1.9-5.1-3.4s-2.5-3.2-3.2-5.3c-0.8-2-1.1-4.3-1.1-6.7s0.4-4.6,1.2-6.6 s1.9-3.8,3.3-5.3s3.1-2.7,5.1-3.5c2-0.9,4.2-1.3,6.6-1.3c2.7,0,5,0.5,7,1.6c2,1,3.6,2.4,4.9,4.2s2.2,3.8,2.8,6 c0.6,2.2,0.8,4.6,0.6,7H46.1C46.3,126.8,47,128.8,48.3,130.1z M58.1,113.5c-1-1.1-2.6-1.7-4.7-1.7c-1.4,0-2.5,0.2-3.5,0.7 c-0.9,0.5-1.7,1.1-2.2,1.7c-0.6,0.7-0.9,1.4-1.2,2.2c-0.2,0.8-0.4,1.5-0.4,2.1h14.1C59.9,116.3,59.2,114.6,58.1,113.5z\"></path><path d=\"M78.7,106.1v4h0.1c1.1-1.7,2.4-3,4-3.7c1.6-0.8,3.4-1.2,5.4-1.2c2.5,0,4.6,0.5,6.4,1.4c1.8,0.9,3.3,2.2,4.5,3.7 c1.2,1.6,2.1,3.4,2.6,5.4c0.6,2.1,0.9,4.2,0.9,6.5c0,2.1-0.3,4.2-0.9,6.1c-0.6,2-1.4,3.7-2.6,5.2s-2.6,2.7-4.3,3.6 c-1.7,0.9-3.8,1.3-6.1,1.3c-2,0-3.8-0.4-5.4-1.2c-1.7-0.8-3-2-4.1-3.5h-0.1v15h-8.7V106L78.7,106.1L78.7,106.1z M90,131.1 c1-0.6,1.7-1.3,2.3-2.2c0.6-0.9,1-2,1.3-3.2c0.2-1.2,0.4-2.5,0.4-3.7c0-1.3-0.1-2.5-0.4-3.7s-0.7-2.3-1.3-3.3 c-0.6-1-1.4-1.7-2.4-2.3s-2.1-0.9-3.5-0.9s-2.6,0.3-3.6,0.9c-1,0.6-1.7,1.4-2.3,2.3c-0.6,0.9-1,2-1.3,3.2c-0.2,1.2-0.4,2.5-0.4,3.8 s0.1,2.5,0.4,3.7s0.7,2.3,1.3,3.2c0.6,0.9,1.4,1.7,2.4,2.2c1,0.6,2.2,0.9,3.5,0.9C87.8,132,89,131.7,90,131.1z\"></path><path d=\"M104.3,115c0.8-2.1,1.9-3.8,3.3-5.3c1.4-1.4,3.1-2.6,5.1-3.4s4.2-1.2,6.7-1.2s4.7,0.4,6.8,1.2c2,0.8,3.7,1.9,5.2,3.4 c1.4,1.4,2.5,3.2,3.3,5.3c0.8,2.1,1.2,4.4,1.2,6.9s-0.4,4.8-1.2,6.9c-0.8,2-1.9,3.8-3.3,5.2c-1.4,1.4-3.2,2.6-5.2,3.3 c-2,0.8-4.3,1.2-6.8,1.2s-4.7-0.4-6.7-1.2s-3.7-1.9-5.1-3.3c-1.4-1.4-2.5-3.2-3.3-5.2s-1.2-4.3-1.2-6.9S103.6,117.1,104.3,115z M112.2,125.6c0.2,1.2,0.7,2.3,1.3,3.2c0.6,1,1.4,1.7,2.4,2.3s2.2,0.9,3.7,0.9s2.7-0.3,3.7-0.9c1-0.6,1.8-1.3,2.4-2.3 c0.6-1,1-2,1.3-3.2c0.2-1.2,0.4-2.4,0.4-3.7s-0.1-2.5-0.4-3.7c-0.2-1.2-0.7-2.3-1.3-3.2s-1.4-1.7-2.4-2.3s-2.2-0.9-3.7-0.9 s-2.7,0.3-3.7,0.9c-1,0.6-1.8,1.4-2.4,2.3c-0.6,0.9-1,2-1.3,3.2c-0.2,1.2-0.4,2.5-0.4,3.7S112,124.4,112.2,125.6z\"></path><path d=\"M146.1,106.1v5.9h0.1c0.4-1,1-1.9,1.7-2.7c0.7-0.8,1.5-1.5,2.4-2.1c0.9-0.6,1.9-1,2.9-1.4c1-0.3,2.1-0.5,3.2-0.5 c0.6,0,1.2,0.1,1.9,0.3v8.1c-0.4-0.1-0.9-0.2-1.5-0.2c-0.6-0.1-1.1-0.1-1.7-0.1c-1.6,0-2.9,0.3-4,0.8s-2,1.3-2.7,2.2 c-0.7,0.9-1.2,2-1.4,3.2c-0.3,1.2-0.4,2.5-0.4,4v14.3h-8.7v-31.6h8.2V106.1z\"></path><path d=\"M160.3,106.1v-9.5h8.7v9.5h6.4v5.8H169v15.7c0,1.5,0.2,2.4,0.7,2.9s1.5,0.7,2.9,0.7c0.5,0,1,0,1.4-0.1 c0.4,0,0.9-0.1,1.3-0.2v6.7c-0.7,0.1-1.6,0.2-2.4,0.2c-0.9,0-1.8,0.1-2.6,0.1c-1.3,0-2.6-0.1-3.8-0.3c-1.2-0.2-2.3-0.5-3.2-1.1 c-0.9-0.5-1.6-1.3-2.2-2.3c-0.6-1-0.8-2.3-0.8-3.9v-18.7\"></path></g></svg>"

/***/ }),

/***/ "s0Au":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tPgL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rbi-website',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "u4mn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uMhA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ugqt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transcope',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "ulLA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidenav_vue__ = __webpack_require__("Lvoq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53531710_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidenav_vue__ = __webpack_require__("3dfe");
function injectStyle (ssrContext) {
  __webpack_require__("wZ4v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53531710"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidenav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53531710_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidenav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "und+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectHeader_vue__ = __webpack_require__("JnOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5243bcfc_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectHeader_vue__ = __webpack_require__("4LVk");
function injectStyle (ssrContext) {
  __webpack_require__("KvrH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5243bcfc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5243bcfc_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vRXY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wG1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RbiEmails_vue__ = __webpack_require__("R0MY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d280971e_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RbiEmails_vue__ = __webpack_require__("z4fC");
function injectStyle (ssrContext) {
  __webpack_require__("DcGR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d280971e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RbiEmails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d280971e_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RbiEmails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wKsR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'work-list-item',
  props: ['itemSlug', 'itemColor'],
  data: function data() {
    return {
      itemHover: false
    };
  }
});

/***/ }),

/***/ "wZ4v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wdOw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("Collision: The Dark War is a fake movie trailer made by editing 20 different movies. The scenes and sounds are mostly excerpted from the movie trailers downloaded from HD-Trailers(hd-trailers.net), and the background music is Mind Heist by Zack Hemsey (music.zackhemsey.com/album/mind-heist).")]),_vm._v(" "),_c('div',{staticClass:"embed"},[_c('figure',[_c('iframe',{attrs:{"src":"https://player.vimeo.com/video/97084600?color=ffffff&title=0&byline=0&portrait=0","width":"1140","height":"641","frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "woY9":
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 176.7 150.1\" style=\"enable-background:new 0 0 176.7 150.1;\" xml:space=\"preserve\"><style type=\"text/css\"> .__3a1f4oe__st0{fill-rule:evenodd;clip-rule:evenodd;} </style><g><path d=\"M20.5,0c4.2,0,7.4,1,9.8,3.1c2.3,2,3.5,4.8,3.5,8.4c0,2.7-0.6,5-1.8,7s-3.1,3.4-5.8,4.1v0.1c1.3,0.2,2.3,0.7,3.1,1.2 c0.8,0.6,1.4,1.3,1.9,2c0.5,0.8,0.8,1.7,1,2.7s0.4,2,0.5,3.1s0.1,2.1,0.2,3.2c0,1.1,0.1,2.2,0.3,3.2c0.2,1.1,0.4,2.1,0.7,3 c0.3,1,0.8,1.8,1.4,2.5h-6.5c-0.4-0.4-0.7-1.1-0.8-1.8c-0.1-0.8-0.2-1.6-0.3-2.6c0-1-0.1-2-0.1-3.1s-0.2-2.2-0.4-3.2 c-0.2-1.1-0.4-2.1-0.6-3c-0.2-1-0.6-1.8-1.2-2.5c-0.5-0.7-1.2-1.3-2.1-1.7s-2-0.6-3.4-0.6H5.8v18.7H0V0H20.5z M21.7,19.8 c1.2-0.2,2.3-0.6,3.2-1.2c0.9-0.6,1.7-1.4,2.2-2.4c0.6-1,0.8-2.3,0.8-3.9c0-2.2-0.6-4-1.8-5.4s-3.2-2.1-5.9-2.1H5.8V20h12.1 C19.2,20.1,20.5,20,21.7,19.8z\"></path><path d=\"M54,0c0.9,0,1.9,0,3,0s2.2,0.1,3.2,0.2c1.1,0.1,2,0.3,3,0.5c0.9,0.2,1.7,0.5,2.4,0.9c1.4,0.9,2.6,2,3.6,3.5 s1.5,3.4,1.5,5.6c0,2.3-0.6,4.3-1.7,6s-2.7,2.9-4.8,3.8v0.1c2.7,0.6,4.8,1.8,6.2,3.7c1.4,1.9,2.1,4.2,2.1,6.9 c0,1.6-0.3,3.1-0.9,4.7c-0.6,1.5-1.4,2.8-2.5,4s-2.5,2.1-4.2,2.8s-3.6,1.1-5.7,1.1h-21V0H54z M55.6,18.7c3.3,0,5.7-0.6,7.1-1.7 c1.4-1.2,2.2-2.9,2.2-5.2c0-1.5-0.2-2.8-0.7-3.7S63,6.5,62.2,6s-1.8-0.8-3-0.9c-1.1-0.1-2.3-0.2-3.6-0.2H44v13.9L55.6,18.7 L55.6,18.7z M58.6,38.8c2.6,0,4.6-0.7,6-2.1c1.4-1.4,2.2-3.3,2.2-5.8c0-1.4-0.3-2.6-0.8-3.6c-0.5-0.9-1.2-1.7-2.1-2.2 c-0.9-0.6-1.9-0.9-3-1.2c-1.1-0.2-2.3-0.3-3.5-0.3H44v15.2H58.6z\"></path><path d=\"M82.5,0v43.7h-5.8V0H82.5z\"></path></g><path id=\"Email-Design\" class=\"__3a1f4oe__st0 \" d=\"M0,47.7h32.6v8.1h-23v9.3h21.1v7.4H9.6v10.7h23.5v8.1H0V47.7z M35.3,59.7h8.2V64h0.1 c1.1-1.6,2.5-2.9,4.1-3.8c1.6-0.9,3.4-1.3,5.5-1.3c2,0,3.8,0.4,5.5,1.2c1.6,0.8,2.9,2.1,3.8,4.1c0.9-1.4,2.2-2.6,3.8-3.7 s3.5-1.6,5.7-1.6c1.7,0,3.2,0.2,4.6,0.6c1.4,0.4,2.6,1.1,3.7,2c1,0.9,1.8,2.1,2.4,3.5c0.6,1.4,0.9,3.2,0.9,5.2v21.1h-8.7V73.4 c0-1.1,0-2.1-0.1-3c-0.1-0.9-0.3-1.7-0.7-2.4c-0.4-0.7-0.9-1.2-1.6-1.6s-1.7-0.6-2.9-0.6c-1.2,0-2.2,0.2-3,0.7 c-0.8,0.5-1.3,1.1-1.8,1.8c-0.4,0.8-0.7,1.6-0.9,2.6s-0.2,1.9-0.2,2.9v17.6H55V73.5c0-0.9,0-1.9-0.1-2.8c0-0.9-0.2-1.8-0.5-2.5 c-0.3-0.8-0.8-1.4-1.5-1.9c-0.7-0.5-1.8-0.7-3.1-0.7c-0.4,0-0.9,0.1-1.6,0.3c-0.7,0.2-1.3,0.5-2,1c-0.6,0.5-1.2,1.2-1.6,2.2 s-0.7,2.2-0.7,3.8v18.3h-8.7V59.7z M86.3,69.4c0.1-2,0.6-3.7,1.5-5.1c0.9-1.3,2-2.4,3.4-3.2c1.4-0.8,2.9-1.4,4.7-1.7 s3.5-0.5,5.2-0.5c1.6,0,3.2,0.1,4.8,0.3c1.6,0.2,3.1,0.7,4.5,1.3c1.3,0.7,2.4,1.6,3.3,2.7c0.9,1.2,1.3,2.7,1.3,4.6v16.4 c0,1.4,0.1,2.8,0.2,4.1c0.2,1.3,0.4,2.3,0.9,2.9h-8.8c-0.2-0.5-0.3-1-0.4-1.5c-0.1-0.5-0.2-1-0.2-1.6c-1.4,1.4-3,2.4-4.9,3 S98,92,96.1,92c-1.5,0-2.9-0.2-4.2-0.5c-1.3-0.4-2.4-0.9-3.4-1.7c-1-0.8-1.7-1.7-2.3-2.9c-0.5-1.2-0.8-2.6-0.8-4.2 c0-1.8,0.3-3.3,0.9-4.4c0.6-1.2,1.4-2.1,2.4-2.8c1-0.7,2.1-1.2,3.4-1.6c1.3-0.3,2.6-0.6,3.9-0.8c1.3-0.2,2.6-0.4,3.8-0.5 s2.4-0.3,3.4-0.5c1-0.2,1.7-0.6,2.3-1.1s0.8-1.1,0.8-2c0-0.9-0.2-1.7-0.5-2.2s-0.7-1-1.2-1.3c-0.5-0.3-1.1-0.5-1.8-0.6 c-0.7-0.1-1.4-0.2-2.2-0.2c-1.7,0-3,0.4-4,1.1s-1.5,2-1.7,3.7H86.3z M106.3,75.8c-0.4,0.3-0.8,0.6-1.4,0.8c-0.5,0.2-1.1,0.3-1.8,0.5 c-0.6,0.1-1.3,0.2-2,0.3c-0.7,0.1-1.4,0.2-2.1,0.3c-0.7,0.1-1.3,0.3-1.9,0.5c-0.6,0.2-1.2,0.5-1.6,0.8c-0.5,0.3-0.8,0.8-1.1,1.3 c-0.3,0.5-0.4,1.2-0.4,2c0,0.8,0.1,1.4,0.4,2s0.7,0.9,1.2,1.3c0.5,0.3,1.1,0.5,1.7,0.6c0.7,0.1,1.3,0.2,2,0.2c1.7,0,3-0.3,4-0.9 c0.9-0.6,1.6-1.3,2.1-2c0.4-0.8,0.7-1.6,0.8-2.4c0.1-0.8,0.2-1.5,0.2-2V75.8z M127,54.8h-8.7v-7.1h8.7V54.8z M118.3,59.7h8.7v31.5 h-8.7V59.7z M130.5,47.7h8.7v43.6h-8.7V47.7z M9.6,130.2h8.5c1.4,0,2.7-0.2,4-0.7c1.3-0.4,2.5-1.2,3.5-2.2c1-1,1.8-2.4,2.4-4.1 c0.6-1.7,0.9-3.7,0.9-6.1c0-2.2-0.2-4.2-0.6-5.9c-0.4-1.8-1.1-3.3-2.1-4.5c-1-1.3-2.3-2.2-3.9-2.9c-1.6-0.7-3.6-1-5.9-1H9.6V130.2z M0,94.7h18.8c2.8,0,5.4,0.4,7.8,1.3c2.4,0.9,4.5,2.2,6.3,4c1.8,1.8,3.2,4,4.1,6.7s1.5,5.8,1.5,9.5c0,3.2-0.4,6.1-1.2,8.8 c-0.8,2.7-2,5-3.7,7c-1.6,2-3.7,3.5-6.2,4.6c-2.5,1.1-5.4,1.7-8.7,1.7H0V94.7z M61.9,119.1c-0.4-2.2-1.1-3.9-2.2-5s-2.6-1.7-4.7-1.7 c-1.4,0-2.5,0.2-3.4,0.7c-0.9,0.5-1.6,1-2.2,1.7c-0.5,0.7-0.9,1.4-1.2,2.2c-0.2,0.8-0.4,1.5-0.4,2.1H61.9z M47.8,124.6 c0.1,2.8,0.8,4.8,2.1,6.1c1.3,1.3,3.2,1.9,5.6,1.9c1.7,0,3.3-0.4,4.5-1.3c1.3-0.9,2-1.8,2.3-2.8H70c-1.2,3.8-3.1,6.5-5.6,8.1 s-5.6,2.4-9.2,2.4c-2.5,0-4.7-0.4-6.7-1.2s-3.7-1.9-5.1-3.4s-2.5-3.2-3.2-5.2c-0.8-2-1.1-4.3-1.1-6.7c0-2.4,0.4-4.6,1.2-6.6 c0.8-2,1.9-3.8,3.3-5.3c1.4-1.5,3.1-2.7,5.1-3.5s4.2-1.3,6.6-1.3c2.7,0,5,0.5,7,1.6c2,1,3.6,2.4,4.9,4.2c1.3,1.7,2.2,3.7,2.8,6 s0.8,4.6,0.6,7H47.8z M78.8,128c0,0.9,0.2,1.7,0.6,2.4c0.4,0.7,0.9,1.2,1.5,1.6c0.6,0.4,1.3,0.7,2.1,0.9c0.8,0.2,1.6,0.3,2.5,0.3 c0.6,0,1.3-0.1,1.9-0.2s1.3-0.4,1.8-0.7s1-0.7,1.4-1.2s0.5-1.1,0.5-1.9c0-1.3-0.9-2.3-2.6-2.9c-1.7-0.7-4.1-1.3-7.2-2 c-1.3-0.3-2.5-0.6-3.7-1c-1.2-0.4-2.3-0.9-3.2-1.5c-0.9-0.6-1.7-1.4-2.3-2.4s-0.9-2.1-0.9-3.5c0-2,0.4-3.7,1.2-5 c0.8-1.3,1.8-2.3,3.1-3.1c1.3-0.8,2.8-1.3,4.4-1.6c1.6-0.3,3.3-0.5,5-0.5s3.4,0.2,5,0.5c1.6,0.3,3,0.9,4.3,1.6 c1.3,0.8,2.3,1.8,3.1,3.1s1.3,2.9,1.5,4.8h-8.2c-0.1-1.7-0.8-2.8-1.9-3.4s-2.5-0.9-4-0.9c-0.5,0-1,0-1.6,0.1 c-0.6,0.1-1.1,0.2-1.6,0.4c-0.5,0.2-0.9,0.5-1.2,0.9c-0.3,0.4-0.5,0.9-0.5,1.6c0,0.8,0.3,1.4,0.9,1.9s1.3,0.9,2.2,1.2 c0.9,0.3,2,0.6,3.1,0.8c1.2,0.2,2.4,0.5,3.6,0.8c1.3,0.3,2.5,0.6,3.7,1c1.2,0.4,2.3,0.9,3.2,1.6c0.9,0.7,1.7,1.5,2.3,2.5 s0.9,2.2,0.9,3.7c0,2.1-0.4,3.8-1.3,5.2c-0.8,1.4-1.9,2.5-3.3,3.4c-1.3,0.9-2.9,1.5-4.6,1.8c-1.7,0.3-3.5,0.5-5.3,0.5 c-1.8,0-3.6-0.2-5.4-0.5c-1.7-0.4-3.3-1-4.7-1.8c-1.4-0.9-2.5-2-3.4-3.4c-0.9-1.4-1.4-3.2-1.4-5.3H78.8z M110.2,101.8h-8.7v-7.1h8.7 V101.8z M101.5,106.7h8.7v31.5h-8.7V106.7z M128.1,130.8c1.2,0,2.3-0.2,3.2-0.7c0.9-0.5,1.7-1.1,2.3-2c0.6-0.8,1.1-1.7,1.4-2.8 c0.3-1,0.5-2.1,0.5-3.3c0-1.3-0.1-2.5-0.4-3.7c-0.2-1.2-0.7-2.2-1.2-3.1c-0.6-0.9-1.3-1.6-2.3-2.1s-2.1-0.8-3.5-0.8 c-1.2,0-2.3,0.2-3.1,0.7c-0.9,0.5-1.6,1.1-2.2,2s-1,1.8-1.3,2.9c-0.3,1.1-0.4,2.2-0.4,3.4c0,1.1,0.1,2.3,0.3,3.4 c0.2,1.1,0.6,2.1,1.2,3c0.5,0.9,1.3,1.6,2.2,2.2C125.6,130.5,126.8,130.8,128.1,130.8z M143.7,136.2c0,1.3-0.2,2.7-0.5,4.3 c-0.3,1.6-1.1,3.1-2.2,4.5c-1.1,1.4-2.8,2.6-4.9,3.6s-5,1.5-8.7,1.5c-1.5,0-3.1-0.2-4.7-0.6c-1.6-0.4-3.1-1-4.4-1.8 c-1.3-0.8-2.4-1.9-3.3-3.1s-1.4-2.8-1.5-4.6h8.6c0.4,1.6,1.2,2.8,2.4,3.4c1.2,0.6,2.5,0.9,4.1,0.9c2.4,0,4.2-0.7,5.3-2.2 c1.1-1.5,1.7-3.3,1.6-5.6v-4.1h-0.1c-0.9,1.7-2.3,2.9-4,3.7c-1.7,0.8-3.5,1.2-5.5,1.2c-2.4,0-4.4-0.4-6.1-1.3 c-1.7-0.8-3.1-2-4.2-3.4c-1.1-1.4-1.9-3.1-2.4-5.1c-0.5-1.9-0.8-4-0.8-6.1c0-2,0.3-4,0.9-5.9c0.6-1.9,1.5-3.6,2.6-5 c1.1-1.4,2.6-2.6,4.2-3.4s3.6-1.3,5.8-1.3c2.1,0,3.9,0.4,5.5,1.2c1.6,0.8,2.9,2.1,3.9,3.9h0.1v-4.2h8.2V136.2z M147.1,106.7h8.2v4.4 h0.2c1.1-1.8,2.5-3.2,4.3-4s3.5-1.3,5.4-1.3c2.3,0,4.2,0.3,5.7,0.9c1.5,0.6,2.7,1.5,3.5,2.6s1.5,2.5,1.8,4.1 c0.3,1.6,0.5,3.4,0.5,5.3v19.4H168v-17.8c0-2.6-0.4-4.5-1.2-5.8s-2.3-1.9-4.3-1.9c-2.4,0-4.1,0.7-5.1,2.1c-1.1,1.4-1.6,3.7-1.6,6.9 v16.5h-8.7V106.7z\"></path></svg>"

/***/ }),

/***/ "x0EL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Sidenav_vue__ = __webpack_require__("ulLA");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'sidenav': __WEBPACK_IMPORTED_MODULE_0__components_Sidenav_vue__["a" /* default */]
  },
  created: function created() {
    var routePath = this.$route.path;
    var accessPath = routePath.slice(-7);
    var actualPath = routePath.slice(0, -7);

    if (accessPath === '/access') {
      this.$store.commit('accessGrant');
      this.$router.push(actualPath);
    }
  }
});

/***/ }),

/***/ "xRSM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__ = __webpack_require__("fPBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__ = __webpack_require__("5Evu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rbi-report',
  components: {
    'project-layout': __WEBPACK_IMPORTED_MODULE_0__layouts_ProjectLayout_vue__["a" /* default */]
  },
  data: function data() {
    return {
      imagePath: '',
      videoPath: ''
    };
  },
  created: function created() {
    this.imagePath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().imagePath + this.$options.name + '/';
    this.videoPath = __WEBPACK_IMPORTED_MODULE_1__components_DataPath_vue__["a" /* default */].data().videoPath + this.$options.name + '/';
  }
});

/***/ }),

/***/ "xW9d":
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 253.9 70.2\" style=\"enable-background:new 0 0 253.9 70.2;\" xml:space=\"preserve\"><g><path d=\"M33.4,54V17.6C33.4,6.4,27.5,0,16.7,0S0,6.4,0,17.6V54c0,8.1,3.1,13.7,8.9,16.2c6.5-1,13.1-2,19.9-2.9 C31.8,64.3,33.4,59.8,33.4,54z M16.7,61.6c-3.5,0-5.7-1.9-5.7-6.9V16.9c0-5,2.2-6.9,5.7-6.9s5.7,1.9,5.7,6.9v37.8 C22.4,59.7,20.2,61.6,16.7,61.6z\"></path><path d=\"M79.6,60.8H61.5v-60h-11v64c9.5-0.9,19.3-1.7,29.1-2.3V60.8z\"></path><path d=\"M110.2,13l7.2,48.2c3.3,0,6.5-0.1,9.8-0.1c0.4,0,0.8,0,1.2,0l-9.6-60.2h-16.1l-9.8,61c3.3-0.1,6.7-0.3,10.1-0.4L110.2,13z\"></path><path d=\"M176.2,54c0-20-21.5-22.7-21.5-37.1c0-5,2-6.9,5.5-6.9s5.5,1.9,5.5,6.9v2.9h10.4v-2.2c0-11.2-5.5-17.6-16.2-17.6 s-16.2,6.4-16.2,17.6c0,20,21.5,22.7,21.5,37.1c0,5-2.2,6.8-5.7,6.8s-5.7-1.8-5.7-6.8v-5h-10.4V54c0,2.7,0.3,5.1,1,7.2 c10.3,0.2,20.4,0.6,30.4,1.2C175.7,60.1,176.2,57.3,176.2,54z\"></path><path d=\"M203.4,0.8h-11v62.9c3.7,0.3,7.4,0.6,11,1V0.8z\"></path><path d=\"M253.9,54V17.6C253.9,6.4,248,0,237.2,0s-16.7,6.4-16.7,17.6V54c0,5.7,1.6,10.2,4.5,13.2c6.8,0.9,13.5,1.9,20.1,2.9 C250.9,67.6,253.9,62.1,253.9,54z M237.2,61.6c-3.5,0-5.7-1.9-5.7-6.9V16.9c0-5,2.2-6.9,5.7-6.9s5.7,1.9,5.7,6.9v37.8 C242.9,59.7,240.7,61.6,237.2,61.6z\"></path></g></svg>"

/***/ }),

/***/ "xZjo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xolb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Access_vue__ = __webpack_require__("iTUb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_199474aa_hasScoped_false_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Access_vue__ = __webpack_require__("nVSC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Access_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_199474aa_hasScoped_false_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Access_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yLFQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkListItem_vue__ = __webpack_require__("wKsR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8aa1d6_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkListItem_vue__ = __webpack_require__("AMUS");
function injectStyle (ssrContext) {
  __webpack_require__("oVxY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a8aa1d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8aa1d6_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yc4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeaTwo_vue__ = __webpack_require__("AUWW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a2e3acc_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeaTwo_vue__ = __webpack_require__("aY1u");
function injectStyle (ssrContext) {
  __webpack_require__("s0Au")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a2e3acc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TeaTwo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a2e3acc_hasScoped_true_transformToRequire_video_src_source_src_vector_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TeaTwo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yuix":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('site-title',{attrs:{"textDelay":0.5}}),_vm._v(" "),_c('text-block',{attrs:{"revealTransition":true,"marginLess":true}},[_vm._v("I’m a UI designer and front-end developer based in Melbourne, Australia.")])],1),_vm._v(" "),_c('featured-grid'),_vm._v(" "),_c('text-block',[_vm._v("I love and am good at creating digital solutions for complicated problems.")]),_vm._v(" "),_c('work-list',{attrs:{"listType":"latest"}}),_vm._v(" "),_c('text-block',[_c('div',[_vm._v("Please contact me via "),_c('u',{staticClass:"clip",attrs:{"data-clipboard-text":"uxd.jun@gmail.com"}},[_vm._v("email")]),_vm._v(" or "),_c('a',{attrs:{"href":"https://www.linkedin.com/in/jsonjun/","target":"_blank"}},[_vm._v("LinkedIn")]),_vm._v(".")]),_vm._v(" "),_c('em',{staticClass:"clip-message"},[_vm._v("uxd.jun@gmail.com has been copied to clipboard.")])]),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z4fC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("Email design is often considered to be easier than webpage design because of its usualy simplicity, but it can be even trickier when you're trying to do it right. There are so many limitations when it comes to email development, thus the design also has many constraints.\n  "),_c('br'),_c('br'),_vm._v("Many companies use email as the main communication channel with their customers. However, keeping email designs consistent can be challenging, especially when new emails are created by multiple departments, each for specific reasons.")]),_vm._v(" "),_c('img',{staticClass:"shadow mw600",attrs:{"src":_vm.imagePath + 'works-rbi-emails-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Re-designed email")]),_vm._v(" "),_c('p',[_vm._v("RedBook Inspect has many email templates with minor differences, so redesigning one-by-one was not the optimal way. First, we collected all the existing emails and put them on a whiteboard to see their flow.")]),_vm._v(" "),_c('div',{staticClass:"cols col-2-row-2"},[_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-emails-board-01.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-emails-board-02.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-emails-board-03.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-emails-board-04.jpg',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Whiteboard session")]),_vm._v(" "),_c('p',[_vm._v("After the whiteboard session, I wanted to set up a digital space to continue the discussion. After some research, I found Milanote, which is a planning tool for creative projects, having many features we could use to replace the whiteboard.")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-emails-mila-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Overall email flow")]),_vm._v(" "),_c('div',{staticClass:"cols col-2"},[_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-emails-mila-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-emails-mila-03.png',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Detailed email flow")]),_vm._v(" "),_c('p',[_vm._v("After the team finished the discussion on the email flow and everyone was on the same page, I started redesigning the emails with Sketch. There were many repeated sections throughout the emails, so I chose to design each component and create pages by compositing the repetitive components.")]),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-emails-05.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-emails-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-emails-03.png',"alt":this.$options.name}})]),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-emails-07.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-emails-06.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-emails-04.png',"alt":this.$options.name}})]),_vm._v(" "),_c('p',[_vm._v("Email development is infamous for still using 1990's coding styles, but there are many helpful tools these days that make email development much easier and more straightforward.\n  "),_c('br'),_c('br'),_vm._v("My choice of tools was Foundation for Emails. It had the Sass version that we wanted, and also has great documentation.")]),_vm._v(" "),_c('img',{staticClass:"mw800 shadow",attrs:{"src":_vm.imagePath + 'works-rbi-emails-code-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Email code example")]),_vm._v(" "),_c('img',{staticClass:"mw800 shadow",attrs:{"src":_vm.imagePath + 'works-rbi-emails-code-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Responsive gutter and spacer")]),_vm._v(" "),_c('p',[_vm._v("I've spent quite a bit of effort making the actual emails look exactly the same as my initial design because the overall quality is always determined by the smallest things.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zUDM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.theListType === 'latest')?_c('small',[_vm._v("Latest works")]):_vm._e(),_vm._v(" "),_c('ul',{ref:"latestList",staticClass:"latest-items"},_vm._l((_vm.items),function(item){return _c('li',{key:item.slug,class:item.slug},[_c('work-list-item',{attrs:{"itemSlug":item.slug,"itemColor":item.projectColor}}),_vm._v(" "),_c('div',[_c('h4',[_vm._v(_vm._s(item.subject))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.year)+" • "+_vm._s(item.participation))])])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zai1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'project-footer',
  props: ['nextSlug', 'nextBgColor'],
  computed: {
    nextProjectStyle: function nextProjectStyle() {
      return 'background-color: ' + this.nextBgColor;
    }
  },
  mounted: function mounted() {
    this.$refs.contentFooter.classList.add('loaded');
  }
});

/***/ }),

/***/ "zegB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'data-path',
  data: function data() {
    return {
      imagePath: '/static/image/works/',
      videoPath: '/static/video/works/'
    };
  }
});

/***/ }),

/***/ "zoQ1":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 163.9 50.4\"><path d=\"M4.8.1c1.2 0 2.2.4 3 1.2.8.8 1.2 1.8 1.2 3v3.2H6.9V4.3c0-.6-.2-1.1-.6-1.6S5.4 2 4.8 2h-.4c-.6 0-1.1.2-1.5.6s-.6.9-.6 1.5v23.6c0 .6.2 1.1.6 1.5s.9.6 1.5.6h.4c.6 0 1.1-.2 1.5-.7s.6-1 .6-1.6v-3.6H9v3.7c0 1.2-.4 2.2-1.2 3-.8.8-1.8 1.2-3 1.2h-.4c-1.2 0-2.2-.4-3-1.3-.8-.8-1.3-1.8-1.3-3V4.3c0-1.2.4-2.2 1.3-3C2.2.5 3.2 0 4.4 0l.4.1zm16.4 27.5V4.4c0-1.2.4-2.2 1.3-3 .8-.8 1.8-1.3 3-1.3h.4c1.2 0 2.2.4 3 1.3.8.8 1.2 1.8 1.2 3v23.2c0 1.2-.4 2.2-1.2 3-.8.8-1.8 1.2-3 1.2h-.4c-1.2 0-2.2-.4-3-1.2-.8-.8-1.3-1.8-1.3-3zm6.9-23.2c0-.6-.2-1.2-.6-1.6-.4-.5-.9-.7-1.5-.7h-.4c-.6 0-1.1.2-1.5.6s-.6.9-.6 1.5v23.5c0 .6.2 1.1.6 1.5s.9.6 1.5.6h.4c.6 0 1.1-.2 1.5-.7s.6-1 .6-1.6V4.4zM42.4.5h2.1v29.1h7.3v1.9h-9.4V.5zm20.1 0h2.1v29.1h7.3v1.9h-9.4V.5zm20.2 31V.4h2.2v31.1h-2.2zM101.9.1c1.2 0 2.2.4 3 1.3.8.8 1.3 1.8 1.3 3v3.2H104V4.4c0-.6-.2-1.1-.6-1.6-.4-.5-.9-.7-1.5-.7h-.4c-.6 0-1.1.2-1.5.6s-.6.9-.6 1.5v2.7c0 1.1.2 2 .5 2.8s1.4 2.7 3.3 5.6c1.4 2.2 2.2 3.8 2.5 4.8s.5 2.3.5 3.9v3.7c0 1.2-.4 2.2-1.3 3-.8.8-1.8 1.3-3 1.3h-.6c-1.2 0-2.2-.4-3-1.2-.8-.8-1.3-1.8-1.3-3v-3.7h2.2v3.6c0 .6.2 1.1.6 1.6.4.5.9.7 1.5.7h.6c.6 0 1.1-.2 1.5-.6s.6-.9.6-1.5v-4.3c0-1.9-.4-3.5-1.3-4.9-.8-1.4-1.6-2.6-2.2-3.6-.6-.9-1.2-2-2-3.4-.8-1.3-1.2-2.5-1.3-3.6-.1-.6-.1-1.1-.1-1.7v-2c0-1.2.4-2.2 1.3-3.1.8-.8 1.9-1.3 3.1-1.3h.4v.1zm16.4 31.4V.4h2.2v31.1h-2.2zm14.3-3.9V4.4c0-1.2.4-2.2 1.3-3 .8-.8 1.8-1.3 3-1.3h.4c1.2 0 2.2.4 3 1.3.8.8 1.2 1.8 1.2 3v23.2c0 1.2-.4 2.2-1.2 3s-1.8 1.2-3 1.2h-.4c-1.2 0-2.2-.4-3-1.2-.9-.8-1.3-1.8-1.3-3zm6.8-23.2c0-.6-.2-1.2-.6-1.6-.4-.5-.9-.7-1.5-.7h-.4c-.6 0-1.1.2-1.5.6s-.6.9-.6 1.5v23.5c0 .6.2 1.1.6 1.5.4.4.9.6 1.5.6h.4c.6 0 1.1-.2 1.5-.7s.6-1 .6-1.6V4.4zM161.5.5h2.2v31.1h-2.5l-5.3-24.7v24.7h-2.1V.5h2.6l5.3 24.7V.5h-.2zM52.8 42.8h3.7v1.1h-1.2v6.5h-1.2v-6.5h-1.2l-.1-1.1zm6.3 7.5h-1.2v-7.5h1.2V46h1.3v-3.2h1.2v7.5h-1.2v-3.2h-1.3v3.2zm5.6-4.3h1.6v1.1h-1.6v2.2h2v1.1h-3.2v-7.5h3.2V44h-2v2zm6.4-3.2H73c1.2 0 1.8.7 1.8 1.9v3.8c0 1.2-.6 1.9-1.8 1.9h-1.9v-7.6zm1.1 1.1v5.4h.7c.4 0 .6-.2.6-.7v-3.9c0-.5-.2-.7-.6-.7l-.7-.1zm8 6.4H79l-.2-1.4h-1.5l-.2 1.4H76l1.2-7.5h1.7l1.3 7.5zm-2.7-2.4h1.1l-.6-3.8-.5 3.8zm6.7 2.4c-.1-.2-.1-.3-.1-.9v-1.2c0-.7-.2-1-.8-1h-.4v3.1h-1.2v-7.5h1.8c1.2 0 1.8.6 1.8 1.7v.6c0 .8-.2 1.3-.8 1.5.6.2.8.8.8 1.6v1.2c0 .4 0 .6.1.9h-1.2zm-1.3-6.4v2.3h.5c.4 0 .7-.2.7-.8v-.7c0-.5-.2-.8-.6-.8h-.6zm5.7 3.4l-.4.7v2.3H87v-7.5h1.2v3.3l1.6-3.3H91l-1.6 3.4 1.6 4.2h-1.2l-1.2-3.1zm9.2-1l-.4 4h-1.6l-.8-7.5h1.2l.6 5.9.6-5.9h1.1l.6 6 .6-6h1l-.8 7.5h-1.6l-.5-4zm8 4h-1.2l-.2-1.4h-1.5l-.2 1.4h-1.1l1.2-7.5h1.7l1.3 7.5zm-2.7-2.4h1.1l-.6-3.8-.5 3.8zm6.7 2.4c-.1-.2-.1-.3-.1-.9v-1.2c0-.7-.2-1-.8-1h-.4v3.1h-1.2v-7.5h1.8c1.2 0 1.8.6 1.8 1.7v.6c0 .8-.2 1.3-.8 1.5.6.2.8.8.8 1.6v1.2c0 .4 0 .6.1.9h-1.2zm-1.3-6.4v2.3h.5c.4 0 .7-.2.7-.8v-.7c0-.5-.2-.8-.6-.8h-.6zM.1 46.2h50.3v1H.1zm113.6 0h50v1h-50z\" class=\"__FHedCak__st0 \"></path></svg>"

/***/ }),

/***/ "zz8+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-layout',{attrs:{"projectName":this.$options.name}},[_c('p',[_vm._v("RedBook Inspect is a vehicle inspection service by Carsales. They provide an inspection service, not only to individual customers, but to car dealers and finance companies. Also, a big part of the business is roadworthy inspection for drivers of ride-share services such as Uber, Ola and Didi.\n  "),_c('br'),_c('br'),_vm._v("One of my main projects at the RedBook Inspect team was to redesign its website. I was given enough flexibility in terms of brand and style constraints, and that was very helpful for me to think more freely without worrying too much about boundaries.")]),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-00.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-01.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('p',[_vm._v("Although consistency is very important in interface design, I don't think the same design in different contexts is consistent, and that's the main reason I choose to separate the marketing side of interface design from the actual product's interface styles. Thus, more sets of typography and colours are used on this website, compared to the dynamic report.")]),_vm._v(" "),_c('div',{staticClass:"cols col-2-row-2"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-02.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-04.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-05.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-03.jpg',"alt":this.$options.name}})]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-website-responsive.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Responsive modules")]),_vm._v(" "),_c('div',{staticClass:"cols col-2"},[_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-website-nav-01.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-website-nav-02.jpg',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Navigation")]),_vm._v(" "),_c('img',{staticClass:"mw600 shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-items.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Interaction states")]),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-forms-01.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-forms-02.jpg',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-forms-03.jpg',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Forms")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.imagePath + 'works-rbi-website-map.png',"alt":this.$options.name}}),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Sitemap")]),_vm._v(" "),_c('div',{staticClass:"cols col-3"},[_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-wf-01.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-wf-02.png',"alt":this.$options.name}}),_vm._v(" "),_c('img',{staticClass:"shadow",attrs:{"src":_vm.imagePath + 'works-rbi-website-wf-03.png',"alt":this.$options.name}})]),_vm._v(" "),_c('em',{staticClass:"desc"},[_vm._v("Wireframes in early stage")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7f5e335d6404a5d101f6.js